
function $parcel$import(url) {
  url = parcelRequire.i?.[url] || url;
  return import($parcel$distDir + url);
}

function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequireefef"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequireefef"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("9R3dw", function(module, exports) {
module.exports = JSON.parse('{"about.about.attr.aria.label.our.principles":"Our principles","about.about.h3.private.by.default":"Private by default","about.about.h3.transparent.by.design":"Transparent by design","about.about.h3.you.stay.in.control":"You stay in control","about.about.heading.h2.most.ai.begins.by.asking.for.your.data":"Most AI begins by asking for your data. <slot1>We begin by asking</slot1> <slot2>where it should stay.</slot2>","about.about.p.brand.builds.custom.ai.powered.solutions.using.custom":"{algorithmicNetwork} builds custom AI-powered solutions, using custom models or fine-tuning where your project needs them. We keep sensitive information on your devices or inside infrastructure you control wherever we can, and when a hosted model is the better tool, we connect it carefully. Your team gets the benefits of AI without needless exposure.","about.about.p.clear.permissions.useful.feedback.and.human.review.for":"Clear permissions, useful feedback and human review for the actions that matter. People stay in charge of their information and their decisions.","about.about.p.our.point.of.view":"Our point of view","about.about.p.we.design.around.clear.data.boundaries.and.limited":"We design around clear data boundaries and limited collection. Your privacy requirements decide where information is processed and how the system is run.","about.about.p.we.explain.capabilities.data.flows.and.limitations.in":"We explain capabilities, data flows and limitations in plain language, so the people using a system understand what it does and why.","app.development.a.skip.to.main.content":"Skip to main content","app.development.attr.content.ai.product.and.custom.model.development.fine.tuning":"AI product and custom model development, fine-tuning, assistants and knowledge systems for local, private and hosted environments.","app.development.cta.heading.h2.let.s.build.something.extraordinary":"Let\u2019s build something <slot1>extraordinary.</slot1>","app.development.expertise.h4.ai.product.interfaces":"AI product interfaces","app.development.expertise.h4.cloud.ai.integration":"Cloud AI integration","app.development.expertise.h4.local.ai.applications":"Local AI applications","app.development.expertise.h4.private.knowledge.systems":"Private knowledge systems","app.development.expertise.heading.h2.our.development.expertise":"Our development <slot1>expertise.</slot1>","app.development.expertise.li.answers.with.sources":"Answers with sources","app.development.expertise.li.cost.control":"Cost control","app.development.expertise.li.data.minimisation":"Data minimisation","app.development.expertise.li.desktop.and.mobile.apps":"Desktop and mobile apps","app.development.expertise.li.document.search":"Document search","app.development.expertise.li.offline.assistants":"Offline assistants","app.development.expertise.li.on.device.vision":"On device vision","app.development.expertise.li.provider.selection":"Provider selection","app.development.expertise.li.review.steps":"Review steps","app.development.expertise.li.source.permissions":"Source permissions","app.development.expertise.li.system.integrations":"System integrations","app.development.expertise.li.workflow.tools":"Workflow tools","app.development.expertise.p.clear.interfaces.and.integrations.that.make.ai.a":"Clear interfaces and integrations that make AI a useful part of everyday work, with people in control of important actions.","app.development.expertise.p.focused.applications.that.run.intelligence.on.your.devices":"Focused applications that run intelligence on your devices. We evaluate the models, hardware and workflow around the task you want to improve.","app.development.expertise.p.from.focused.assistants.to.custom.model.development.fine":"From focused assistants to custom model development, fine-tuning and complete products, built around your people, data and deployment needs.","app.development.expertise.p.search.and.assistance.over.your.own.documents.and":"Search and assistance over your own documents and business information, with source permissions, references and deliberate data boundaries.","app.development.expertise.p.what.we.build":"What we build","app.development.expertise.p.when.local.is.not.enough.we.integrate.hosted":"When local is not enough, we integrate hosted models with minimal data sharing, clear provider terms and the same review steps.","app.development.faq.a.ask.us.directly":"<slot1>Ask us directly</slot1><slot2></slot2>","app.development.faq.heading.h2.before.you.start.building":"Before you <slot1>start building.</slot1>","app.development.faq.p.after.discovery.we.agree.on.scope.deliverables.and":"After discovery we agree on scope, deliverables and evaluation criteria. A focused prototype can test the important assumptions before a larger development commitment.","app.development.faq.p.common.questions.about.how.we.plan.build.and":"Common questions about how we plan, build and support AI products.","app.development.faq.p.documentation.handover.and.support.are.agreed.as.part":"Documentation, handover and support are agreed as part of the engagement. The operating plan covers maintenance, model behaviour, access controls and costs.","app.development.faq.p.questions":"Questions","app.development.faq.p.we.define.the.use.case.and.data.flow":"We define the use case and data flow, then assess local execution or a private environment. The choice depends on the task, the hardware, access requirements and the quality the system needs to achieve.","app.development.faq.p.yes.we.develop.custom.models.and.fine.tune":"Yes. We develop custom models and fine-tune existing ones around an agreed task and dataset. The work includes data preparation, training or adaptation, evaluation on separate test examples and deployment planning. We compare results with a baseline so you can judge the benefit.","app.development.faq.p.yes.we.examine.the.existing.workflow.available.interfaces":"Yes. We examine the existing workflow, available interfaces and access permissions, and aim for a focused integration with clear ownership and useful behaviour.","app.development.faq.p.yes.when.a.hosted.model.is.the.better":"Yes. When a hosted model is the better fit for quality, scale or cost, we integrate it carefully: we limit what is shared, mask sensitive details where possible and choose providers with clear data terms.","app.development.faq.summary.can.you.develop.a.custom.model.or.fine":"Can you develop a custom model or fine-tune an existing one?<slot1></slot1>","app.development.faq.summary.can.you.work.with.our.existing.software":"Can you work with our existing software?<slot1></slot1>","app.development.faq.summary.do.you.also.build.with.hosted.ai":"Do you also build with hosted AI?<slot1></slot1>","app.development.faq.summary.how.do.you.approach.local.and.private.ai":"How do you approach local and private AI?<slot1></slot1>","app.development.faq.summary.how.do.you.plan.a.project":"How do you plan a project?<slot1></slot1>","app.development.faq.summary.what.happens.after.deployment":"What happens after deployment?<slot1></slot1>","app.development.main.content.a.email.us":"Email us","app.development.main.content.attr.alt.brand":"{langChain}","app.development.main.content.attr.alt.brand.2":"{langGraph}","app.development.main.content.attr.alt.brand.3":"{python}","app.development.main.content.attr.alt.brand.4":"{fastApi}","app.development.main.content.attr.alt.brand.5":"{docker}","app.development.main.content.attr.aria.label.ai.tools.and.technologies":"AI tools and technologies","app.development.main.content.button.let.s.talk":"Let\u2019s talk <slot1></slot1>","app.development.main.content.div.you.get.a.clear.scope.and.success.criteria":"<slot1>You get</slot1><slot2>A clear scope and success criteria</slot2>","app.development.main.content.div.you.get.a.live.system.with.a.clear":"<slot1>You get</slot1><slot2>A live system with a clear owner</slot2>","app.development.main.content.div.you.get.a.tested.design.and.architecture":"<slot1>You get</slot1><slot2>A tested design and architecture</slot2>","app.development.main.content.div.you.get.working.software.measured.on.your.tasks":"<slot1>You get</slot1><slot2>Working software, measured on your tasks</slot2>","app.development.main.content.h1.build.launch.innovate":"<slot1>Build, Launch,</slot1> <slot2>Innovate<slot3>.</slot3></slot2>","app.development.main.content.h3.deploy":"Deploy","app.development.main.content.h3.design":"Design","app.development.main.content.h3.develop":"Develop","app.development.main.content.h3.discover":"Discover","app.development.main.content.li.brand":"<slot1></slot1><slot2>{huggingFace}</slot2>","app.development.main.content.li.brand.10":"<slot1></slot1><slot2>{onnx}</slot2>","app.development.main.content.li.brand.11":"<slot1></slot1><slot2>{mlflow}</slot2>","app.development.main.content.li.brand.12":"<slot1></slot1><slot2>{anthropic}</slot2>","app.development.main.content.li.brand.2":"<slot1></slot1><slot2>{typeSafeAi}</slot2>","app.development.main.content.li.brand.3":"<slot1></slot1><slot2>{ollama}</slot2>","app.development.main.content.li.brand.4":"<slot1></slot1><slot2>{pytorch}</slot2>","app.development.main.content.li.brand.5":"<slot1></slot1><slot2>{fastai}</slot2>","app.development.main.content.li.brand.6":"<slot1></slot1><slot2>{tensorFlow}</slot2>","app.development.main.content.li.brand.7":"<slot1></slot1><slot2>{keras}</slot2>","app.development.main.content.li.brand.8":"<slot1></slot1><slot2>{scikitLearn}</slot2>","app.development.main.content.li.brand.9":"<slot1></slot1><slot2>{weightsAndBiases}</slot2>","app.development.main.content.p.define.the.use.case.information.requirements.and.outcome":"Define the use case, information requirements and outcome before choosing a model.","app.development.main.content.p.design.the.workflow.data.boundaries.and.interface.around":"Design the workflow, data boundaries and interface around the people using the system.","app.development.main.content.p.develop.or.fine.tune.models.where.the.task":"Develop or fine-tune models where the task calls for it, and evaluate the product on separate test examples, including cases where it should fail safely.","app.development.main.content.p.four.stages.each.ending.with.something.you.can":"Four stages, each ending with something you can see and test before the next begins.","app.development.main.content.p.methodology":"Methodology","app.development.main.content.p.our.philosophy":"Our philosophy","app.development.main.content.p.prepare.the.deployment.documentation.and.ongoing.review.of":"Prepare the deployment, documentation and ongoing review of quality and operating costs.","app.development.main.content.p.technology":"Technology","app.development.main.content.p.tell.us.about.the.workflow.you.want.to":"Tell us about the workflow you want to improve and the information that needs to stay private. We can begin with a focused conversation.","app.development.main.content.p.we.choose.ai.tools.for.the.task.from":"We choose AI tools for the task, from custom model training and fine-tuning to orchestration and local inference, with a practical stack for the application around them.","app.development.main.content.p.we.start.with.local.execution.and.private.environments":"We start with local execution and private environments, and integrate hosted models when they serve the work better. Either way you get software that is measured on your real tasks, easy to operate and clear about its limits.","app.development.metadata.title.ai.product.development.brand":"AI Product Development | {algorithmicNetwork}","app.development.method.heading.h2.a.proven.path.to.working.software":"A proven path to <slot1>working software.</slot1>","app.development.philosophy.heading.h2.we.build.purposeful.ai.products.around.your.work":"We build <slot1>purposeful AI products</slot1> around your work, with privacy considered from the start.","app.development.tech.heading.h2.tools.chosen.for.each.job":"Tools chosen for <slot1>each job.</slot1>","contact.contact.div.touch":"Touch","contact.contact.h3.book.a.session":"Book a Session","contact.contact.h3.direct.contact":"Direct Contact","contact.contact.h4.ai.consultation":"AI Consultation","contact.contact.h4.ai.project.review":"AI Project Review","contact.contact.h4.development.planning":"Development Planning","contact.contact.h4.email.address":"Email Address","contact.contact.h4.response.time":"Response Time","contact.contact.heading.h2.get.in.touch.get.in.touch":"<slot1> <slot2>Get in</slot2> <slot3>Touch</slot3> </slot1>  <slot4>Get in <slot5>Touch</slot5></slot4>","contact.contact.p.30.min.models.fine.tuning.and.deployment":"30 min \u2022 Models, fine-tuning and deployment","contact.contact.p.45.min.workflow.and.model.review":"30 min \u2022 Workflow and model review","contact.contact.p.60.min.scope.approach.and.next.steps":"30 min \u2022 Scope, approach and next steps","contact.contact.p.by.scheduling.a.meeting.you.agree.to.our":"By scheduling a meeting, you agree to our <slot1>privacy policy</slot1>. We respect your privacy and will only use your information to schedule and conduct the meeting.","contact.contact.p.for.general.inquiries.feel.free.to.reach.out":"For general inquiries, feel free to reach out directly.","contact.contact.p.ready.to.start.a.project.or.just.want":"Ready to start a project or just want to chat? We\'d love to hear from you. Select a contact method below that best suits your needs.","contact.contact.p.the.fastest.way.to.get.a.detailed.response":"The fastest way to get a detailed response. Choose a time that works for you.","contact.contact.p.usually.within.48.hours":"Usually within 48 hours","cookie.policy.attr.content.brand.s.cookie.policy.we.respect.your.privacy":"{algorithmicNetwork}\'s Cookie Policy - We respect your privacy and don\'t use tracking cookies.","cookie.policy.contact.h3.contact.us":"Contact Us","cookie.policy.contact.p.if.you.have.any.questions.or.concerns.about":"If you have any questions or concerns about our cookie policy, please don\'t hesitate to contact us at <slot1>{privacyEmail}</slot1>.","cookie.policy.essential.cookies.h3.essential.cookies":"Essential cookies","cookie.policy.essential.cookies.p.we.may.use.essential.cookies.that.are.strictly":"We may use essential cookies that are strictly necessary for the website to function properly. These cookies do not track you, collect your personal information, or remember where you\'ve been on the internet.","cookie.policy.main.content.div.cookies":"COOKIES","cookie.policy.main.content.h1.cookie.policy":"Cookie Policy","cookie.policy.main.content.p.last.updated.may.18.2025":"Last updated: May 18, 2025","cookie.policy.main.content.p.we.believe.in.a.web.where.you.can":"We believe in a web where you can browse without being watched. This policy outlines our cookie practices.","cookie.policy.metadata.title.cookie.policy.brand":"Cookie Policy - {algorithmicNetwork}","cookie.policy.our.approach.h3.our.approach":"Our approach","cookie.policy.our.approach.p.at.brand.we.ve.made.a.conscious.decision":"At {algorithmicNetwork}, we\'ve made a conscious decision not to use tracking cookies or similar technologies that collect personal data. We believe your browsing experience should be private and secure.","cookie.policy.our.policy.h3.we.love.cookies.but.the.real.ones":"We love cookies, but the real ones!","cookie.policy.our.policy.p.we.believe.in.maintaining.transparency.and.trust.with":"We believe in maintaining transparency and trust with our users. Rest assured that your browsing experience on our site is completely anonymous and secure. You can explore our content without any concerns about your privacy being compromised.","cookie.policy.our.policy.p.we.value.your.privacy.and.are.committed.to":"We value your privacy and are committed to protecting it. As part of our commitment, we want to assure you that our website does not use any tracking cookies or collect any personal information from our visitors.","cookie.policy.our.policy.p.wondering.why.you.didn.t.see.any.annoying":"Wondering why you didn\'t see any annoying cookie banners? At {algorithmicNetwork}, we\'re committed to protecting your privacy and being transparent about how our website operates.","cookie.policy.privacy.nav.h2.on.this.page":"On this page","cookie.policy.privacy.nav.li.contact.us":"<slot1>Contact Us</slot1>","cookie.policy.privacy.nav.li.essential.cookies":"<slot1>Essential Cookies</slot1>","cookie.policy.privacy.nav.li.our.approach":"<slot1>Our Approach</slot1>","cookie.policy.privacy.nav.li.our.policy":"<slot1>Our Policy</slot1>","cookie.policy.privacy.nav.li.what.are.cookies":"<slot1>What are Cookies?</slot1>","cookie.policy.what.are.cookies.h3.what.are.cookies":"What are cookies?","cookie.policy.what.are.cookies.p.cookies.are.small.text.files.that.are.stored":"Cookies are small text files that are stored on your device when you visit a website. They are widely used to make websites work more efficiently and provide information to the website owners.","deployment.deploy.diagram.title.compact.metadata.title.your.data.the.model.and.your.team.sit":"Your data, the model and your team sit inside your boundary. Outside services are used only when you choose them.","deployment.deploy.diagram.title.metadata.title.your.data.the.model.and.your.team.sit":"Your data, the model and your team sit inside your boundary. Outside services are used only when you choose them.","deployment.deploy.heading.h2.local.first.cloud.when.it.helps":"Local first. <slot1>Cloud when it helps.</slot1>","deployment.deploy.hosted.title.compact.metadata.title.an.agreed.request.goes.from.your.systems.to":"An agreed request goes from your systems to a model running with a hosted provider. The response returns to your team for review.","deployment.deploy.hosted.title.metadata.title.your.data.and.your.team.remain.in.your":"Your data and your team remain in your systems. Safeguards prepare an agreed request for a model running with a hosted provider. Its response returns for review.","deployment.deploy.panel.dd.assistants.and.tools.that.work.offline.on.laptops":"Assistants and tools that work offline on laptops, phones and point of sale machines.","deployment.deploy.panel.dd.prompts.documents.and.results.never.leave.the.device":"Prompts, documents and results never leave the device.","deployment.deploy.panel.dt.best.for":"Best for","deployment.deploy.panel.dt.what.stays.inside":"What stays inside","deployment.deploy.panel.text.ai.model":"AI model","deployment.deploy.panel.text.documents.and.records":"Documents and records","deployment.deploy.panel.text.hosted.ai.model":"Hosted AI model","deployment.deploy.panel.text.hosted.provider":"Hosted provider","deployment.deploy.panel.text.limit.shared.input":"Limit shared input","deployment.deploy.panel.text.not.required":"Not required","deployment.deploy.panel.text.public.ai":"Public AI","deployment.deploy.panel.text.reviews.and.decides":"Reviews and decides","deployment.deploy.panel.text.reviews.the.response":"Reviews the response","deployment.deploy.panel.text.runs.on.the.device":"Runs on the device","deployment.deploy.panel.text.runs.with.provider":"Runs with provider","deployment.deploy.panel.text.safeguards":"Safeguards","deployment.deploy.panel.text.your.data":"Your data","deployment.deploy.panel.text.your.device":"Your device","deployment.deploy.panel.text.your.systems":"Your systems","deployment.deploy.panel.text.your.team":"Your team","deployment.deploy.tab.cloud.attr.best.workloads.that.need.to.scale.in.a.cloud":"Workloads that need to scale, in a cloud account and region you choose.","deployment.deploy.tab.cloud.attr.inside.data.stays.in.your.account.protected.by.your":"Data stays in your account, protected by your keys and permissions.","deployment.deploy.tab.cloud.attr.label.your.cloud.account":"Your cloud account","deployment.deploy.tab.cloud.attr.model.runs.in.your.region":"Runs in your region","deployment.deploy.tab.cloud.attr.outside.public.ai":"Public AI","deployment.deploy.tab.cloud.attr.outside.sub.not.required":"Not required","deployment.deploy.tab.cloud.button.private.cloud.your.account.your.region":"<slot1><slot2></slot2></slot1> <slot3><slot4>Private cloud</slot4><slot5>Your account, your region</slot5></slot3> <slot6></slot6>","deployment.deploy.tab.device.attr.best.assistants.and.tools.that.work.offline.on.laptops":"Assistants and tools that work offline on laptops, phones and point of sale machines.","deployment.deploy.tab.device.attr.inside.prompts.documents.and.results.never.leave.the.device":"Prompts, documents and results never leave the device.","deployment.deploy.tab.device.attr.label.your.device":"Your device","deployment.deploy.tab.device.attr.model.runs.on.the.device":"Runs on the device","deployment.deploy.tab.device.attr.outside.public.ai":"Public AI","deployment.deploy.tab.device.attr.outside.sub.not.required":"Not required","deployment.deploy.tab.device.button.on.device.laptops.phones.and.workstations":"<slot1><slot2></slot2></slot1> <slot3><slot4>On device</slot4><slot5>Laptops, phones and workstations</slot5></slot3> <slot6></slot6>","deployment.deploy.tab.hosted.attr.best.tasks.that.need.the.largest.models.broad.knowledge":"Tasks that need the largest models, broad knowledge or scale beyond your own hardware.","deployment.deploy.tab.hosted.attr.inside.source.records.stay.under.your.control.only.the":"Source records stay under your control. Only the input you approve is sent to the hosted provider; its response returns to your team for review.","deployment.deploy.tab.hosted.attr.label.your.systems":"Your systems","deployment.deploy.tab.hosted.attr.model.local.where.it.can.be":"Local where it can be","deployment.deploy.tab.hosted.attr.outside.hosted.ai":"Hosted AI","deployment.deploy.tab.hosted.attr.outside.sub.only.what.is.needed":"Only what is needed","deployment.deploy.tab.hosted.button.hosted.ai.trusted.cloud.models.with.safeguards":"<slot1><slot2></slot2></slot1> <slot3><slot4>Hosted AI</slot4><slot5>Trusted cloud models, with safeguards</slot5></slot3> <slot6></slot6>","deployment.deploy.tab.premises.attr.best.teams.that.want.shared.ai.on.hardware.they":"Teams that want shared AI on hardware they already own, inside their own network.","deployment.deploy.tab.premises.attr.inside.models.data.and.logs.stay.on.your.network":"Models, data and logs stay on your network, under your access rules.","deployment.deploy.tab.premises.attr.label.your.servers":"Your servers","deployment.deploy.tab.premises.attr.model.runs.on.your.hardware":"Runs on your hardware","deployment.deploy.tab.premises.attr.outside.public.ai":"Public AI","deployment.deploy.tab.premises.attr.outside.sub.not.required":"Not required","deployment.deploy.tab.premises.button.on.premises.servers.inside.your.own.network":"<slot1><slot2></slot2></slot1> <slot3><slot4>On premises</slot4><slot5>Servers inside your own network</slot5></slot3> <slot6></slot6>","deployment.deployment.attr.aria.label.deployment.options":"Deployment options","deployment.deployment.p.deployment":"Deployment","deployment.deployment.p.local.first.never.local.only.many.projects.combine":"<slot1></slot1> Local first, never local only. Many projects combine both: private models for sensitive work and hosted models where they add real value.","deployment.deployment.p.we.choose.the.deployment.around.your.information.your":"We choose the deployment around your information, your hardware and your rules. Private options come first, and trusted hosted AI joins in when it is the better fit for quality, scale or cost.","faq.faq.a.ask.us.directly":"<slot1>Ask us directly</slot1><slot2></slot2>","faq.faq.heading.h2.good.questions.straight.answers":"Private AI, <slot1>clearly explained.</slot1>","faq.faq.p.for.many.focused.tasks.yes.search.over.your":"For many focused tasks, yes. Search over your documents, drafting, classification and extraction often work very well with open models. We test on your real tasks before recommending anything, and we say plainly when a larger hosted model is the better choice.","faq.faq.p.local.ai.runs.models.on.hardware.you.control":"Local AI runs models on hardware you control, such as a laptop, a workstation or your own servers. Prompts, documents and results stay with you instead of being sent to an outside service.","faq.faq.p.no.we.start.with.local.and.private.options":"No. We start with local and private options, and we use hosted AI services when they are the better fit for quality, scale or cost. In those cases we limit what is shared, mask sensitive details where possible and choose providers with clear data terms.","faq.faq.p.often.less.than.you.expect.many.assistants.run":"Often less than you expect. Many assistants run well on a modern laptop or a single workstation. We size the model to your hardware and your task, and recommend upgrades only when they clearly pay off.","faq.faq.p.only.when.you.authorise.it.for.custom.model":"Only when you authorise it for custom model development or fine-tuning. We agree on the dataset, permissions and training environment first. Your information is not used to train shared models or for unrelated projects.","faq.faq.p.questions":"Questions","faq.faq.p.the.things.teams.usually.ask.before.starting.with":"The things teams usually ask before starting with private AI. Something else on your mind?","faq.faq.p.with.a.short.call.about.your.goals.if":"With a short call about your goals. If there is a good fit, we agree on a focused discovery and a prototype before any larger build, so you can judge real results before committing further.","faq.faq.p.yes.we.connect.to.the.tools.and.data":"Yes. We connect to the tools and data sources you already use, and we design workflows around how your team works today rather than asking it to change everything at once.","faq.faq.p.yes.we.develop.custom.models.and.fine.tune":"Yes. We develop custom models and fine-tune existing ones for focused tasks. We start with your data quality, permissions and a baseline, then evaluate results on separate test examples before deployment.","faq.faq.summary.can.local.models.match.the.quality.of.cloud":"Can local models match the quality of cloud AI?<slot1></slot1>","faq.faq.summary.can.you.work.with.our.existing.systems":"Can you work with our existing systems?<slot1></slot1>","faq.faq.summary.do.you.develop.custom.models.and.offer.fine":"Do you develop custom models and offer fine-tuning?<slot1></slot1>","faq.faq.summary.do.you.only.build.local.ai":"Do you only build local AI?<slot1></slot1>","faq.faq.summary.how.does.an.engagement.start":"How does an engagement start?<slot1></slot1>","faq.faq.summary.what.hardware.do.we.need":"What hardware do we need?<slot1></slot1>","faq.faq.summary.what.is.local.ai":"What is local AI?<slot1></slot1>","faq.faq.summary.will.our.data.be.used.to.train.models":"Will our data be used to train models?<slot1></slot1>","footer.attr.alt.brand":"{huggingFace}","footer.attr.alt.brand.2":"{x}","footer.attr.aria.label.brand":"{x}","footer.attr.aria.label.brand.2":"{github}","footer.attr.aria.label.brand.on.brand":"{algorithmicNetwork} on {huggingFace}","footer.attr.aria.label.footer.navigation":"Footer navigation","footer.h3.connect":"Connect","footer.h3.explore":"Explore","footer.h3.our.mission":"Our Mission","footer.legal.cookies":"Cookie Policy","footer.legal.privacy":"Privacy Policy","footer.legal.terms":"Terms of Service","footer.li.about.us":"<slot1>About Us</slot1>","footer.li.app.development":"<slot1>App Development</slot1>","footer.li.contact.us":"<slot1>Contact Us</slot1>","footer.li.it.consultation":"<slot1>IT Consultation</slot1>","footer.li.solutions":"<slot1>Solutions</slot1>","footer.p.brand.brand.all.rights.reserved":"\xa9 <slot1>{year}</slot1> {algorithmicNetwork}. All Rights Reserved.","footer.p.building.the.future.of.digital.infrastructure.with.an":"Building the future of digital infrastructure with an unwavering commitment to privacy, security, transparency, and encryption.","fynlink.a.skip.to.main.content":"Skip to main content","fynlink.attr.content.brand.is.a.privacy.first.link.shortener.with":"{fynlink} is a privacy first link shortener with end to end encryption, no ads or trackers, privacy respecting analytics and browser extensions.","fynlink.cta.heading.h2.ready.to.take.control.of.your.links":"Ready to take control of <slot1>your links?</slot1>","fynlink.ext.heading.h2.one.click.away.from.private.links":"One click away from <slot1>private links<slot2>.</slot2></slot1>","fynlink.faq.a.ask.the.brand.team":"<slot1>Ask the {fynlink} team</slot1><slot2></slot2>","fynlink.faq.heading.h2.privacy.explained":"Privacy<slot1>,</slot1> <slot2>explained<slot3>.</slot3></slot2>","fynlink.faq.p.absolutely.the.premium.and.business.plans.are.built":"Absolutely. The Premium and Business plans are built for teams, with team management, custom domains and advanced targeting. Many businesses choose {fynlink} for its strong privacy features, which help them meet regulations like GDPR and build trust with their customers.","fynlink.faq.p.how.brand.protects.your.links.and.your.visitors":"How {fynlink} protects your links and your visitors.","fynlink.faq.p.questions":"Questions","fynlink.faq.p.when.a.link.reaches.its.expiry.date.it":"When a link reaches its expiry date, it is deleted from our servers along with all associated data. Expired links cannot be recovered or accessed by anyone.","fynlink.faq.p.yes.brand.offers.privacy.respecting.analytics.you.choose":"Yes. {fynlink} offers privacy respecting analytics. You choose the level of tracking, from completely private with no tracking at all to basic click counts, without storing IP addresses or personal data.","fynlink.faq.p.your.link.data.is.encrypted.in.your.browser":"Your link data is encrypted in your browser before it is sent to our servers. The encryption keys never leave your device, so even we cannot read your data. When someone opens your short link, the data is decrypted only in their browser.","fynlink.faq.summary.can.i.track.clicks.while.keeping.visitors.private":"Can I track clicks while keeping visitors private?<slot1></slot1>","fynlink.faq.summary.how.does.end.to.end.encryption.work.with":"How does end to end encryption work with {fynlink}?<slot1></slot1>","fynlink.faq.summary.is.brand.suitable.for.business.use":"Is {fynlink} suitable for business use?<slot1></slot1>","fynlink.faq.summary.what.happens.to.my.links.when.they.expire":"What happens to my links when they expire?<slot1></slot1>","fynlink.features.h4.end.to.end.encryption":"End to end encryption","fynlink.features.h4.flexible.privacy.controls":"Flexible privacy controls","fynlink.features.h4.link.expiration":"Link expiration","fynlink.features.h4.local.qr.code.generation":"Local QR code generation","fynlink.features.h4.password.protection":"Password protection","fynlink.features.h4.zero.ads.and.trackers":"Zero ads and trackers","fynlink.features.heading.h2.an.uncompromising.stance.on.privacy":"An uncompromising <slot1>stance on privacy<slot2>.</slot2></slot1>","fynlink.features.p.choose.exactly.how.much.analytics.data.to.collect":"Choose exactly how much analytics data to collect. We never log IP addresses, so your visitors stay protected.","fynlink.features.p.every.feature.in.brand.is.designed.with.one":"Every feature in {fynlink} is designed with one purpose: to give you maximum security and control over your data.","fynlink.features.p.generate.qr.codes.right.in.your.browser.the":"Generate QR codes right in your browser. The data never leaves your device.","fynlink.features.p.no.ads.and.no.third.party.trackers.we":"No ads and no third party trackers. We do not sell your data or compromise your privacy.","fynlink.features.p.privacy.features":"Privacy features","fynlink.features.p.secure.sensitive.links.with.a.password.only.people":"Secure sensitive links with a password. Only people with the password can reach the destination.","fynlink.features.p.set.custom.expiry.dates.once.a.link.expires":"Set custom expiry dates. Once a link expires, it and its data are permanently deleted from our servers.","fynlink.features.p.your.link.data.is.encrypted.in.your.browser":"Your link data is encrypted in your browser before it ever reaches our servers, so even we cannot read it.","fynlink.main.content.a.install.the.free.extension":"Install the free extension <slot1></slot1>","fynlink.main.content.attr.aria.label.available.browsers":"Available browsers","fynlink.main.content.attr.aria.label.the.brand.dashboard.showing.120.active.links.343":"The {fynlink} dashboard showing 120 active links, 343 link clicks, custom domains, teams and recent links.","fynlink.main.content.div.active.link.clicks.343.click.rate.285":"<slot1>Active Link Clicks</slot1><slot2>343</slot2><slot3>Click rate: 285%</slot3>","fynlink.main.content.div.active.links.120":"<slot1>Active Links</slot1><slot2>120</slot2>","fynlink.main.content.div.current.usage.7.2.000":"<slot1><slot2></slot2>Current usage</slot1><slot3>7 / 2,000 (\u221E)</slot3>","fynlink.main.content.div.dashboard":"<slot1></slot1>Dashboard","fynlink.main.content.div.dashboard.domains":"<slot1><slot2></slot2>Dashboard</slot1> <slot3><slot4></slot4>Domains</slot3>","fynlink.main.content.div.demo.team":"<slot1><slot2></slot2></slot1> <slot3>Demo Team</slot3> <slot4></slot4>","fynlink.main.content.div.general.advanced.analytics":"<slot1>General</slot1> <slot2><slot3></slot3>Advanced Analytics</slot2>","fynlink.main.content.div.get.started.for.free.contact.us":"<slot1> Get started for free <slot2></slot2> </slot1> <slot3>Contact us</slot3>","fynlink.main.content.div.get.started.for.free.see.how.it.works":"<slot1>Get started for free <slot2></slot2></slot1> <slot3>See how it works</slot3>","fynlink.main.content.div.help.documentation.support":"<slot1>Help</slot1> <slot2><slot3></slot3>Documentation<slot4></slot4></slot2> <slot5><slot6></slot6>Support<slot7></slot7></slot5>","fynlink.main.content.div.recent.links.top.links":"<slot1>Recent Links</slot1><slot2>Top Links</slot2>","fynlink.main.content.div.team.overview.links.members.api.tokens.settings":"<slot1>Team</slot1> <slot2><slot3></slot3>Overview</slot2> <slot4><slot5></slot5>Links</slot4> <slot6><slot7></slot7>Members</slot6> <slot8><slot9></slot9>API Tokens</slot8> <slot10><slot11></slot11>Settings</slot10>","fynlink.main.content.div.view.all":"View all","fynlink.main.content.h1.secure.links.absolute.privacy":"Secure links<slot1>,</slot1> <slot2>absolute privacy<slot3>.</slot3></slot2>","fynlink.main.content.h4.recent.active.links":"Recent active links","fynlink.main.content.p.3.custom.domains.20":"<slot1>3</slot1><slot2>Custom Domains</slot2> <slot3>/ 20</slot3>","fynlink.main.content.p.6.teams.unlimited":"<slot1>6</slot1><slot2>Teams</slot2> <slot3>/ Unlimited</slot3>","fynlink.main.content.p.a.list.of.all.recent.active.links.across":"A list of all recent active links across all your owned teams.","fynlink.main.content.p.brand":"<slot1></slot1> <slot2>{fynlink}</slot2>","fynlink.main.content.p.brand.4.days.ago":"{fynlinkLlc} \xb7 4 days ago","fynlink.main.content.p.brand.6.days.ago":"{fynlinkLlc} \xb7 6 days ago","fynlink.main.content.p.browser.extensions":"Browser extensions","fynlink.main.content.p.create.secure.private.links.from.anywhere.on.the":"Create secure, private links from anywhere on the web with our free browser extensions.","fynlink.main.content.p.free.extensions.for.your.browser":"Free extensions for your browser","fynlink.main.content.p.join.the.privacy.conscious.people.and.businesses.who":"Join the privacy conscious people and businesses who trust {fynlink} for secure, private link management.","fynlink.main.content.p.the.privacy.first.link.shortener.that.puts.security":"The privacy first link shortener that puts security and control first. Your link data is encrypted in your browser, so not even we can read it.","fynlink.main.content.small.domains":"Domains","fynlink.main.content.small.teams":"Teams","fynlink.main.content.span.fyn.li.rebrandly":"fyn.li/rebrandly","fynlink.main.content.span.fyn.li.shortio":"fyn.li/shortio","fynlink.metadata.title.brand.private.link.shortener.by.brand":"{fynlink} | Private link shortener by {algorithmicNetwork}","fynlink.pricing.a.start.free.trial":"Start free trial","fynlink.pricing.a.start.free.trial.2":"Start free trial <slot1></slot1>","fynlink.pricing.h3.business":"Business","fynlink.pricing.h3.premium":"Premium","fynlink.pricing.h3.starter":"Starter","fynlink.pricing.heading.h2.simple.transparent.pricing":"Simple<slot1>,</slot1> <slot2>transparent pricing<slot3>.</slot3></slot2>","fynlink.pricing.li.100.links.per.month":"<slot1></slot1>100 links per month","fynlink.pricing.li.2.000.links.per.month":"<slot1></slot1>2,000 links per month","fynlink.pricing.li.20.000.links.per.month":"<slot1></slot1>20,000 links per month","fynlink.pricing.li.20.branded.domains.and.unlimited.teams":"<slot1></slot1>20 branded domains and unlimited teams","fynlink.pricing.li.50.branded.domains.and.advanced.roles":"<slot1></slot1>50 branded domains and advanced roles","fynlink.pricing.li.ai.powered.filters":"<slot1></slot1>AI powered filters","fynlink.pricing.li.api.access":"<slot1></slot1>API access","fynlink.pricing.li.geo.and.device.targeting":"<slot1></slot1>Geo and device targeting","fynlink.pricing.li.unlimited.redirects.and.2.branded.domains":"<slot1></slot1>Unlimited redirects and 2 branded domains","fynlink.pricing.p.29.month":"<slot1>$29</slot1><slot2>/ month</slot2>","fynlink.pricing.p.4.month":"<slot1>$4</slot1><slot2>/ month</slot2>","fynlink.pricing.p.79.month":"<slot1>$79</slot1><slot2>/ month</slot2>","fynlink.pricing.p.all.plans.include.a.14.day.free.trial":"All plans include a 14 day free trial. No credit card required.","fynlink.pricing.p.choose.a.plan.that.fits.your.needs.no":"Choose a plan that fits your needs. No hidden fees and no surprises.","fynlink.pricing.p.for.individuals.and.small.projects":"For individuals and small projects.","fynlink.pricing.p.for.large.scale.organisations":"For large scale organisations.","fynlink.pricing.p.for.professionals.and.teams":"For professionals and teams.","fynlink.pricing.p.pricing":"Pricing","fynlink.pricing.span.coming.later":"Coming later","fynlink.pricing.span.most.popular":"Most popular","hero.hero.attr.aria.label.core.services":"Core services","hero.hero.attr.aria.label.explore.our.solutions":"Explore our solutions","hero.hero.attr.aria.label.scroll.down.for.more.content":"Scroll down for more content","hero.hero.attr.aria.label.services.offered":"Services offered","hero.hero.div.ai.solutions.privacy.solutions":"<slot1>AI SOLUTIONS</slot1> <slot2>PRIVACY SOLUTIONS</slot2>","hero.hero.div.by.design":"<slot1> BY </slot1> <slot2> DESIGN </slot2>","hero.hero.div.explore.solutions":"<slot1> <slot2>Explore Solutions</slot2> </slot1>","hero.hero.div.it.consultation.application.development":"<slot1>IT CONSULTATION</slot1> <slot2>APPLICATION DEVELOPMENT</slot2>","hero.hero.heading.h1.privacy":"PRIVACY","hero.hero.span.scroll.down":"Scroll Down","index.a.skip.to.main.content":"Skip to main content","index.attr.content.custom.ai.powered.solutions.for.your.devices.private":"Custom AI-powered solutions for your devices, private infrastructure or trusted hosted AI, with custom models or fine-tuning where needed. Privacy is designed in.","index.attr.content.custom.ai.powered.solutions.with.custom.models.or":"Custom AI-powered solutions, with custom models or fine-tuning where needed. Local first, private by default and connected to hosted AI when it helps.","index.attr.content.private.ai.by.design.brand":"Private AI, by design | {algorithmicNetwork}","index.metadata.title.brand.custom.ai.powered.solutions":"{algorithmicNetwork} | Custom AI-powered solutions","it.consultation.a.skip.to.main.content":"Skip to main content","it.consultation.approach.heading.h2.advice.you.can.act.on":"Advice you can <slot1>act on.</slot1>","it.consultation.areas.h4.ai.feasibility.assessment":"AI feasibility assessment","it.consultation.areas.h4.data.access.and.governance":"Data access and governance","it.consultation.areas.h4.deployment.choices":"Deployment choices","it.consultation.areas.h4.evaluation.and.cost.planning":"Evaluation and cost planning","it.consultation.areas.heading.h2.core.consultation.areas":"Core consultation <slot1>areas.</slot1>","it.consultation.areas.li.evaluation.criteria":"Evaluation criteria","it.consultation.areas.li.feasibility.questions":"Feasibility questions","it.consultation.areas.li.hosted.provider.review":"Hosted provider review","it.consultation.areas.li.implementation.priorities":"Implementation priorities","it.consultation.areas.li.information.quality":"Information quality","it.consultation.areas.li.local.hardware.assessment":"Local hardware assessment","it.consultation.areas.li.operating.cost.assessment":"Operating cost assessment","it.consultation.areas.li.private.environment.planning":"Private environment planning","it.consultation.areas.li.prototype.scope":"Prototype scope","it.consultation.areas.li.retention.requirements":"Retention requirements","it.consultation.areas.li.source.permissions":"Source permissions","it.consultation.areas.li.use.case.definition":"Use case definition","it.consultation.areas.p.assess.dataset.quality.and.permissions.for.custom.models":"Assess dataset quality and permissions for custom models and fine-tuning, and define access, handling and retention requirements.","it.consultation.areas.p.assess.the.use.case.and.whether.an.existing":"Assess the use case and whether an existing model, retrieval, fine-tuning or custom model development is the right approach.","it.consultation.areas.p.compare.on.device.execution.private.environments.and.hosted":"Compare on device execution, private environments and hosted AI services around your privacy, hardware and operating requirements.","it.consultation.areas.p.four.areas.that.decide.whether.an.ai.project":"Four areas that decide whether an AI project succeeds. We can work through all of them or focus on the one holding you back.","it.consultation.areas.p.plan.test.cases.and.acceptable.errors.and.assess":"Plan test cases and acceptable errors, and assess training, fine-tuning, deployment and maintenance costs.","it.consultation.areas.p.what.we.cover":"What we cover","it.consultation.attr.content.ai.consulting.for.custom.model.development.fine.tuning":"AI consulting for custom model development, fine-tuning and deployment: use case assessment, data readiness, evaluation and cost planning.","it.consultation.cta.heading.h2.unlock.your.business.potential":"Unlock your business <slot1>potential.</slot1>","it.consultation.main.content.a.email.us":"Email us","it.consultation.main.content.button.schedule.a.consultation":"Schedule a consultation <slot1></slot1>","it.consultation.main.content.div.you.get.a.clear.problem.statement.and.use":"<slot1>You get</slot1><slot2>A clear problem statement and use case</slot2>","it.consultation.main.content.div.you.get.a.recommended.approach.with.tradeoffs":"<slot1>You get</slot1><slot2>A recommended approach with tradeoffs</slot2>","it.consultation.main.content.div.you.get.a.review.plan.that.keeps.it":"<slot1>You get</slot1><slot2>A review plan that keeps it healthy</slot2>","it.consultation.main.content.div.you.get.a.scoped.next.step.ready.to":"<slot1>You get</slot1><slot2>A scoped next step, ready to start</slot2>","it.consultation.main.content.h1.strategic.guidance":"<slot1>Strategic</slot1> <slot2>Guidance<slot3>.</slot3></slot2>","it.consultation.main.content.h3.considered.data.boundaries":"Considered data boundaries","it.consultation.main.content.h3.data.protection.by.design":"Data protection by design","it.consultation.main.content.h3.discover.and.assess":"Discover and assess","it.consultation.main.content.h3.guide":"Guide","it.consultation.main.content.h3.improve":"Improve","it.consultation.main.content.h3.plan":"Plan","it.consultation.main.content.h3.practical.evaluation":"Practical evaluation","it.consultation.main.content.h3.purposeful.advice":"Purposeful advice","it.consultation.main.content.h3.specialist.focus":"Specialist focus","it.consultation.main.content.h3.transparent.communication":"Transparent communication","it.consultation.main.content.li.a.dedicated.point.of.contact":"<slot1></slot1>A dedicated point of contact","it.consultation.main.content.li.access":"Access","it.consultation.main.content.li.define.suitable.access.and.deployment.controls":"<slot1></slot1>Define suitable access and deployment controls","it.consultation.main.content.li.map.the.information.and.permissions.involved":"<slot1></slot1>Map the information and permissions involved","it.consultation.main.content.li.ownership":"Ownership","it.consultation.main.content.li.permissions":"Permissions","it.consultation.main.content.li.plain.language.documentation":"<slot1></slot1>Plain language documentation","it.consultation.main.content.li.regular.updates.for.stakeholders":"<slot1></slot1>Regular updates for stakeholders","it.consultation.main.content.li.retention":"Retention","it.consultation.main.content.li.visual.explanations.of.complex.ideas":"<slot1></slot1>Visual explanations of complex ideas","it.consultation.main.content.p.assess.deployment.choices.data.boundaries.evaluation.criteria.and":"Assess deployment choices, data boundaries, evaluation criteria and operating requirements.","it.consultation.main.content.p.custom.model.development.fine.tuning.local.and.private":"Custom model development, fine-tuning, local and private AI, and careful use of hosted models, with a practical path from evaluation to working software.","it.consultation.main.content.p.define.how.quality.maintenance.and.costs.will.be":"Define how quality, maintenance and costs will be reviewed as the system and the work evolve.","it.consultation.main.content.p.every.stage.ends.with.something.concrete.you.can":"Every stage ends with something concrete you can review, share and decide on.","it.consultation.main.content.p.good.ai.decisions.start.before.any.model.is":"Good AI decisions start before any model is chosen. We look at the work you want to improve, the information it depends on and the boundaries that matter, then recommend the simplest approach that will hold up in practice.","it.consultation.main.content.p.how.a.consultation.runs":"How a consultation runs","it.consultation.main.content.p.our.approach":"Our approach","it.consultation.main.content.p.our.philosophy":"Our philosophy","it.consultation.main.content.p.real.examples.and.agreed.criteria.separate.a.promising":"Real examples and agreed criteria separate a promising demo from a system that is ready for the work, with an honest view of its limits.","it.consultation.main.content.p.recommendations.shaped.around.your.task.data.and.operating":"Recommendations shaped around your task, data and operating needs, always with a clearly defined next step and business outcome.","it.consultation.main.content.p.shape.a.practical.next.step.whether.that.is":"Shape a practical next step, whether that is a prototype, an integration or a private deployment.","it.consultation.main.content.p.tell.us.what.you.want.ai.to.do":"Tell us what you want AI to do, where your information lives and the boundaries that matter. We will work through a practical next step together.","it.consultation.main.content.p.three.habits.shape.every.engagement.whether.the.answer":"Three habits shape every engagement, whether the answer is a local model, a private system or a carefully chosen hosted service.","it.consultation.main.content.p.understand.the.task.the.information.involved.and.the":"Understand the task, the information involved and the outcome the business needs.","it.consultation.main.content.p.we.define.the.data.flow.and.access.requirements":"We define the data flow and access requirements before recommending an architecture. Privacy shapes the deployment rather than being added after a prototype.","it.consultation.main.content.p.we.examine.where.information.is.processed.what.is":"We examine where information is processed, what is retained and how access is controlled, and document requirements clearly, including any specialist review.","it.consultation.main.content.p.we.explain.opportunities.tradeoffs.and.limitations.in.plain":"We explain opportunities, tradeoffs and limitations in plain language, so you can make informed decisions.","it.consultation.main.content.p.we.focus.on.ai.that.respects.how.your":"We focus on AI that respects how your business works and the information it relies on, and we connect advice directly to what can be built.","it.consultation.main.content.p.why.work.with.us":"Why work with us","it.consultation.main.content.span.e":"E","it.consultation.main.content.span.p":"P","it.consultation.main.content.span.s":"S","it.consultation.metadata.title.ai.consulting.brand":"AI Consulting | {algorithmicNetwork}","it.consultation.philosophy.heading.h2.we.help.you.find.a.clear.direction.for":"We help you find a <slot1>clear direction for AI,</slot1> with the use case, data and deployment considered together.","it.consultation.process.heading.h2.from.question.to.clear.next.step":"From question to <slot1>clear next step.</slot1>","it.consultation.why.heading.h2.practical.ai.honestly.advised":"Practical AI, <slot1>honestly advised.</slot1>","language.choose":"Choose language","language.current":"Language: {language}","language.empty":"No languages found.","language.label":"Language","language.search":"Search languages","links.retailistSuite":"<slot1>Explore the {retailist} suite<slot2> (opens in a new tab)</slot2></slot1><slot3></slot3>","navigation.a.get.started":"Get Started <slot1></slot1>","navigation.an.mobile.nav.a.get.started":"Get Started <slot1></slot1>","navigation.an.mobile.nav.button.products":"Products <slot1></slot1>","navigation.an.mobile.nav.button.services":"Services <slot1></slot1>","navigation.an.mobile.nav.li.about":"<slot1>About</slot1>","navigation.an.mobile.nav.li.approach":"<slot1>Approach</slot1>","navigation.an.mobile.nav.li.faq":"<slot1>FAQ</slot1>","navigation.an.mobile.nav.p.or.write.to.brand":"Or write to <slot1>{helloEmail}</slot1>","navigation.an.mobile.products.attr.aria.label.more.products":"More products","navigation.an.mobile.products.div.brand.a.family.of.products.for.commerce":"<slot1>{retailist}</slot1><slot2>A family of products for commerce</slot2>","navigation.an.mobile.products.li.brand.a.focused.online.storefront":"<slot1><slot2><slot3></slot3></slot2><slot4><slot5>{retailistStore}</slot5><slot6>A focused online storefront</slot6></slot4></slot1>","navigation.an.mobile.products.li.brand.creative.tools.for.commerce":"<slot1><slot2><slot3></slot3></slot2><slot4><slot5>{retailistAi}</slot5><slot6>Creative tools for commerce</slot6></slot4></slot1>","navigation.an.mobile.products.li.brand.desktop.operations.for.retail":"<slot1><slot2><slot3></slot3></slot2><slot4><slot5>{retailistApp}</slot5><slot6>Desktop operations for retail</slot6></slot4></slot1>","navigation.an.mobile.products.li.brand.encrypted.backup.and.recovery":"<slot1><slot2><slot3></slot3></slot2><slot4><slot5>{retailistCloud}</slot5><slot6>Encrypted backup and recovery</slot6></slot4></slot1>","navigation.an.mobile.products.li.brand.live.private.link.shortener":"<slot1><slot2><slot3></slot3></slot2><slot4><slot5>{fynlink}</slot5><slot7>Private link shortener</slot7></slot4></slot1>","navigation.an.mobile.products.li.brand.opens.in.a.new.tab.private.ai":"<slot1><slot2><slot3></slot3></slot2><slot4><slot5>{localAts} <slot6></slot6><slot7>(opens in a new tab)</slot7></slot5><slot8>Private AI resume analysis in your browser</slot8></slot4></slot1>","navigation.an.mobile.services.li.ai.consulting.clarity.before.you.commit":"<slot1><slot2><slot3></slot3></slot2><slot4><slot5>AI consulting</slot5><slot6>Clarity before you commit</slot6></slot4></slot1>","navigation.an.mobile.services.li.ai.development.custom.models.fine.tuning.and.ai":"<slot1><slot2><slot3></slot3></slot2><slot4><slot5>AI development</slot5><slot6>Custom models, fine tuning and AI products</slot6></slot4></slot1>","navigation.attr.alt.brand":"{algorithmicNetwork}","navigation.attr.aria.label.brand.home":"{algorithmicNetwork} home","navigation.attr.aria.label.dark.mode":"Dark mode","navigation.attr.aria.label.open.menu":"Open menu","navigation.attr.aria.label.primary.navigation":"Primary navigation","navigation.attr.title.switch.to.dark.mode":"Switch to dark mode","navigation.closeMenu":"Close menu","navigation.li.about":"<slot1>About</slot1>","navigation.li.approach":"<slot1>Approach</slot1>","navigation.li.faq":"<slot1>FAQ</slot1>","navigation.nav.other.products.heading.p.other.products":"Other products","navigation.nav.products.panel.a.let.s.talk":"Let\u2019s talk <slot1></slot1>","navigation.nav.products.panel.li.brand.opens.in.a.new.tab.private.ai":"<slot1> <slot2><slot3></slot3></slot2> <slot4><slot5>{localAts} <slot6></slot6><slot7>(opens in a new tab)</slot7></slot5><slot8>Private AI resume analysis in your browser. Free and open source.</slot8></slot4> </slot1>","navigation.nav.products.panel.li.brand.private.links.with.end.to.end.encryption":"<slot1> <slot2><slot3></slot3></slot2> <slot4><slot5>{fynlink}</slot5><slot6>Private links with end to end encryption.</slot6></slot4> </slot1>","navigation.nav.products.panel.p.a.family.of.products.for.commerce":"A family of products for commerce.","navigation.nav.products.panel.p.a.focused.online.storefront.managed.from.your.desktop":"A focused online storefront, managed from your desktop.","navigation.nav.products.panel.p.encrypted.backups.and.clear.recovery.for.your.shop":"Encrypted backups and clear recovery for your shop.","navigation.nav.products.panel.p.have.a.product.in.mind.we.design.build":"Have a product in mind? We design, build and run our own, and we can build yours.","navigation.nav.products.panel.p.products.stock.point.of.sale.and.orders.in":"Products, stock, point of sale and orders in one desktop app.","navigation.nav.products.panel.p.studio.shots.model.photos.and.video.from.one":"Studio shots, model photos and video from one product photo.","navigation.nav.products.trigger.button.products":"Products <slot1></slot1>","navigation.nav.services.panel.a.book.a.discovery.call":"Book a discovery call <slot1></slot1>","navigation.nav.services.panel.a.how.we.work":"How we work <slot1></slot1>","navigation.nav.services.panel.li.ai.feasibility":"<slot1></slot1>AI feasibility","navigation.nav.services.panel.li.ai.strategy":"<slot1></slot1>AI strategy","navigation.nav.services.panel.li.cloud.ai.integration":"<slot1></slot1>Cloud AI integration","navigation.nav.services.panel.li.custom.models":"<slot1></slot1>Custom models","navigation.nav.services.panel.li.data.readiness":"<slot1></slot1>Data readiness","navigation.nav.services.panel.li.fine.tuning":"<slot1></slot1>Fine tuning","navigation.nav.services.panel.li.local.and.private.ai":"<slot1></slot1>Local and private AI","navigation.nav.services.panel.li.private.deployment":"<slot1></slot1>Private deployment","navigation.nav.services.panel.p.book.a.30.minute.call.we.will.look":"Book a 30 minute call. We will look at your idea, your data and a sensible first step.","navigation.nav.services.panel.p.build.private.ai.applications.custom.models.and.useful":"Build private AI applications, custom models and useful products.","navigation.nav.services.panel.p.find.the.right.use.case.assess.your.data":"Find the right use case, assess your data and choose how to deploy.","navigation.nav.services.panel.p.local.first.and.private.by.default.hosted.ai":"Local first and private by default. Hosted AI when it helps.","navigation.nav.services.panel.p.or.write.to.brand":"Or write to <slot1>{helloEmail}</slot1>","navigation.nav.services.panel.p.start.here":"Start here","navigation.nav.services.panel.span.explore.consulting":"Explore consulting <slot1></slot1>","navigation.nav.services.panel.span.explore.development":"Explore development <slot1></slot1>","navigation.nav.services.panel.strong.ai.consulting":"AI consulting","navigation.nav.services.panel.strong.ai.development":"AI development","navigation.nav.services.trigger.button.services":"Services <slot1></slot1>","navigation.nav.start.heading.strong.not.sure.where.to.start":"Not sure where to start?","navigation.openMenu":"Open menu","privacy.policy.attr.content.our.commitment.to.privacy.security.and.transparency":"Our commitment to privacy, security, and transparency.","privacy.policy.collection.h3.information.we.collect":"Information We Collect","privacy.policy.collection.li.your.email.address.so.we.can.respond.to":"Your email address (so we can respond to your inquiry)","privacy.policy.collection.li.your.name.so.we.know.who.we.re":"Your name (so we know who we\'re talking to)","privacy.policy.collection.p.that.s.it.we.don.t.track.your":"That\'s it. We don\'t track your browsing behavior, we don\'t use cookies to follow you around the web, and we don\'t collect any data beyond what you explicitly provide.","privacy.policy.collection.p.we.collect.minimal.information.through.our.website.s":"We collect minimal information through our website\'s contact form:","privacy.policy.commitment.h3.our.privacy.commitment":"Our Privacy Commitment","privacy.policy.commitment.p.at.brand.we.re.a.consultancy.firm.focused":"At {algorithmicNetwork}, we\'re a consultancy firm focused on privacy-first development. We believe your data belongs to you, and we\'re committed to maintaining the highest standards of privacy protection. This policy explains how we handle the limited data we collect.","privacy.policy.contact.h3.contact.us":"Contact Us","privacy.policy.contact.p.if.you.have.any.questions.or.concerns.about":"If you have any questions or concerns about our privacy practices, please don\'t hesitate to contact us at <slot1>{privacyEmail}</slot1>.","privacy.policy.main.content.div.privacy":"PRIVACY","privacy.policy.main.content.h1.privacy.policy":"Privacy Policy","privacy.policy.main.content.p.last.updated.may.19.2025":"Last Updated: May 19, 2025","privacy.policy.main.content.p.we.believe.in.a.web.where.you.can":"We believe in a web where you can browse without being watched. This policy outlines our unwavering commitment to your privacy.","privacy.policy.metadata.title.privacy.policy.brand":"Privacy Policy - {algorithmicNetwork}","privacy.policy.privacy.nav.h2.on.this.page":"On this page","privacy.policy.privacy.nav.li.contact.us":"<slot1>Contact Us</slot1>","privacy.policy.privacy.nav.li.data.security":"<slot1>Data Security</slot1>","privacy.policy.privacy.nav.li.data.sharing":"<slot1>Data Sharing</slot1>","privacy.policy.privacy.nav.li.how.we.use.it":"<slot1>How We Use It</slot1>","privacy.policy.privacy.nav.li.information.we.collect":"<slot1>Information We Collect</slot1>","privacy.policy.privacy.nav.li.our.commitment":"<slot1>Our Commitment</slot1>","privacy.policy.privacy.nav.li.your.rights":"<slot1>Your Rights</slot1>","privacy.policy.privacy.nav.li.zero.tracking":"<slot1>Zero-Tracking</slot1>","privacy.policy.rights.h3.your.rights":"Your Rights","privacy.policy.rights.li.access.the.personal.information.we.hold.about.you":"Access the personal information we hold about you","privacy.policy.rights.li.request.a.copy.of.your.data.in.a":"Request a copy of your data in a portable format","privacy.policy.rights.li.request.correction.of.any.inaccurate.information":"Request correction of any inaccurate information","privacy.policy.rights.li.request.deletion.of.your.information":"Request deletion of your information","privacy.policy.rights.li.withdraw.consent.at.any.time":"Withdraw consent at any time","privacy.policy.rights.p.to.exercise.any.of.these.rights.please.contact":"To exercise any of these rights, please contact us at <slot1>{privacyEmail}</slot1>.","privacy.policy.rights.p.you.have.the.right.to":"You have the right to:","privacy.policy.security.h3.data.security":"Data Security","privacy.policy.security.li.end.to.end.encryption.for.all.communications":"End-to-end encryption for all communications","privacy.policy.security.li.regular.security.audits.and.updates":"Regular security audits and updates","privacy.policy.security.li.secure.encrypted.storage.for.any.data.we.maintain":"Secure, encrypted storage for any data we maintain","privacy.policy.security.li.strict.access.controls.limiting.who.can.view.your":"Strict access controls limiting who can view your information","privacy.policy.security.p.all.data.we.process.is.encrypted.using.industry":"All data we process is encrypted using industry-leading standards. Our security measures include:","privacy.policy.security.p.we.treat.your.data.with.the.same.level":"We treat your data with the same level of protection we design into our privacy-focused products.","privacy.policy.sharing.h3.data.sharing":"Data Sharing","privacy.policy.sharing.li.if.necessary.to.protect.our.rights.property.or":"If necessary to protect our rights, property, or safety","privacy.policy.sharing.li.if.required.by.law":"If required by law","privacy.policy.sharing.li.if.you.explicitly.request.us.to.share.your":"If you explicitly request us to share your information","privacy.policy.sharing.p.we.do.not.sell.trade.or.otherwise.transfer":"We do not sell, trade, or otherwise transfer your information to third parties under any circumstances, except with your explicit consent. The only exceptions to this rule would be:","privacy.policy.tracking.h3.zero.tracking.policy":"Zero Tracking Policy","privacy.policy.tracking.li.create.user.profiles.based.on.your.interactions":"Create user profiles based on your interactions","privacy.policy.tracking.li.employ.analytics.scripts.that.monitor.your.behavior":"Employ analytics scripts that monitor your behavior","privacy.policy.tracking.li.use.tracking.cookies":"Use tracking cookies","privacy.policy.tracking.li.utilize.third.party.tracking.tools":"Utilize third-party tracking tools","privacy.policy.tracking.p.unlike.most.websites.we.do.not":"Unlike most websites, we do not:","privacy.policy.tracking.p.we.believe.in.a.web.where.you.can":"We believe in a web where you can browse without being watched. Our website reflects this philosophy with <slot1>absolutely zero tracking</slot1>.","privacy.policy.usage.h3.how.we.use.your.information":"How We Use Your Information","privacy.policy.usage.li.improve.our.services.based.on.your.feedback":"Improve our services based on your feedback","privacy.policy.usage.li.provide.the.consultancy.services.you.request":"Provide the consultancy services you request","privacy.policy.usage.li.respond.to.your.inquiries":"Respond to your inquiries","privacy.policy.usage.p.the.information.you.provide.is.used.solely.to":"The information you provide is used solely to:","privacy.policy.usage.p.we.will.never.use.your.information.for.marketing":"We will never use your information for marketing purposes without your explicit consent. We have a strict <slot1>no-spam policy</slot1>.","process.process.a.discuss.your.ai.project":"Discuss your AI project <slot1></slot1>","process.process.div.you.get.a.scoped.use.case.and.agreed":"<slot1>You get</slot1><slot2>A scoped use case and agreed data boundaries</slot2>","process.process.div.you.get.a.working.prototype.measured.on.your":"<slot1>You get</slot1><slot2>A working prototype, measured on your data</slot2>","process.process.div.you.get.monitoring.documentation.and.a.clear.owner":"<slot1>You get</slot1><slot2>Monitoring, documentation and a clear owner</slot2>","process.process.div.you.get.production.software.your.team.can.rely":"<slot1>You get</slot1><slot2>Production software your team can rely on</slot2>","process.process.h3.build":"Build","process.process.h3.discover":"Discover","process.process.h3.every.engagement.includes":"Every engagement includes","process.process.h3.operate":"Operate","process.process.h3.prove":"Prove","process.process.heading.h2.a.clear.path.from.idea.to.impact":"A clear path from <slot1>idea to impact.</slot1>","process.process.li.defined.data.boundaries.agreed.before.any.build":"<slot1></slot1>Defined data boundaries, agreed before any build","process.process.li.evaluation.against.your.real.tasks":"<slot1></slot1>Evaluation against your real tasks","process.process.li.human.review.for.important.actions":"<slot1></slot1>Human review for important actions","process.process.li.local.and.private.deployment.considered.first":"<slot1></slot1>Local and private deployment considered first","process.process.li.plain.language.documentation.and.handover":"<slot1></slot1>Plain language documentation and handover","process.process.li.purposeful.access.controls.and.permissions":"<slot1></slot1>Purposeful access controls and permissions","process.process.p.build.the.application.and.where.useful.develop.or":"Build the application and, where useful, develop or fine-tune its model, with quality checks and review for important actions.","process.process.p.compare.deployment.options.and.test.the.riskiest.assumptions":"Compare deployment options and test the riskiest assumptions with a focused prototype on your real tasks.","process.process.p.how.we.work":"How we work","process.process.p.most.projects.start.with.a.short.call.and":"Most projects start with a short call and a focused discovery.","process.process.p.prepare.deployment.and.handover.then.review.quality.security":"Prepare deployment and handover, then review quality, security and operating cost as the system grows.","process.process.p.understand.the.task.the.people.and.the.information":"Understand the task, the people and the information involved. Agree on the outcome and the privacy requirements.","process.process.p.we.turn.a.clear.use.case.into.a":"We turn a clear use case into a useful AI system through discovery, evaluation, development and ongoing review. Every step ends with something you can see and judge.","retailist.ai.a.skip.to.main.content":"Skip to main content","retailist.ai.attr.content.brand.is.being.developed.to.help.merchants.refine":"{retailistAi} is being developed to help merchants refine product images, create visual scenes and prepare content for catalogs, storefronts and campaigns. Coming soon.","retailist.ai.cta.heading.h2.coming.soon":"Coming <slot1>soon<slot2>.</slot2></slot1>","retailist.ai.does.heading.h2.built.for.the.way.retail.really.works":"Built for the way <slot1>retail really works<slot2>.</slot2></slot1>","retailist.ai.faq.heading.h2.questions.about.brand":"Questions about <slot1>{retailistAi}<slot2>.</slot2></slot1>","retailist.ai.main.content.a.ask.us.directly":"<slot1>Ask us directly</slot1><slot2></slot2>","retailist.ai.main.content.attr.alt.a.silver.and.cobalt.dress.photographed.on.its":"A silver and cobalt dress photographed on its own against a plain background","retailist.ai.main.content.attr.alt.a.synthetic.adult.model.standing.in.a.cobalt":"A synthetic adult model standing in a cobalt suit","retailist.ai.main.content.attr.alt.the.same.model.wearing.the.silver.and.cobalt":"The same model wearing the silver and cobalt dress","retailist.ai.main.content.attr.aria.label.a.preview.of.brand.removing.the.background.from":"A preview of {retailistAi} removing the background from a photo of a speaker on a shop counter.","retailist.ai.main.content.attr.aria.label.brand":"{retailistDesktop}","retailist.ai.main.content.attr.aria.label.brand.2":"{shopify}","retailist.ai.main.content.attr.aria.label.brand.3":"{wooCommerce}","retailist.ai.main.content.div.01.remove.background.02.bring.back.detail.03":"<slot1><slot2>01</slot2>Remove background</slot1><slot3><slot4>02</slot4>Bring back detail</slot3><slot5><slot6>03</slot6>Balanced light</slot5><slot7><slot8>04</slot8>Build a product scene</slot7>","retailist.ai.main.content.div.get.launch.updates.explore.the.suite":"<slot1>Get launch updates <slot2></slot2></slot1> <slot3>Explore the suite<slot4> (opens in a new tab)</slot4><slot5></slot5></slot3>","retailist.ai.main.content.div.shop.counter.clean.cutout":"<slot1></slot1><slot2><slot3></slot3></slot2><slot4>Shop counter</slot4><slot5>Clean cutout</slot5><slot6><slot7></slot7></slot6>","retailist.ai.main.content.figcaption.a.concept.preview.details.may.change.before.launch":"A concept preview. Details may change before launch.","retailist.ai.main.content.h1.better.product.images.made.simple":"Better product images<slot1>,</slot1> <slot2>made simple<slot3>.</slot3></slot2>","retailist.ai.main.content.h3.photograph.the.garment":"Photograph the garment","retailist.ai.main.content.h3.pick.a.model":"Pick a model","retailist.ai.main.content.h3.see.it.worn":"See it worn","retailist.ai.main.content.h4.create.scenes":"Create scenes","retailist.ai.main.content.h4.models.and.video":"Models and video","retailist.ai.main.content.h4.prepare.content":"Prepare content","retailist.ai.main.content.h4.refine.images":"Refine images","retailist.ai.main.content.li.brand.app":"<slot1><slot2></slot2><slot3></slot3></slot1><slot4>{shopify} app</slot4>","retailist.ai.main.content.li.brand.plugin":"<slot1><slot2></slot2></slot1><slot3>{wooCommerce} plugin</slot3>","retailist.ai.main.content.li.desktop.desktop.app":"<slot1><slot2><slot3></slot3><slot4></slot4><slot5></slot5></slot2></slot1><slot6>Desktop app</slot6>","retailist.ai.main.content.p.a.clear.photo.of.the.item.on.a":"A clear photo of the item on a hanger or a table is enough. No model and no studio needed.","retailist.ai.main.content.p.a.focused.online.store.connected.to.the.catalog":"A focused online store connected to the catalog and operations you manage in {retailistApp}.","retailist.ai.main.content.p.ai.tools.for.product.imagery.scenes.and.content":"AI tools for product imagery, scenes and content across catalogs, storefronts and campaigns.","retailist.ai.main.content.p.always.check.the.result.before.you.publish.it":"<slot1></slot1> Always check the result before you publish it. Look closely at the garment details, the fit and the hands.","retailist.ai.main.content.p.brand":"<slot1></slot1> <slot2>{retailistAi}</slot2>","retailist.ai.main.content.p.brand.focuses.on.creative.product.content.it.complements":"{retailistAi} focuses on creative product content. It complements {retailistApp} and {retailistStore}, while remaining distinct from the local AI used for business information on the desktop.","retailist.ai.main.content.p.brand.is.coming.soon.this.page.introduces.the":"{retailistAi} is coming soon. This page introduces the intended product, and launch information will be shared when it is ready.","retailist.ai.main.content.p.brand.is.designed.around.everyday.retail.work.with":"{retailistAi} is designed around everyday retail work, with privacy and clear boundaries considered from the start.","retailist.ai.main.content.p.choose.one.of.your.saved.models.or.create":"Choose one of your saved models, or create a new one that suits your brand. The models are synthetic people, not real ones.","retailist.ai.main.content.p.creative.processing.may.use.hosted.models.with.requirements":"Creative processing may use hosted models, with requirements specific to each tool. {retailistAi} is distinct from the local business AI in {retailistApp}, and generated content should be reviewed for accuracy and suitability.","retailist.ai.main.content.p.creative.tools.for.commerce":"Creative tools for commerce","retailist.ai.main.content.p.desktop.operations":"Desktop operations","retailist.ai.main.content.p.encrypted.backup":"Encrypted backup","retailist.ai.main.content.p.encrypted.backups.version.history.and.recovery.for.supported":"Encrypted backups, version history and recovery for supported commerce data.","retailist.ai.main.content.p.explore.settings.and.compositions.that.help.people.understand":"Explore settings and compositions that help people understand the product, then review generated results for accuracy before using them.","retailist.ai.main.content.p.good.to.know":"Good to know","retailist.ai.main.content.p.online.storefront":"Online storefront","retailist.ai.main.content.p.products.inventory.orders.and.daily.retail.operations.with":"Products, inventory, orders and daily retail operations, with local tools and optional connected services.","retailist.ai.main.content.p.remove.backgrounds.improve.lighting.and.colour.and.prepare":"Remove backgrounds, improve lighting and colour, and prepare cleaner images for product listings.","retailist.ai.main.content.p.resize.crop.and.export.content.for.the.places":"Resize, crop and export content for the places your products appear, while keeping original assets distinct from generated work.","retailist.ai.main.content.p.run.the.shop.floor.sell.online.protect.your":"Run the shop floor, sell online, protect your data and create with AI. Each product works on its own and better together.","retailist.ai.main.content.p.show.clothing.on.synthetic.models.with.virtual.try":"Show clothing on synthetic models with virtual try on, and turn product photos into short videos for social.","retailist.ai.main.content.p.the.brand.suite":"The {retailist} suite","retailist.ai.main.content.p.turn.one.product.photo.into.studio.shots.model":"Turn one product photo into studio shots, model photos and short videos. Refine images, show clothing on models and prepare content for your store, ads and social.","retailist.ai.main.content.p.virtual.try.on":"Virtual try on","retailist.ai.main.content.p.virtual.try.on.simply.means.showing.your.clothing":"Virtual try on simply means showing your clothing worn by a model, without booking another photoshoot. You take a clear photo of the garment, pick a model, and {retailistAi} creates a photo of that model wearing it.","retailist.ai.main.content.p.we.are.preparing.brand.for.release.explore.the":"We are preparing {retailistAi} for release. Explore the suite to see how its products fit together, or ask us to keep you posted.","retailist.ai.main.content.p.what.it.does":"What it does","retailist.ai.main.content.p.what.to.expect.from.brand.and.how.it":"What to expect from {retailistAi} and how it fits with the rest of {retailist}.","retailist.ai.main.content.p.works.with.your.desktop.and.your.store":"Works with your desktop and your store","retailist.ai.main.content.p.yes.brand.works.with.brand.and.is.being":"Yes. {retailistAi} works with {retailistDesktop}, and is being prepared as a {shopify} app and a {wooCommerce} plugin, so product images can be refined from the store admin you already use.","retailist.ai.main.content.p.you.get.a.finished.photo.of.the.model":"You get a finished photo of the model wearing your garment, keeping its colour, shape and details.","retailist.ai.main.content.span.explore.brand":"Explore {retailistApp} <slot1></slot1>","retailist.ai.main.content.span.explore.brand.2":"Explore {retailistStore} <slot1></slot1>","retailist.ai.main.content.span.explore.brand.3":"Explore {retailistCloud} <slot1></slot1>","retailist.ai.main.content.span.product.brand.start.shop.counter.return.clean.cutout":"<slot1><slot2>Product</slot2><slot3>{arcSpeaker}</slot3></slot1> <slot4><slot5>Start</slot5><slot6>Shop counter</slot6></slot4> <slot7><slot8>Return</slot8><slot9>Clean cutout</slot9></slot7> <slot10><slot11>Selected action</slot11><slot12><slot13>Remove background</slot13><slot14>No prompt needed</slot14></slot12></slot10> <slot15>Cut out the product cleanly, including the awkward edges around handles and controls.</slot15> <slot16><slot17></slot17> Review and export</slot16>","retailist.ai.main.content.span.this.page":"This page <slot1></slot1>","retailist.ai.main.content.span.you.are.here":"You are here","retailist.ai.main.content.summary.does.every.creative.tool.run.locally":"Does every creative tool run locally?<slot1></slot1>","retailist.ai.main.content.summary.does.it.work.with.brand.and.brand":"Does it work with {shopify} and {wooCommerce}?<slot1></slot1>","retailist.ai.main.content.summary.how.does.it.fit.into.the.brand.suite":"How does it fit into the {retailist} suite?<slot1></slot1>","retailist.ai.main.content.summary.when.will.brand.be.available":"When will {retailistAi} be available?<slot1></slot1>","retailist.ai.metadata.title.brand.coming.soon.brand":"{retailistAi} | Coming soon | {algorithmicNetwork}","retailist.ai.suite.heading.h2.four.products.one.connected.business":"Four products<slot1>,</slot1> <slot2>one connected business<slot3>.</slot3></slot2>","retailist.ai.tryon.heading.h2.your.garment.on.a.model":"Your garment<slot1>,</slot1> <slot2>on a model<slot3>.</slot3></slot2>","retailist.app.a.skip.to.main.content":"Skip to main content","retailist.app.attr.content.brand.is.being.built.to.bring.products.inventory":"{retailistApp} is being built to bring products, inventory, orders and daily retail work into one desktop workspace. Local tools remain useful independently of optional online services. Coming soon.","retailist.app.cta.heading.h2.coming.soon":"Coming <slot1>soon<slot2>.</slot2></slot1>","retailist.app.does.heading.h2.built.for.the.way.retail.really.works":"Built for the way <slot1>retail really works<slot2>.</slot2></slot1>","retailist.app.faq.heading.h2.questions.about.brand":"Questions about <slot1>{retailistApp}<slot2>.</slot2></slot1>","retailist.app.main.content.a.ask.us.directly":"<slot1>Ask us directly</slot1><slot2></slot2>","retailist.app.main.content.aside.desktop.new.product.dashboard.overview.and.stats.products":"<slot1><slot2></slot2><slot3></slot3><slot4>Desktop</slot4></slot1> <slot5><slot6></slot6> New Product</slot5> <slot7><slot8><slot9><slot10></slot10></slot9><slot11><slot12>Dashboard</slot12><slot13>Overview and stats</slot13></slot11></slot8><slot14><slot15><slot16></slot16></slot15><slot17><slot18>Products</slot18><slot19>Catalog and publishing</slot19></slot17></slot14><slot20><slot21><slot22></slot22></slot21><slot23><slot24>Drafts</slot24><slot25>Work in progress</slot25></slot23><slot26>2</slot26></slot20><slot27><slot28><slot29></slot29></slot28><slot30><slot31>Inventory</slot31><slot32>Stock and receiving</slot32></slot30></slot27><slot33><slot34><slot35></slot35></slot34><slot36><slot37>Orders and Sales</slot37><slot38>Orders, POS and returns</slot38></slot36><slot39>4</slot39></slot33><slot40><slot41><slot42></slot42></slot41><slot43><slot44>Inbox</slot44><slot45>Customer conversations</slot45></slot43><slot46>3</slot46></slot40><slot47><slot48><slot49></slot49></slot48><slot50><slot51>Backups</slot51><slot52>Recovery and history</slot52></slot50></slot47></slot7> <slot53><slot54>NS</slot54><slot55><slot56>{northStar}</slot56><slot57>{shopify}</slot57></slot55></slot53>","retailist.app.main.content.attr.aria.label.a.preview.of.brand.showing.the.product.catalog":"A preview of {retailistDesktop} showing the product catalog with three products.","retailist.app.main.content.attr.aria.label.brand":"{shopify}","retailist.app.main.content.attr.aria.label.brand.2":"{wooCommerce}","retailist.app.main.content.attr.aria.label.brand.3":"{retailistStore}","retailist.app.main.content.div.active.brand.travel.bags.3.variants.129.00":"<slot1><slot2></slot2><slot3><slot4>Active</slot4><slot5>{weekender}</slot5><slot6>Travel bags \xb7 3 variants</slot6><slot7><slot8>$129.00</slot8><slot9>18 in stock</slot9></slot7></slot3></slot1><slot10><slot11></slot11><slot12><slot13>Active</slot13><slot14>{marigold}</slot14><slot15>Apparel \xb7 4 variants</slot15><slot16><slot17>$88.00</slot17><slot18>9 in stock</slot18></slot16></slot12></slot10><slot19><slot20></slot20><slot21><slot22>Active</slot22><slot23>{fieldJacket}</slot23><slot24>Outerwear \xb7 5 variants</slot24><slot25><slot26>$164.00</slot26><slot27>12 in stock</slot27></slot25></slot21></slot19>","retailist.app.main.content.div.catalog.products.create.edit.validate.and.publish.products":"<slot1><slot2>Catalog</slot2><slot3>Products</slot3><slot4>Create, edit, validate and publish products to connected destinations.</slot4></slot1><slot5><slot6></slot6> Add Product</slot5>","retailist.app.main.content.div.get.launch.updates.explore.the.suite":"<slot1>Get launch updates <slot2></slot2></slot1> <slot3>Explore the suite<slot4> (opens in a new tab)</slot4><slot5></slot5></slot3>","retailist.app.main.content.div.products.search.or.ask.brand.brand.mm":"<slot1>Products</slot1><slot2><slot3></slot3> Search or ask</slot2><slot4><slot5><slot6>{matt}</slot6><slot7>{northStar}</slot7></slot5><slot8>MM</slot8></slot4>","retailist.app.main.content.div.search.products.3.products.all.statuses":"<slot1><slot2></slot2> Search products</slot1><slot3>3 products</slot3><slot4>All statuses</slot4>","retailist.app.main.content.figcaption.a.concept.preview.details.may.change.before.launch":"A concept preview. Details may change before launch.","retailist.app.main.content.h1.everything.to.run.your.shop.in.one.place":"Everything to run your shop<slot1>.</slot1> <slot2>In one place<slot3>.</slot3></slot2>","retailist.app.main.content.h4.catalog":"Catalog","retailist.app.main.content.h4.connect":"Connect","retailist.app.main.content.h4.daily.work":"Daily work","retailist.app.main.content.h4.local.ai":"Local AI","retailist.app.main.content.li.local.store":"<slot1><slot2></slot2><slot3>Local store</slot3></slot1>","retailist.app.main.content.li.store":"<slot1><slot2><slot3></slot3><slot4></slot4><slot5></slot5></slot2></slot1>","retailist.app.main.content.p.a.focused.online.store.connected.to.the.catalog":"A focused online store connected to the catalog and operations you manage in {retailistApp}.","retailist.app.main.content.p.ai.tools.for.product.imagery.scenes.and.content":"AI tools for product imagery, scenes and content across catalogs, storefronts and campaigns.","retailist.app.main.content.p.brand":"<slot1></slot1> <slot2>{retailistApp}</slot2>","retailist.app.main.content.p.brand.is.coming.soon.this.page.introduces.the":"{retailistApp} is coming soon. This page introduces the intended product, and launch information will be shared when it is ready.","retailist.app.main.content.p.brand.is.designed.around.everyday.retail.work.with":"{retailistApp} is designed around everyday retail work, with privacy and clear boundaries considered from the start.","retailist.app.main.content.p.brand.is.the.operational.centre.of.the.suite":"{retailistApp} is the operational centre of the suite. {retailistStore} adds a storefront, {retailistCloud} focuses on backup and recovery, and {retailistAi} supports product content.","retailist.app.main.content.p.bring.counter.sales.orders.returns.labels.and.invoices":"Bring counter sales, orders, returns, labels and invoices into one consistent working environment.","retailist.app.main.content.p.connect.brand.brand.and.brand.or.run.a":"Connect {shopify}, {wooCommerce} and {retailistStore}, or run a standalone local store that stays useful on its own.","retailist.app.main.content.p.creative.tools.for.commerce":"Creative tools for commerce","retailist.app.main.content.p.desktop.operations":"Desktop operations","retailist.app.main.content.p.encrypted.backup":"Encrypted backup","retailist.app.main.content.p.encrypted.backups.version.history.and.recovery.for.supported":"Encrypted backups, version history and recovery for supported commerce data.","retailist.app.main.content.p.good.to.know":"Good to know","retailist.app.main.content.p.online.storefront":"Online storefront","retailist.app.main.content.p.organise.products.and.variants.manage.stock.receive.goods":"Organise products and variants, manage stock, receive goods and keep a clear record of inventory changes.","retailist.app.main.content.p.products.inventory.orders.and.daily.retail.operations.with":"Products, inventory, orders and daily retail operations, with local tools and optional connected services.","retailist.app.main.content.p.products.stock.point.of.sale.orders.and.reports":"Products, stock, point of sale, orders and reports in one desktop app for {macOs}, {windows} and {linux}. Run it as a local store, or connect {shopify}, {wooCommerce} and {retailistStore}.","retailist.app.main.content.p.run.locally.or.connect":"Run locally or connect","retailist.app.main.content.p.run.the.shop.floor.sell.online.protect.your":"Run the shop floor, sell online, protect your data and create with AI. Each product works on its own and better together.","retailist.app.main.content.p.the.brand.suite":"The {retailist} suite","retailist.app.main.content.p.the.desktop.workspace.is.designed.to.be.useful":"The desktop workspace is designed to be useful on its own. Connected channels and hosted services add capabilities, each with its own connectivity, permissions and processing requirements.","retailist.app.main.content.p.use.local.ai.to.work.with.business.information":"Use local AI to work with business information on your device. Additional hosted tools have separate processing and connectivity requirements.","retailist.app.main.content.p.we.are.preparing.brand.for.release.explore.the":"We are preparing {retailistApp} for release. Explore the suite to see how its products fit together, or ask us to keep you posted.","retailist.app.main.content.p.what.it.does":"What it does","retailist.app.main.content.p.what.to.expect.from.brand.and.how.it":"What to expect from {retailistApp} and how it fits with the rest of {retailist}.","retailist.app.main.content.span.explore.brand":"Explore {retailistStore} <slot1></slot1>","retailist.app.main.content.span.explore.brand.2":"Explore {retailistCloud} <slot1></slot1>","retailist.app.main.content.span.explore.brand.3":"Explore {retailistAi} <slot1></slot1>","retailist.app.main.content.span.this.page":"This page <slot1></slot1>","retailist.app.main.content.span.you.are.here":"You are here","retailist.app.main.content.summary.how.do.local.and.online.services.work.together":"How do local and online services work together?<slot1></slot1>","retailist.app.main.content.summary.how.does.it.fit.into.the.brand.suite":"How does it fit into the {retailist} suite?<slot1></slot1>","retailist.app.main.content.summary.when.will.brand.be.available":"When will {retailistApp} be available?<slot1></slot1>","retailist.app.metadata.title.brand.coming.soon.brand":"{retailistApp} | Coming soon | {algorithmicNetwork}","retailist.app.suite.heading.h2.four.products.one.connected.business":"Four products<slot1>,</slot1> <slot2>one connected business<slot3>.</slot3></slot2>","retailist.cloud.a.skip.to.main.content":"Skip to main content","retailist.cloud.attr.content.brand.is.a.planned.encrypted.backup.service.for":"{retailistCloud} is a planned encrypted backup service for supported commerce data. It is designed to preserve useful history and make recovery a deliberate, understandable process. Coming soon.","retailist.cloud.cta.heading.h2.coming.soon":"Coming <slot1>soon<slot2>.</slot2></slot1>","retailist.cloud.does.heading.h2.built.for.the.way.retail.really.works":"Built for the way <slot1>retail really works<slot2>.</slot2></slot1>","retailist.cloud.faq.heading.h2.questions.about.brand":"Questions about <slot1>{retailistCloud}<slot2>.</slot2></slot1>","retailist.cloud.main.content.a.ask.us.directly":"<slot1>Ask us directly</slot1><slot2></slot2>","retailist.cloud.main.content.attr.aria.label.a.preview.of.a.brand.backup.with.a":"A preview of a {retailistCloud} backup with a verified, encrypted restore point.","retailist.cloud.main.content.attr.aria.label.brand":"{retailistDesktop}","retailist.cloud.main.content.attr.aria.label.brand.2":"{shopify}","retailist.cloud.main.content.attr.aria.label.brand.3":"{wooCommerce}","retailist.cloud.main.content.div.backup.brand.verified":"<slot1>Backup \xb7 {atelier}</slot1><slot2><slot3></slot3>Verified</slot2>","retailist.cloud.main.content.div.get.launch.updates.explore.the.suite":"<slot1>Get launch updates <slot2></slot2></slot1> <slot3>Explore the suite<slot4> (opens in a new tab)</slot4><slot5></slot5></slot3>","retailist.cloud.main.content.div.latest.restore.point.today.18.42.verified.by":"<slot1><slot2>Latest restore point</slot2><slot3>Today \xb7 18:42</slot3><slot4>Verified by an authorised client</slot4></slot1><slot5><slot6></slot6></slot5>","retailist.cloud.main.content.figcaption.a.concept.preview.details.may.change.before.launch":"A concept preview. Details may change before launch.","retailist.cloud.main.content.h1.encrypted.backups.clear.recovery":"Encrypted backups<slot1>,</slot1> <slot2>clear recovery<slot3>.</slot3></slot2>","retailist.cloud.main.content.h4.encrypt":"Encrypt","retailist.cloud.main.content.h4.history":"History","retailist.cloud.main.content.h4.restore":"Restore","retailist.cloud.main.content.h4.storage":"Storage","retailist.cloud.main.content.li.brand.app":"<slot1><slot2></slot2><slot3></slot3></slot1><slot4>{shopify} app</slot4>","retailist.cloud.main.content.li.brand.plugin":"<slot1><slot2></slot2></slot1><slot3>{wooCommerce} plugin</slot3>","retailist.cloud.main.content.li.desktop.desktop.app":"<slot1><slot2><slot3></slot3><slot4></slot4><slot5></slot5></slot2></slot1><slot6>Desktop app</slot6>","retailist.cloud.main.content.p.a.focused.online.store.connected.to.the.catalog":"A focused online store connected to the catalog and operations you manage in {retailistApp}.","retailist.cloud.main.content.p.ai.tools.for.product.imagery.scenes.and.content":"AI tools for product imagery, scenes and content across catalogs, storefronts and campaigns.","retailist.cloud.main.content.p.backup.content.is.designed.to.be.encrypted.by":"Backup content is designed to be encrypted by an authorised client before upload. Storage location and access to readable contents are separate concerns.","retailist.cloud.main.content.p.brand":"<slot1></slot1> <slot2>{retailistCloud}</slot2>","retailist.cloud.main.content.p.brand.complements.the.desktop.and.supported.commerce.channels":"{retailistCloud} complements the desktop and supported commerce channels. Its role is backup and recovery, while {retailistApp} remains the workspace for daily operations.","retailist.cloud.main.content.p.brand.is.coming.soon.this.page.introduces.the":"{retailistCloud} is coming soon. This page introduces the intended product, and launch information will be shared when it is ready.","retailist.cloud.main.content.p.brand.is.designed.around.everyday.retail.work.with":"{retailistCloud} is designed around everyday retail work, with privacy and clear boundaries considered from the start.","retailist.cloud.main.content.p.brand.supports.local.and.customer.owned.backup.destinations":"{retailist} supports local and customer owned backup destinations. Managed {retailistCloud} storage is a planned additional service with its own launch requirements.","retailist.cloud.main.content.p.creative.tools.for.commerce":"Creative tools for commerce","retailist.cloud.main.content.p.desktop.operations":"Desktop operations","retailist.cloud.main.content.p.encrypted.backup":"Encrypted backup","retailist.cloud.main.content.p.encrypted.backups.and.version.history.for.a.considered":"Encrypted backups and version history for a considered recovery plan, with access and storage choices made clear from the start.","retailist.cloud.main.content.p.encrypted.backups.version.history.and.recovery.for.supported":"Encrypted backups, version history and recovery for supported commerce data.","retailist.cloud.main.content.p.good.to.know":"Good to know","retailist.cloud.main.content.p.keep.restore.points.for.supported.catalog.and.commerce":"Keep restore points for supported catalog and commerce records, so earlier states can be examined when something changes.","retailist.cloud.main.content.p.online.storefront":"Online storefront","retailist.cloud.main.content.p.products.inventory.orders.and.daily.retail.operations.with":"Products, inventory, orders and daily retail operations, with local tools and optional connected services.","retailist.cloud.main.content.p.recovery.depends.on.the.contents.of.the.backup":"Recovery depends on the contents of the backup, the supported restore workflow and access to the required keys. Managed storage is a planned service, distinct from local and customer owned backup destinations.","retailist.cloud.main.content.p.review.available.history.and.restore.supported.data.through":"Review available history and restore supported data through a controlled workflow. Recovery depends on the backup contents and access to the required keys.","retailist.cloud.main.content.p.run.the.shop.floor.sell.online.protect.your":"Run the shop floor, sell online, protect your data and create with AI. Each product works on its own and better together.","retailist.cloud.main.content.p.the.brand.suite":"The {retailist} suite","retailist.cloud.main.content.p.we.are.preparing.brand.for.release.explore.the":"We are preparing {retailistCloud} for release. Explore the suite to see how its products fit together, or ask us to keep you posted.","retailist.cloud.main.content.p.what.it.does":"What it does","retailist.cloud.main.content.p.what.to.expect.from.brand.and.how.it":"What to expect from {retailistCloud} and how it fits with the rest of {retailist}.","retailist.cloud.main.content.p.works.with.your.desktop.and.your.store":"Works with your desktop and your store","retailist.cloud.main.content.p.yes.brand.works.with.brand.and.is.being":"Yes. {retailistCloud} works with {retailistDesktop}, and is being prepared as a {shopify} app and a {wooCommerce} plugin, so supported store records can be protected from the admin you already use.","retailist.cloud.main.content.span.01.catalog.8.412.objects.encrypted.02.orders":"<slot1><slot2>01</slot2><slot3><slot4>Catalog</slot4><slot5>8,412 objects</slot5></slot3><slot6>Encrypted</slot6></slot1> <slot7><slot8>02</slot8><slot9><slot10>Orders</slot10><slot11>34,921 records</slot11></slot9><slot12>Encrypted</slot12></slot7> <slot13><slot14>03</slot14><slot15><slot16>Storefront assets</slot16><slot17>2.8 GB</slot17></slot15><slot18>Encrypted</slot18></slot13>","retailist.cloud.main.content.span.explore.brand":"Explore {retailistApp} <slot1></slot1>","retailist.cloud.main.content.span.explore.brand.2":"Explore {retailistStore} <slot1></slot1>","retailist.cloud.main.content.span.explore.brand.3":"Explore {retailistAi} <slot1></slot1>","retailist.cloud.main.content.span.storage.brand.stored.contents.encrypted":"<slot1><slot2>Storage</slot2><slot3>{retailistCloud}</slot3></slot1><slot4><slot5>Stored contents</slot5><slot6>Encrypted</slot6></slot4>","retailist.cloud.main.content.span.this.page":"This page <slot1></slot1>","retailist.cloud.main.content.span.you.are.here":"You are here","retailist.cloud.main.content.summary.does.it.work.with.brand.and.brand":"Does it work with {shopify} and {wooCommerce}?<slot1></slot1>","retailist.cloud.main.content.summary.how.does.it.fit.into.the.brand.suite":"How does it fit into the {retailist} suite?<slot1></slot1>","retailist.cloud.main.content.summary.what.does.recovery.require":"What does recovery require?<slot1></slot1>","retailist.cloud.main.content.summary.when.will.brand.be.available":"When will {retailistCloud} be available?<slot1></slot1>","retailist.cloud.metadata.title.brand.coming.soon.brand":"{retailistCloud} | Coming soon | {algorithmicNetwork}","retailist.cloud.suite.heading.h2.four.products.one.connected.business":"Four products<slot1>,</slot1> <slot2>one connected business<slot3>.</slot3></slot2>","retailist.store.a.skip.to.main.content":"Skip to main content","retailist.store.attr.content.brand.is.a.hosted.storefront.designed.for.businesses":"{retailistStore} is a hosted storefront designed for businesses that want a focused way to present products and sell online, connected to the operations managed in {retailistApp}. Coming soon.","retailist.store.cta.heading.h2.coming.soon":"Coming <slot1>soon<slot2>.</slot2></slot1>","retailist.store.does.heading.h2.built.for.the.way.retail.really.works":"Built for the way <slot1>retail really works<slot2>.</slot2></slot1>","retailist.store.faq.heading.h2.questions.about.brand":"Questions about <slot1>{retailistStore}<slot2>.</slot2></slot1>","retailist.store.main.content.a.ask.us.directly":"<slot1>Ask us directly</slot1><slot2></slot2>","retailist.store.main.content.attr.aria.label.a.preview.of.a.brand.storefront.for.a":"A preview of a {retailistStore} storefront for a shop called Mori.","retailist.store.main.content.attr.aria.label.brand":"{retailistDesktop}","retailist.store.main.content.div.brand.88.brand.64.brand.240":"<slot1><slot2></slot2><slot3><slot4>{halo}</slot4><slot5>$88</slot5></slot3></slot1> <slot6><slot7></slot7><slot8><slot9>{afterRain}</slot9><slot10>$64</slot10></slot8></slot6> <slot11><slot12></slot12><slot13><slot14>{cobaltTrench}</slot14><slot15>$240</slot15></slot13></slot11>","retailist.store.main.content.div.brand.live":"<slot1></slot1><slot2></slot2><slot3></slot3><slot4>{moriDomain}</slot4><slot5><slot6></slot6>Live</slot5>","retailist.store.main.content.div.brand.new.objects.journal.bag.2":"<slot1>{mori}</slot1><slot2>New</slot2><slot3>Objects</slot3><slot4>Journal</slot4><slot5>Bag \xb7 2</slot5>","retailist.store.main.content.div.catalog.and.stock.from.brand.in.sync":"<slot1>Catalog and stock from {retailistDesktop}</slot1><slot2><slot3></slot3>In sync</slot2>","retailist.store.main.content.div.get.launch.updates.explore.the.suite":"<slot1>Get launch updates <slot2></slot2></slot1> <slot3>Explore the suite<slot4> (opens in a new tab)</slot4><slot5></slot5></slot3>","retailist.store.main.content.div.new.season.06.objects.for.a.brighter.day":"<slot1></slot1><slot2><slot3>New season / 06</slot3><slot4>Objects for a brighter day.</slot4><slot5>Shop the edit <slot6></slot6></slot5></slot2>","retailist.store.main.content.figcaption.a.concept.preview.details.may.change.before.launch":"A concept preview. Details may change before launch.","retailist.store.main.content.h1.sell.online.connected.to.your.shop":"Sell online<slot1>,</slot1> <slot2>connected to your shop<slot3>.</slot3></slot2>","retailist.store.main.content.h4.catalog":"Catalog","retailist.store.main.content.h4.daily.work":"Daily work","retailist.store.main.content.h4.selling.modes":"Selling modes","retailist.store.main.content.h4.the.shop":"The shop","retailist.store.main.content.li.desktop":"<slot1><slot2><slot3></slot3><slot4></slot4><slot5></slot5></slot2></slot1>","retailist.store.main.content.p.a.focused.online.store.connected.to.the.catalog":"A focused online store connected to the catalog and operations you manage in {retailistApp}.","retailist.store.main.content.p.a.focused.online.storefront.connected.to.the.business":"A focused online storefront connected to the business behind it, managed with {retailist} on your desktop. Present your products beautifully without juggling unrelated extensions.","retailist.store.main.content.p.ai.tools.for.product.imagery.scenes.and.content":"AI tools for product imagery, scenes and content across catalogs, storefronts and campaigns.","retailist.store.main.content.p.brand":"<slot1></slot1> <slot2>{retailistStore}</slot2>","retailist.store.main.content.p.brand.is.coming.soon.this.page.introduces.the":"{retailistStore} is coming soon. This page introduces the intended product, and launch information will be shared when it is ready.","retailist.store.main.content.p.brand.is.designed.around.everyday.retail.work.with":"{retailistStore} is designed around everyday retail work, with privacy and clear boundaries considered from the start.","retailist.store.main.content.p.brand.is.the.online.storefront.of.the.suite":"{retailistStore} is the online storefront of the suite. {retailistApp} manages the business behind it, {retailistAi} supports product presentation and {retailistCloud} adds backup and recovery.","retailist.store.main.content.p.choose.an.online.catalog.contact.based.ordering.or":"Choose an online catalog, contact based ordering or supported checkout, according to the capabilities available for your business.","retailist.store.main.content.p.creative.tools.for.commerce":"Creative tools for commerce","retailist.store.main.content.p.desktop.operations":"Desktop operations","retailist.store.main.content.p.encrypted.backup":"Encrypted backup","retailist.store.main.content.p.encrypted.backups.version.history.and.recovery.for.supported":"Encrypted backups, version history and recovery for supported commerce data.","retailist.store.main.content.p.good.to.know":"Good to know","retailist.store.main.content.p.managed.from":"Managed from","retailist.store.main.content.p.online.storefront":"Online storefront","retailist.store.main.content.p.present.your.products.through.curated.themes.and.clear":"Present your products through curated themes and clear design controls, without managing a collection of unrelated extensions.","retailist.store.main.content.p.products.inventory.orders.and.daily.retail.operations.with":"Products, inventory, orders and daily retail operations, with local tools and optional connected services.","retailist.store.main.content.p.publish.selected.products.from.brand.and.keep.the":"Publish selected products from {retailist} and keep the public storefront connected to the business that manages them.","retailist.store.main.content.p.run.the.shop.floor.sell.online.protect.your":"Run the shop floor, sell online, protect your data and create with AI. Each product works on its own and better together.","retailist.store.main.content.p.storefront.content.is.public.by.design.private.operational":"Storefront content is public by design. Private operational records and customer information have separate access and delivery controls.","retailist.store.main.content.p.the.brand.suite":"The {retailist} suite","retailist.store.main.content.p.use.brand.for.stock.sales.and.daily.operations":"Use {retailistApp} for stock, sales and daily operations, with the storefront acting as an online sales channel.","retailist.store.main.content.p.we.are.preparing.brand.for.release.explore.the":"We are preparing {retailistStore} for release. Explore the suite to see how its products fit together, or ask us to keep you posted.","retailist.store.main.content.p.what.it.does":"What it does","retailist.store.main.content.p.what.to.expect.from.brand.and.how.it":"What to expect from {retailistStore} and how it fits with the rest of {retailist}.","retailist.store.main.content.span.explore.brand":"Explore {retailistApp} <slot1></slot1>","retailist.store.main.content.span.explore.brand.2":"Explore {retailistCloud} <slot1></slot1>","retailist.store.main.content.span.explore.brand.3":"Explore {retailistAi} <slot1></slot1>","retailist.store.main.content.span.this.page":"This page <slot1></slot1>","retailist.store.main.content.span.you.are.here":"You are here","retailist.store.main.content.summary.how.does.it.fit.into.the.brand.suite":"How does it fit into the {retailist} suite?<slot1></slot1>","retailist.store.main.content.summary.how.is.public.and.private.information.kept.apart":"How is public and private information kept apart?<slot1></slot1>","retailist.store.main.content.summary.when.will.brand.be.available":"When will {retailistStore} be available?<slot1></slot1>","retailist.store.metadata.title.brand.coming.soon.brand":"{retailistStore} | Coming soon | {algorithmicNetwork}","retailist.store.suite.heading.h2.four.products.one.connected.business":"Four products<slot1>,</slot1> <slot2>one connected business<slot3>.</slot3></slot2>","services.advise.heading.h3.advise":"Advise","services.services.a.ai.consulting":"<slot1>AI consulting</slot1><slot2></slot2>","services.services.a.ai.development":"<slot1>AI development</slot1><slot2></slot2>","services.services.a.talk.to.us":"Talk to us <slot1></slot1>","services.services.attr.aria.label.examples":"Examples","services.services.h3.build":"Build","services.services.h4.ai.feasibility":"AI feasibility","services.services.h4.ai.product.development":"AI product development","services.services.h4.ai.strategy":"AI strategy","services.services.h4.ai.workflow.integration":"AI workflow integration","services.services.h4.cloud.ai.with.safeguards":"Cloud AI, with safeguards","services.services.h4.data.readiness":"Data readiness","services.services.h4.local.ai.development":"Local AI development","services.services.h4.private.ai.systems":"Private AI systems","services.services.h4.private.deployment":"Private deployment","services.services.heading.h2.from.first.question.to.private.production":"From first question to <slot1>private production.</slot1>","services.services.li.desktop.apps":"Desktop apps","services.services.li.document.search":"Document search","services.services.li.offline.assistants":"Offline assistants","services.services.li.on.device.vision":"On device vision","services.services.p.ai.inside.controlled.environments.with.deliberate.choices.about":"AI inside controlled environments, with deliberate choices about data access, deployment and who operates it.","services.services.p.assess.a.specific.use.case.its.expected.value":"Assess a specific use case, its expected value and the assumptions a prototype needs to test.","services.services.p.assess.data.quality.permissions.and.preparation.for.retrieval":"Assess data quality, permissions and preparation for retrieval, custom models and fine-tuning.","services.services.p.assistants.and.analysis.tools.that.run.on.your":"Assistants and analysis tools that run on your devices, sized to your hardware, your task and the information you want to keep close.","services.services.p.custom.model.development.fine.tuning.and.complete.ai":"Custom model development, fine-tuning and complete AI products, from dataset preparation and evaluation to deployment.","services.services.p.evaluate.local.execution.and.private.environments.around.your":"Evaluate local execution and private environments around your information and operating needs.","services.services.p.knowledge.search.document.assistance.and.focused.automation.that":"Knowledge search, document assistance and focused automation that fit the way your team already works, with references and human review for important actions.","services.services.p.not.sure.where.to.start.a.short.call":"Not sure where to start? A short call is usually enough to find the right first step.","services.services.p.plan.the.next.step.with.clear.evaluation.criteria":"Plan the next step with clear evaluation criteria, dependencies and operating costs.","services.services.p.services":"Services","services.services.p.two.ways.to.work.with.us.we.advise":"Two ways to work with us. We advise when you need clarity, and we build when you need software that works on day one, locally, privately or in the cloud.","services.services.p.when.local.is.not.enough.we.integrate.hosted":"When local is not enough, we integrate hosted models with minimal data sharing, clear provider terms and the same review steps.","solutions.products.heading.h2.our.own.products.built.the.same.way":"Our own products, <slot1>built the same way.</slot1>","solutions.solutions.a.let.s.talk":"Let\u2019s talk <slot1></slot1>","solutions.solutions.a.visit.brand":"<slot1>Visit {fynlink}</slot1><slot2></slot2>","solutions.solutions.a.visit.brand.opens.in.a.new.tab":"<slot1>Visit {localAts}<slot2> (opens in a new tab)</slot2></slot1><slot3></slot3>","solutions.solutions.div.beta":"<slot1><slot2></slot2></slot1> <slot3>Beta</slot3>","solutions.solutions.div.live":"<slot1><slot2></slot2></slot1> <slot3><slot4></slot4>Live</slot3>","solutions.solutions.h4.have.a.product.in.mind":"Have a product in mind?","solutions.solutions.p.a.family.of.products.for.commerce.run.the":"A family of products for commerce. Run the shop floor, sell online, protect your data and create with AI, all from one connected suite.","solutions.solutions.p.a.focused.online.store.connected.to.the.catalog":"A focused online store connected to the catalog and operations you manage in {retailistApp}.","solutions.solutions.p.ai.tools.for.product.imagery.scenes.and.content":"AI tools for product imagery, scenes and content across catalogs, storefronts and campaigns.","solutions.solutions.p.encrypted.backups.version.history.and.recovery.for.supported":"Encrypted backups, version history and recovery for supported commerce data, with clear storage and access boundaries.","solutions.solutions.p.free.and.open.source.compare.your.resume.with":"Free and open source. Compare your resume with a job description privately in your browser, powered by our custom models.","solutions.solutions.p.private.ai.resume.analysis.in.your.browser":"Private AI resume analysis in your browser","solutions.solutions.p.private.link.shortener":"Private link shortener","solutions.solutions.p.product.family":"Product family","solutions.solutions.p.products":"Products","solutions.solutions.p.products.inventory.orders.and.daily.retail.operations.with":"Products, inventory, orders and daily retail operations, with local tools and optional connected services.","solutions.solutions.p.short.secure.links.with.end.to.end.encryption":"Short, secure links with end to end encryption and analytics that respect your visitors. No ads and no trackers.","solutions.solutions.p.we.build.and.run.products.on.the.principles":"We build and run products on the principles we bring to client work. Private by default, useful every day, and designed for the people who rely on them.","solutions.solutions.p.we.partner.with.founders.and.teams.to.build":"We partner with founders and teams to build private, AI native products, from the first prototype to launch.","solutions.solutions.span.creative.tools.for.commerce":"Creative tools for commerce","solutions.solutions.span.desktop.operations":"Desktop operations","solutions.solutions.span.encrypted.backup":"Encrypted backup","solutions.solutions.span.explore.brand":"Explore {retailistApp} <slot1></slot1>","solutions.solutions.span.explore.brand.2":"Explore {retailistStore} <slot1></slot1>","solutions.solutions.span.explore.brand.3":"Explore {retailistCloud} <slot1></slot1>","solutions.solutions.span.explore.brand.4":"Explore {retailistAi} <slot1></slot1>","solutions.solutions.span.online.storefront":"Online storefront","theme.darkMode":"Dark mode","theme.switchToDark":"Switch to dark mode","theme.switchToLight":"Switch to light mode","tos.acceptance.h3.1.acceptance.of.terms":"1. Acceptance of Terms","tos.acceptance.p.by.accessing.or.using.brand.s.website.products":"By accessing or using {algorithmicNetwork}\'s website, products, or services, you acknowledge that you have read, understood, and agree to be bound by these Terms, as well as our Privacy Policy.","tos.acceptance.p.welcome.to.brand.these.terms.of.service.terms":"Welcome to {algorithmicNetwork}. These Terms of Service (\\"Terms\\") govern your use of our website, products, and services. By accessing or using our website, you agree to be bound by these Terms. If you do not agree with any part of these Terms, you may not use our services.","tos.attr.content.brand.s.terms.of.service.legal.terms.governing":"{algorithmicNetwork}\'s Terms of Service - Legal terms governing the use of our website and services.","tos.confidentiality.h3.6.confidentiality":"6. Confidentiality","tos.confidentiality.p.for.client.projects.we.will.provide.a.separate":"For client projects, we will provide a separate non-disclosure agreement that outlines our specific confidentiality obligations.","tos.confidentiality.p.we.understand.the.sensitive.nature.of.the.projects":"We understand the sensitive nature of the projects and information you may share with us. We commit to maintaining the confidentiality of all information provided to us during the course of our business relationship.","tos.contact.info.h3.11.contact.information":"11. Contact Information","tos.contact.info.p.if.you.have.any.questions.about.these.terms":"If you have any questions about these Terms, please contact us at <slot1>{legalEmail}</slot1>.","tos.governing.law.h3.10.governing.law":"10. Governing Law","tos.governing.law.p.these.terms.shall.be.governed.by.and.construed":"These Terms shall be governed by and construed in accordance with the laws of the jurisdiction in which {algorithmicNetwork} is registered, without regard to its conflict of law provisions.","tos.indemnification.h3.8.indemnification":"8. Indemnification","tos.indemnification.p.you.agree.to.defend.indemnify.and.hold.harmless":"You agree to defend, indemnify, and hold harmless {algorithmicNetwork}, its officers, directors, employees, and agents, from and against any claims, liabilities, damages, losses, and expenses, including, without limitation, reasonable legal and accounting fees, arising out of or in any way connected with your access to or use of our services or your violation of these Terms.","tos.intellectual.property.h3.5.intellectual.property":"5. Intellectual Property","tos.intellectual.property.p.all.content.on.our.website.including.but.not":"All content on our website, including but not limited to text, graphics, logos, icons, images, audio clips, digital downloads, and software, is the property of {algorithmicNetwork} or its content suppliers and is protected by international copyright laws.","tos.intellectual.property.p.the.compilation.of.all.content.on.this.site":"The compilation of all content on this site is the exclusive property of {algorithmicNetwork} and is protected by international copyright laws. Our trademarks and trade dress may not be used in connection with any product or service without the prior written consent of {algorithmicNetwork}.","tos.limitation.of.liability.h3.7.limitation.of.liability":"7. Limitation of Liability","tos.limitation.of.liability.li.any.conduct.or.content.of.any.third.party":"Any conduct or content of any third party on our services","tos.limitation.of.liability.li.any.content.obtained.from.our.services":"Any content obtained from our services","tos.limitation.of.liability.li.unauthorized.access.use.or.alteration.of.your.transmissions":"Unauthorized access, use, or alteration of your transmissions or content","tos.limitation.of.liability.li.your.access.to.or.use.of.or.inability":"Your access to or use of or inability to access or use our services","tos.limitation.of.liability.p.to.the.fullest.extent.permitted.by.law.brand":"To the fullest extent permitted by law, {algorithmicNetwork} shall not be liable for any indirect, incidental, special, consequential, or punitive damages, or any loss of profits or revenues, whether incurred directly or indirectly, or any loss of data, use, goodwill, or other intangible losses, resulting from:","tos.main.content.div.legal":"LEGAL","tos.main.content.h1.terms.of.service":"Terms of Service","tos.main.content.p.last.updated.may.19.2025":"Last updated: May 19, 2025","tos.main.content.p.these.terms.of.service.govern.your.use.of":"These Terms of Service govern your use of our website and services.","tos.metadata.title.terms.of.service.brand":"Terms of Service | {algorithmicNetwork}","tos.modifications.h3.9.modifications.to.terms":"9. Modifications to Terms","tos.modifications.p.we.reserve.the.right.to.modify.these.terms":"We reserve the right to modify these Terms at any time. We will provide notice of any material changes by posting the updated Terms on our website. Your continued use of our services after such modifications will constitute your acknowledgment of the modified Terms and agreement to abide by them.","tos.project.engagement.h3.3.project.engagement":"3. Project Engagement","tos.project.engagement.li.alignment.with.our.expertise.and.services":"Alignment with our expertise and services","tos.project.engagement.li.current.availability.of.our.resources.and.team.members":"Current availability of our resources and team members","tos.project.engagement.li.project.timeline.and.requirements":"Project timeline and requirements","tos.project.engagement.li.the.nature.and.scope.of.the.project":"The nature and scope of the project","tos.project.engagement.p.contacting.brand.or.submitting.a.project.inquiry.does":"Contacting {algorithmicNetwork} or submitting a project inquiry does not guarantee that we will undertake your project. Our decision to engage in a project depends on various factors, including but not limited to:","tos.project.engagement.p.we.reserve.the.right.to.decline.any.project":"We reserve the right to decline any project at our sole discretion. If we decide to proceed with your project, we will provide a separate agreement outlining the specific terms, deliverables, timeline, and compensation.","tos.services.description.h3.2.services.description":"2. Services Description","tos.services.description.li.custom.software.solutions":"Custom software solutions","tos.services.description.li.enterprise.workflow.optimization":"Enterprise workflow optimization","tos.services.description.li.privacy.focused.software.development":"Privacy-focused software development","tos.services.description.li.security.consulting.and.implementation":"Security consulting and implementation","tos.services.description.p.brand.provides.consultancy.services.in.privacy.first.development":"{algorithmicNetwork} provides consultancy services in privacy-first development, secure communication systems, and enterprise workflow solutions. Our services may include but are not limited to:","tos.tos.nav.h2.on.this.page":"On this page","tos.tos.nav.li.acceptance.of.terms":"<slot1>Acceptance of Terms</slot1>","tos.tos.nav.li.confidentiality":"<slot1>Confidentiality</slot1>","tos.tos.nav.li.contact":"<slot1>Contact</slot1>","tos.tos.nav.li.governing.law":"<slot1>Governing Law</slot1>","tos.tos.nav.li.indemnification":"<slot1>Indemnification</slot1>","tos.tos.nav.li.intellectual.property":"<slot1>Intellectual Property</slot1>","tos.tos.nav.li.limitation.of.liability":"<slot1>Limitation of Liability</slot1>","tos.tos.nav.li.modifications":"<slot1>Modifications</slot1>","tos.tos.nav.li.project.engagement":"<slot1>Project Engagement</slot1>","tos.tos.nav.li.services.description":"<slot1>Services Description</slot1>","tos.tos.nav.li.user.conduct":"<slot1>User Conduct</slot1>","tos.user.conduct.h3.4.user.conduct":"4. User Conduct","tos.user.conduct.li.attempt.to.gain.unauthorized.access.to.our.systems":"Attempt to gain unauthorized access to our systems or user accounts","tos.user.conduct.li.engage.in.activities.that.could.disable.overburden.or":"Engage in activities that could disable, overburden, or impair our services","tos.user.conduct.li.infringe.upon.the.rights.of.others":"Infringe upon the rights of others","tos.user.conduct.li.transmit.malware.viruses.or.other.harmful.code":"Transmit malware, viruses, or other harmful code","tos.user.conduct.li.use.our.services.for.any.illegal.or.unauthorized":"Use our services for any illegal or unauthorized purpose","tos.user.conduct.li.violate.any.applicable.laws.or.regulations":"Violate any applicable laws or regulations","tos.user.conduct.p.when.using.our.website.or.services.you.agree":"When using our website or services, you agree not to:","booking.title":"Book a session","booking.intro":"A conversation about your project and the right next steps.","booking.video":"Video call","booking.fallback":"Open in {calCom}","booking.close":"Close booking","booking.schedule":"Choose a date and time","booking.timezone":"Time zone","booking.searchTimezones":"Search time zones","booking.noTimezones":"No matching time zones.","booking.previousMonth":"Previous month","booking.nextMonth":"Next month","booking.retry":"Try again","booking.continue":"Continue","booking.back":"Change date or time","booking.details":"Your details","booking.name":"Name","booking.email":"Email address","booking.topic":"What would you like to discuss?","booking.notes":"Additional details (optional)","booking.privacy":"Your details are shared with {calCom} to schedule and conduct this meeting.","booking.privacyLink":"Privacy policy","booking.acceptTerms":"I agree to {calCom}\u2019s <slot1>Terms of Service</slot1> and have read its <slot2>Privacy Policy</slot2> and the <slot3>site\u2019s Privacy Policy</slot3>.","booking.termsRequired":"Please accept the terms and acknowledge the privacy policies.","booking.confirm":"Confirm booking","booking.meeting":"Meeting link","booking.done":"Done","booking.duration":"{minutes} min","booking.selectPrompt":"Choose a time that works for you.","booking.selection":"{date}\\n{time}\\n{zone}","booking.dayLabel":"{date}: {count, plural, =0 {no available times} one {# available time} other {# available times}}","booking.loading":"Loading available times\u2026","booking.chooseTime":"Select a date, then choose a time.","booking.noSlots":"No times are available this month. Try another month.","booking.loadFailed":"We couldn\u2019t load available times. Try again or open the booking page in {calCom}.","booking.required":"Please fill in this field.","booking.emailInvalid":"Please enter a valid email address.","booking.submitting":"Confirming your booking\u2026","booking.unavailable":"This time is no longer available. Please choose another time.","booking.rateLimit":"Too many requests. Please wait a moment and try again.","booking.uncertain":"We couldn\u2019t confirm the result. Check your confirmation email before making another booking.","booking.bookingFailed":"We couldn\u2019t complete your booking. Check your details or open the booking page in {calCom}.","booking.successTitle":"Booking confirmed","booking.successCopy":"Your confirmation email includes the meeting details and options to cancel or reschedule.","booking.pendingTitle":"Booking requested","booking.pendingCopy":"Your request is awaiting approval. You\u2019ll receive an email when it\u2019s confirmed.","booking.topic.consultation":"AI Consultation","booking.topic.review":"AI Project Review","booking.topic.planning":"Development Planning","psynera.meta.title":"{psynera} | Private AI for therapy conversations | {algorithmicNetwork}","psynera.meta.description":"{psynera} is a desktop POC for private, on-device English transcription of therapist\u2013client conversations, speaker detection, mood analysis, session summaries and treatment suggestions for clinician review.","psynera.skip":"Skip to main content","psynera.poc":"POC","psynera.kind":"Private AI for therapy conversations","psynera.hero.title":"Private AI for therapy conversations.<break></break><accent>On your device.</accent>","psynera.hero.lead":"Transcribe sessions, identify speakers, explore mood and draft summaries and treatment suggestions. Review everything in one private workspace.","psynera.hero.explore":"Explore the POC","psynera.hero.contact":"Discuss {psynera}","psynera.hero.platforms":"Desktop scope","psynera.hero.platformLabel":"Desktop platforms","psynera.hero.english":"Supports English, more languages to follow.","psynera.preview.eyebrow":"Inside the workspace","psynera.preview.title":"One session. The whole picture.","psynera.preview.intro":"Explore five views from a sample therapy session. The app stays in English, matching the current POC. This preview uses sample content and does not record or process audio.","psynera.preview.choose":"Choose a POC view","psynera.preview.transcript":"Transcript","psynera.preview.mood":"Mood overview","psynera.preview.timeline":"Emotion timeline","psynera.preview.summary":"Summary draft","psynera.preview.treatment":"Treatment notes","psynera.preview.scroll":"On a smaller screen, scroll the workspace sideways to explore the full desktop view.","psynera.preview.region":"English {psynera} desktop preview","psynera.preview.caption":"Illustrative POC content. AI-generated observations and treatment suggestions require clinician review.","psynera.features.eyebrow":"From conversation to context","psynera.features.title":"Support for the work <accent>around a session.</accent>","psynera.features.lead":"Keep the therapist\u2013client conversation, its emotional context and your clinical review together in one private desktop workspace.","psynera.features.capture.title":"Record or import","psynera.features.capture.body":"Capture a session through your microphone or bring in an existing audio recording. Keep the recording connected to its patient and session details.","psynera.features.transcript.title":"Transcribe in English","psynera.features.transcript.body":"Turn spoken English into a readable conversation. Search the transcript, switch between reading layouts and copy the text for review.","psynera.features.speakers.title":"Know who said what","psynera.features.speakers.body":"Detect different speakers and assign therapist and patient labels. Review and correct the roles before interpreting patient-specific analysis.","psynera.features.mood.title":"Explore emotional patterns","psynera.features.mood.body":"See a mood distribution, category breakdown and emotion timeline derived from patient speech. Use them as prompts for review, with the transcript as context.","psynera.features.summary.title":"Start with a structured draft","psynera.features.summary.body":"Generate a session narrative with key themes, clinical observations, cognitive patterns and treatment progress. Review the draft against the conversation.","psynera.features.treatment.title":"Review possible next steps","psynera.features.treatment.body":"Bring suggested action items and homework into your clinical review. These are draft suggestions; the treating professional decides what is appropriate.","psynera.private.eyebrow":"Private by design","psynera.private.title":"Your conversations <accent>never leave your device.</accent>","psynera.private.lead":"Therapy recordings, transcripts and generated notes stay on your device. After setup, the app works 100% offline. No internet connection is needed.","psynera.private.local.title":"Sensitive conversations stay private","psynera.private.local.body":"There is no upload of therapy audio or session content to a cloud AI service. Recordings, transcripts, mood insights and summary drafts stay together in your local workspace.","psynera.private.setup.title":"Work without an internet connection","psynera.private.setup.body":"Complete the required setup and initial sign-in online. After that, the app works 100% offline, including transcription, speaker detection, mood analysis and summary generation. Cloud sync is disabled in the POC.","psynera.private.control.title":"Your review remains central","psynera.private.control.body":"Check speaker assignments, revisit the source conversation and assess every generated observation. Mood signals and treatment drafts support professional judgement.","psynera.workflow.eyebrow":"A session, step by step","psynera.workflow.title":"Capture. Understand. <accent>Review.</accent>","psynera.workflow.one.title":"Set up the session","psynera.workflow.one.body":"Choose the patient, record or import audio, and keep the session type and duration together with your notes.","psynera.workflow.two.title":"Read the conversation","psynera.workflow.two.body":"Review the English transcript and speaker labels. Search for a phrase or revisit the patient\u2019s words before moving on.","psynera.workflow.three.title":"Look across the session","psynera.workflow.three.body":"Explore the mood breakdown and timeline, then generate a structured summary with suggested follow-up work.","psynera.workflow.four.title":"Apply clinical judgement","psynera.workflow.four.body":"Check the generated draft, add your own notes and decide the next steps. Keep the session available in the patient record or archive it.","psynera.scope.eyebrow":"Where the POC stands","psynera.scope.title":"An early product, <accent>with a defined scope.</accent>","psynera.scope.lead":"{psynera} is a proof of concept for evaluating a private clinical workflow. Its name, interface and capabilities may evolve before a public release.","psynera.scope.contact":"Ask about POC evaluation \u2192","psynera.scope.language.label":"Current app language","psynera.scope.language.value":"English only","psynera.scope.community.label":"Intended community","psynera.scope.community.value":"English-speaking therapists, psychologists and communities in the US, UK, New Zealand, Australia and other English-speaking countries.","psynera.scope.platforms.label":"Desktop platforms","psynera.scope.platforms.note":"The current documented evaluation build is for Apple Silicon Macs. Availability of {windows} and {linux} POC builds is confirmed when arranging access.","psynera.scope.minimum.label":"Minimum system requirements","psynera.scope.ram":"RAM","psynera.scope.disk":"Free disk space","psynera.scope.space.note":"Allow additional space for recordings and session data. A microphone is needed for direct recording.","psynera.scope.stage.label":"POC boundaries","psynera.scope.stage.value":"Cloud sync and data export are disabled in the illustrated POC. Generated clinical content requires professional review.","psynera.faq.eyebrow":"A few questions","psynera.faq.title":"Before you <accent>explore.</accent>","psynera.faq.lead":"What the POC supports today, and what its generated content means for clinical work.","psynera.faq.name.q":"Is {psynera} the final product name?<plus></plus>","psynera.faq.name.a":"{psynera} is an internal codename for the proof of concept. The public product name may be different when it moves beyond this stage.","psynera.faq.language.q":"Which languages does the app support?<plus></plus>","psynera.faq.language.a":"The current POC supports English only. This website is translated for readers, but those translations do not add languages to the desktop app.","psynera.faq.internet.q":"Can I use the app completely offline?<plus></plus>","psynera.faq.internet.a":"Yes. Once the required setup and initial sign-in are complete, the app works 100% offline without internet. Therapy recordings, transcripts, mood analysis and generated summaries remain on the device. Cloud sync is disabled in the POC.","psynera.faq.clinical.q":"Are the mood insights and suggestions clinical decisions?<plus></plus>","psynera.faq.clinical.a":"They are generated aids for review. A mood chart is an interpretation of speech, and summaries or treatment suggestions can be incomplete or incorrect. The treating professional reviews the source conversation and makes clinical decisions.","psynera.faq.access.q":"Can I download a public release?<plus></plus>","psynera.faq.access.a":"{psynera} is still in the POC stage. Contact us to discuss evaluation, platform availability and the current build rather than a public release.","psynera.cta.title":"Help shape <accent>what comes next.</accent>","psynera.cta.body":"We are exploring how private, on-device AI can support English-speaking clinical practice. Talk to us about the workflow, the POC and opportunities to evaluate it.","psynera.cta.contact":"Discuss the POC","psynera.cta.preview":"Back to the workspace","psynera.hero.private":"Session content stays on your device","psynera.hero.offline":"Works 100% offline","psynera.private.seal":"Your device. Your session. Your control.","psynera.roadmap.eyebrow":"What\u2019s planned","psynera.roadmap.title":"What we plan <accent>to build next.</accent>","psynera.roadmap.lead":"These capabilities are planned for future versions. The current POC supports English and keeps session work local. Development timing and availability will be shared as the product progresses.","psynera.roadmap.planned":"Planned","psynera.roadmap.sync.title":"Optional, secure sync","psynera.roadmap.sync.body":"Sync will be entirely optional. Keep working locally and offline, or choose a secure online sync service with end to end encryption for access across your authorised devices.","psynera.roadmap.sync.storage":"Bring your own storage, such as {googleDrive}, {dropbox} or another supported service. These providers will store encrypted copies, without access to the readable session content.","psynera.roadmap.sync.meaning.title":"What end to end encryption means","psynera.roadmap.sync.meaning.body":"Your device encrypts session content before it leaves. Only your authorised devices hold the keys to read it again. The sync service and storage provider receive encrypted files, so they cannot read the recordings, transcripts, notes or generated content. Choosing sync will not mean giving those services access to your therapy conversations.","psynera.roadmap.local.title":"Encrypted on your device too","psynera.roadmap.local.body":"Encrypt local session data at rest, so stored records stay protected while the workspace is locked. Unlock with a password or supported fingerprint or facial recognition options, including {faceId} where available. Biometric options will depend on your device and operating system. This local protection is planned alongside optional, secure encrypted sync.","psynera.roadmap.search.title":"Search in your own words","psynera.roadmap.search.body":"Fast search using everyday language, such as \u201CFind sessions where we discussed sleep.\u201D Look across conversations, summaries and your notes without remembering an exact phrase or filename. Results will take you back to the relevant session and source material for review.","psynera.roadmap.chat.title":"Private chat about a session","psynera.roadmap.chat.body":"An optional AI conversation that runs on your device. Ask questions about a session, explore its themes and weigh possible next steps alongside the transcript and your notes. The chat will support your reasoning; the therapist will make the decisions and review any suggestions.","psynera.roadmap.review.title":"Your edits, your clinical record","psynera.roadmap.review.body":"Review and locally override any generated transcript, mood interpretation, summary or treatment suggestion. Add your own observations and attach notes to the session. Your reviewed version will remain the authoritative record, with the original conversation available for context.","psynera.roadmap.learning.title":"Learn from your corrections","psynera.roadmap.learning.body":"Local learning from your approved edits and preferences, so future drafts improve as you use the workspace. It will adapt to how you document sessions, organise notes and review content. Learning will stay on your device, with changes visible to you and clinical decisions under your control.","psynera.roadmap.languages.title":"More regional languages","psynera.roadmap.languages.body":"Expand the app beyond English to languages such as Spanish, Portuguese, German and French, with more regional languages to follow. The aim is to support therapy conversations and session work in the language people use. English remains the only app language in the current POC.","psynera.faq.sync.q":"Will I need to use online sync?<plus></plus>","psynera.faq.sync.a":"No. The planned online sync service will be optional and secure, with end to end encryption. You will still be able to work locally and offline. If you choose to sync, your storage provider will receive encrypted files rather than readable session content. Sync and local encrypted storage are future plans; cloud sync is disabled in the current POC.","psynera.roadmap.tabs.label":"Planned capabilities","psynera.roadmap.tabs.privacy":"Privacy and sync","psynera.roadmap.tabs.session":"Session tools","psynera.roadmap.tabs.learning":"Therapist control","psynera.roadmap.tabs.languages":"More languages","psynera.roadmap.graphic.device":"Your device","psynera.roadmap.graphic.encrypt":"Encrypt before sending","psynera.roadmap.graphic.storage":"Your storage","psynera.roadmap.graphic.copies":"Encrypted copies only","psynera.roadmap.graphic.authorised":"Authorised device","psynera.roadmap.graphic.decrypt":"Decrypt with your keys","psynera.roadmap.graphic.keys":"Keys stay on your devices","psynera.roadmap.graphic.records":"Session records","psynera.roadmap.graphic.ai":"Private AI","psynera.roadmap.graphic.review":"Therapist review","psynera.roadmap.graphic.query":"Find sessions where we discussed sleep","psynera.roadmap.graphic.local":"All processing stays on your device","psynera.roadmap.graphic.corrections":"Your corrections","psynera.roadmap.graphic.learning":"Local learning","psynera.roadmap.graphic.drafts":"Better drafts","psynera.roadmap.graphic.approval":"You approve what it learns","psynera.roadmap.graphic.english":"English today","psynera.roadmap.graphic.spanish":"Spanish","psynera.roadmap.graphic.portuguese":"Portuguese","psynera.roadmap.graphic.german":"German","psynera.roadmap.graphic.french":"French","psynera.roadmap.graphic.more":"And more"}');

});

parcelRegister("cmS5H", function(module, exports) {
module.exports = $parcel$import("cMfHH").then(()=>parcelRequire('l3kWF'));

});

parcelRegister("e09WF", function(module, exports) {
module.exports = $parcel$import("9tHFB").then(()=>parcelRequire('7pM2x'));

});

parcelRegister("hzCRu", function(module, exports) {
module.exports = $parcel$import("eBNLS").then(()=>parcelRequire('hUe2O'));

});

parcelRegister("25Qnz", function(module, exports) {
module.exports = $parcel$import("bkFK7").then(()=>parcelRequire('dkwSy'));

});

parcelRegister("lNxNA", function(module, exports) {
module.exports = $parcel$import("Pfafn").then(()=>parcelRequire('aaqVa'));

});

var $44065987ba314f0b$exports = {};
$parcel$extendImportMap({
    "cMfHH": "es.4c3b0ca4.js",
    "9tHFB": "pt-BR.cb18b508.js",
    "eBNLS": "fr.fa044eb3.js",
    "bkFK7": "ar.423c3cb5.js",
    "Pfafn": "de.0aeafaaf.js"
});

// One shared entry keeps controls and guarded page interactions available on every route.
// Site navigation: hover and keyboard dropdowns, condensed bar on scroll,
// active section highlighting on the home page and the mobile sheet.
// Shared by every page through navigation.js. The head bootstrap handles first paint.

var $9R3dw = parcelRequire("9R3dw");
var $c964284728795061$exports = {};
$c964284728795061$exports = JSON.parse("{\"algorithmicNetwork\":\"Algorithmic Network\",\"psynera\":\"Psynera\",\"googleDrive\":\"Google Drive\",\"dropbox\":\"Dropbox\",\"faceId\":\"Face ID\",\"algorithmicWordmark\":\"Algorithmic\",\"networkWordmark\":\"Network\",\"retailistDesktop\":\"Retailist Desktop\",\"retailistApp\":\"Retailist App\",\"retailistStore\":\"Retailist Store\",\"retailistCloud\":\"Retailist Cloud\",\"retailistAi\":\"RetailistAI\",\"retailist\":\"Retailist\",\"fynlinkLlc\":\"Fynlink, LLC\",\"fynlink\":\"Fynlink\",\"localAts\":\"Local ATS\",\"shopify\":\"Shopify\",\"shopifyWordmark\":\"shopify\",\"wooCommerce\":\"WooCommerce\",\"macOs\":\"macOS\",\"windows\":\"Windows\",\"linux\":\"Linux\",\"calCom\":\"Cal.com\",\"calVideo\":\"Cal Video\",\"langChain\":\"LangChain\",\"langGraph\":\"LangGraph\",\"huggingFace\":\"Hugging Face\",\"huggingFaceCompact\":\"HuggingFace\",\"typeSafeAi\":\"TypeSafe AI\",\"ollama\":\"Ollama\",\"pytorch\":\"PyTorch\",\"fastai\":\"fastai\",\"tensorFlow\":\"TensorFlow\",\"keras\":\"Keras\",\"scikitLearn\":\"scikit-learn\",\"weightsAndBiases\":\"Weights & Biases\",\"onnx\":\"ONNX\",\"mlflow\":\"MLflow\",\"anthropic\":\"Anthropic\",\"python\":\"Python\",\"fastApi\":\"FastAPI\",\"docker\":\"Docker\",\"chrome\":\"Chrome\",\"firefox\":\"Firefox\",\"edge\":\"Edge\",\"brave\":\"Brave\",\"opera\":\"Opera\",\"github\":\"GitHub\",\"x\":\"X\",\"agents\":\"<Agents>\",\"helloEmail\":\"hello@algorithmic.network\",\"privacyEmail\":\"privacy@algorithmic.network\",\"legalEmail\":\"legal@algorithmic.network\",\"siteDomain\":\"algorithmic.network\",\"northStar\":\"North Star\",\"matt\":\"Matt M.\",\"mori\":\"MORI\",\"moriDomain\":\"moriobjects.com\",\"atelier\":\"Atelier No. 7\",\"weekender\":\"North Star Weekender\",\"marigold\":\"Marigold Wrap Dress\",\"fieldJacket\":\"Field Chore Jacket\",\"halo\":\"Halo frames\",\"afterRain\":\"After Rain\",\"cobaltTrench\":\"Cobalt trench\",\"arcSpeaker\":\"Arc 02 Speaker\"}");


var $175dbb69957d8e06$exports = {};
$175dbb69957d8e06$exports = JSON.parse('{"defaultLocale":"en","storageKey":"algorithmic-network-language-v1","languages":[{"code":"en","nativeLabel":"English","shortLabel":"EN","direction":"ltr"},{"code":"es","nativeLabel":"Espa\xf1ol","shortLabel":"ES","direction":"ltr"},{"code":"pt-BR","nativeLabel":"Portugu\xeas (Brasil)","shortLabel":"PT","direction":"ltr"},{"code":"fr","nativeLabel":"Fran\xe7ais","shortLabel":"FR","direction":"ltr"},{"code":"ar","nativeLabel":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629","shortLabel":"AR","direction":"rtl"},{"code":"de","nativeLabel":"Deutsch","shortLabel":"DE","direction":"ltr"}]}');


// Only reviewed, published locales belong here. Node audits and Parcel use the same loaders.
// Node exposes JSON through a default export; Parcel can return the catalogue directly.
const $33fa2452826454d7$var$catalogFromImport = (imported)=>imported.default ?? imported;






const $33fa2452826454d7$export$7211f0bd52e8a1b7 = Object.freeze({
    en: async ()=>$33fa2452826454d7$var$catalogFromImport(await Promise.resolve((parcelRequire("9R3dw")))),
    es: async ()=>$33fa2452826454d7$var$catalogFromImport(await (parcelRequire("cmS5H"))),
    'pt-BR': async ()=>$33fa2452826454d7$var$catalogFromImport(await (parcelRequire("e09WF"))),
    fr: async ()=>$33fa2452826454d7$var$catalogFromImport(await (parcelRequire("hzCRu"))),
    ar: async ()=>$33fa2452826454d7$var$catalogFromImport(await (parcelRequire("25Qnz"))),
    de: async ()=>$33fa2452826454d7$var$catalogFromImport(await (parcelRequire("lNxNA")))
});


//#region packages/fast-memoize/index.ts
function $7bac09121bc9431c$export$fc10aeed3a532e2a(fn, options) {
    const cache = options && options.cache ? options.cache : $7bac09121bc9431c$var$cacheDefault;
    const serializer = options && options.serializer ? options.serializer : $7bac09121bc9431c$var$serializerDefault;
    return (options && options.strategy ? options.strategy : $7bac09121bc9431c$var$strategyDefault)(fn, {
        cache: cache,
        serializer: serializer
    });
}
function $7bac09121bc9431c$var$isPrimitive(value) {
    return value == null || typeof value === "number" || typeof value === "boolean";
}
function $7bac09121bc9431c$var$monadic(fn, cache, serializer, arg) {
    const cacheKey = $7bac09121bc9431c$var$isPrimitive(arg) ? arg : serializer(arg);
    let computedValue = cache.get(cacheKey);
    if (typeof computedValue === "undefined") {
        computedValue = fn.call(this, arg);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function $7bac09121bc9431c$var$variadic(fn, cache, serializer) {
    const args = Array.prototype.slice.call(arguments, 3);
    const cacheKey = serializer(args);
    let computedValue = cache.get(cacheKey);
    if (typeof computedValue === "undefined") {
        computedValue = fn.apply(this, args);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function $7bac09121bc9431c$var$assemble(fn, context, strategy, cache, serialize) {
    return strategy.bind(context, fn, cache, serialize);
}
function $7bac09121bc9431c$var$strategyDefault(fn, options) {
    const strategy = fn.length === 1 ? $7bac09121bc9431c$var$monadic : $7bac09121bc9431c$var$variadic;
    return $7bac09121bc9431c$var$assemble(fn, this, strategy, options.cache.create(), options.serializer);
}
function $7bac09121bc9431c$var$strategyVariadic(fn, options) {
    return $7bac09121bc9431c$var$assemble(fn, this, $7bac09121bc9431c$var$variadic, options.cache.create(), options.serializer);
}
function $7bac09121bc9431c$var$strategyMonadic(fn, options) {
    return $7bac09121bc9431c$var$assemble(fn, this, $7bac09121bc9431c$var$monadic, options.cache.create(), options.serializer);
}
const $7bac09121bc9431c$var$serializerDefault = function() {
    return JSON.stringify(arguments);
};
var $7bac09121bc9431c$var$ObjectWithoutPrototypeCache = class {
    constructor(){
        this.cache = Object.create(null);
    }
    get(key) {
        return this.cache[key];
    }
    set(key, value) {
        this.cache[key] = value;
    }
};
const $7bac09121bc9431c$var$cacheDefault = {
    create: function create() {
        return new $7bac09121bc9431c$var$ObjectWithoutPrototypeCache();
    }
};
const $7bac09121bc9431c$export$c5491a8691a23b9e = {
    variadic: $7bac09121bc9431c$var$strategyVariadic,
    monadic: $7bac09121bc9431c$var$strategyMonadic
};


//#region packages/icu-skeleton-parser/date-time.ts
/**
* https://unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
* Credit: https://github.com/caridy/intl-datetimeformat-pattern/blob/master/index.js
* with some tweaks
*/ const $d4d3fc9f6275a50a$var$DATE_TIME_REGEX = /(?:[Eec]{1,6}|G{1,5}|[Qq]{1,5}|(?:[yYur]+|U{1,5})|[ML]{1,5}|d{1,2}|D{1,3}|F{1}|[abB]{1,5}|[hkHK]{1,2}|w{1,2}|W{1}|m{1,2}|s{1,2}|[zZOvVxX]{1,4})(?=([^']*'[^']*')*[^']*$)/g;
/**
* Parse Date time skeleton into Intl.DateTimeFormatOptions
* Ref: https://unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
* @public
* @param skeleton skeleton string
*/ function $d4d3fc9f6275a50a$export$f7b99fb377fe69fa(skeleton) {
    const result = {};
    skeleton.replace($d4d3fc9f6275a50a$var$DATE_TIME_REGEX, (match)=>{
        const len = match.length;
        switch(match[0]){
            case "G":
                result.era = len === 4 ? "long" : len === 5 ? "narrow" : "short";
                break;
            case "y":
                result.year = len === 2 ? "2-digit" : "numeric";
                break;
            case "Y":
            case "u":
            case "U":
            case "r":
                throw new RangeError("`Y/u/U/r` (year) patterns are not supported, use `y` instead");
            case "q":
            case "Q":
                throw new RangeError("`q/Q` (quarter) patterns are not supported");
            case "M":
            case "L":
                result.month = [
                    "numeric",
                    "2-digit",
                    "short",
                    "long",
                    "narrow"
                ][len - 1];
                break;
            case "w":
            case "W":
                throw new RangeError("`w/W` (week) patterns are not supported");
            case "d":
                result.day = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            case "D":
            case "F":
            case "g":
                throw new RangeError("`D/F/g` (day) patterns are not supported, use `d` instead");
            case "E":
                result.weekday = len === 4 ? "long" : len === 5 ? "narrow" : "short";
                break;
            case "e":
                if (len < 4) throw new RangeError("`e..eee` (weekday) patterns are not supported");
                result.weekday = [
                    "short",
                    "long",
                    "narrow",
                    "short"
                ][len - 3];
                break;
            case "c":
                if (len < 4) throw new RangeError("`c..ccc` (weekday) patterns are not supported");
                result.weekday = [
                    "short",
                    "long",
                    "narrow",
                    "short"
                ][len - 3];
                break;
            case "a":
                result.hour12 = true;
                break;
            case "b":
            case "B":
                throw new RangeError("`b/B` (period) patterns are not supported, use `a` instead");
            case "h":
                result.hourCycle = "h12";
                result.hour = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            case "H":
                result.hourCycle = "h23";
                result.hour = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            case "K":
                result.hourCycle = "h11";
                result.hour = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            case "k":
                result.hourCycle = "h24";
                result.hour = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            case "j":
            case "J":
            case "C":
                throw new RangeError("`j/J/C` (hour) patterns are not supported, use `h/H/K/k` instead");
            case "m":
                result.minute = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            case "s":
                result.second = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            case "S":
            case "A":
                throw new RangeError("`S/A` (second) patterns are not supported, use `s` instead");
            case "z":
                result.timeZoneName = len < 4 ? "short" : "long";
                break;
            case "Z":
            case "O":
            case "v":
            case "V":
            case "X":
            case "x":
                throw new RangeError("`Z/O/v/V/X/x` (timeZone) patterns are not supported, use `z` instead");
        }
        return "";
    });
    return result;
}
//#endregion
//#region node_modules/.aspect_rules_js/@formatjs_generated+unicode@0.0.0/node_modules/@formatjs_generated/unicode/icu-skeleton-parser-regex.js
const $d4d3fc9f6275a50a$var$WHITE_SPACE_REGEX = /[\t-\r \x85\u200E\u200F\u2028\u2029]/i;
//#endregion
//#region packages/icu-skeleton-parser/number.ts
function $d4d3fc9f6275a50a$export$71cee2f16fba2480(skeleton) {
    if (skeleton.length === 0) throw new Error("Number skeleton cannot be empty");
    const stringTokens = skeleton.split($d4d3fc9f6275a50a$var$WHITE_SPACE_REGEX).filter((x)=>x.length > 0);
    const tokens = [];
    for (const stringToken of stringTokens){
        let stemAndOptions = stringToken.split("/");
        if (stemAndOptions.length === 0) throw new Error("Invalid number skeleton");
        const [stem, ...options] = stemAndOptions;
        for (const option of options)if (option.length === 0) throw new Error("Invalid number skeleton");
        tokens.push({
            stem: stem,
            options: options
        });
    }
    return tokens;
}
function $d4d3fc9f6275a50a$var$icuUnitToEcma(unit) {
    return unit.replace(/^(.*?)-/, "");
}
const $d4d3fc9f6275a50a$var$FRACTION_PRECISION_REGEX = /^\.(?:(0+)(\*)?|(#+)|(0+)(#+))$/g;
const $d4d3fc9f6275a50a$var$SIGNIFICANT_PRECISION_REGEX = /^(@+)?(\+|#+)?[rs]?$/g;
const $d4d3fc9f6275a50a$var$INTEGER_WIDTH_REGEX = /(\*)(0+)|(#+)(0+)|(0+)/g;
const $d4d3fc9f6275a50a$var$CONCISE_INTEGER_WIDTH_REGEX = /^(0+)$/;
function $d4d3fc9f6275a50a$var$parseSignificantPrecision(str) {
    const result = {};
    if (str[str.length - 1] === "r") result.roundingPriority = "morePrecision";
    else if (str[str.length - 1] === "s") result.roundingPriority = "lessPrecision";
    str.replace($d4d3fc9f6275a50a$var$SIGNIFICANT_PRECISION_REGEX, function(_, g1, g2) {
        if (typeof g2 !== "string") {
            result.minimumSignificantDigits = g1.length;
            result.maximumSignificantDigits = g1.length;
        } else if (g2 === "+") result.minimumSignificantDigits = g1.length;
        else if (g1[0] === "#") result.maximumSignificantDigits = g1.length;
        else {
            result.minimumSignificantDigits = g1.length;
            result.maximumSignificantDigits = g1.length + (typeof g2 === "string" ? g2.length : 0);
        }
        return "";
    });
    return result;
}
function $d4d3fc9f6275a50a$var$parseSign(str) {
    switch(str){
        case "sign-auto":
            return {
                signDisplay: "auto"
            };
        case "sign-accounting":
        case "()":
            return {
                currencySign: "accounting"
            };
        case "sign-always":
        case "+!":
            return {
                signDisplay: "always"
            };
        case "sign-accounting-always":
        case "()!":
            return {
                signDisplay: "always",
                currencySign: "accounting"
            };
        case "sign-except-zero":
        case "+?":
            return {
                signDisplay: "exceptZero"
            };
        case "sign-accounting-except-zero":
        case "()?":
            return {
                signDisplay: "exceptZero",
                currencySign: "accounting"
            };
        case "sign-never":
        case "+_":
            return {
                signDisplay: "never"
            };
    }
}
function $d4d3fc9f6275a50a$var$parseConciseScientificAndEngineeringStem(stem) {
    let result;
    if (stem[0] === "E" && stem[1] === "E") {
        result = {
            notation: "engineering"
        };
        stem = stem.slice(2);
    } else if (stem[0] === "E") {
        result = {
            notation: "scientific"
        };
        stem = stem.slice(1);
    }
    if (result) {
        const signDisplay = stem.slice(0, 2);
        if (signDisplay === "+!") {
            result.signDisplay = "always";
            stem = stem.slice(2);
        } else if (signDisplay === "+?") {
            result.signDisplay = "exceptZero";
            stem = stem.slice(2);
        }
        if (!$d4d3fc9f6275a50a$var$CONCISE_INTEGER_WIDTH_REGEX.test(stem)) throw new Error("Malformed concise eng/scientific notation");
        result.minimumIntegerDigits = stem.length;
    }
    return result;
}
function $d4d3fc9f6275a50a$var$parseNotationOptions(opt) {
    const result = {};
    const signOpts = $d4d3fc9f6275a50a$var$parseSign(opt);
    if (signOpts) return signOpts;
    return result;
}
/**
* https://github.com/unicode-org/icu/blob/master/docs/userguide/format_parse/numbers/skeletons.md#skeleton-stems-and-options
*/ function $d4d3fc9f6275a50a$export$47c6f8480bda3e11(tokens) {
    let result = {};
    for (const token of tokens){
        switch(token.stem){
            case "percent":
            case "%":
                result.style = "percent";
                continue;
            case "%x100":
                result.style = "percent";
                result.scale = 100;
                continue;
            case "currency":
                result.style = "currency";
                result.currency = token.options[0];
                continue;
            case "group-off":
            case ",_":
                result.useGrouping = false;
                continue;
            case "precision-integer":
            case ".":
                result.maximumFractionDigits = 0;
                continue;
            case "measure-unit":
            case "unit":
                result.style = "unit";
                result.unit = $d4d3fc9f6275a50a$var$icuUnitToEcma(token.options[0]);
                continue;
            case "compact-short":
            case "K":
                result.notation = "compact";
                result.compactDisplay = "short";
                continue;
            case "compact-long":
            case "KK":
                result.notation = "compact";
                result.compactDisplay = "long";
                continue;
            case "scientific":
                result = {
                    ...result,
                    notation: "scientific",
                    ...token.options.reduce((all, opt)=>({
                            ...all,
                            ...$d4d3fc9f6275a50a$var$parseNotationOptions(opt)
                        }), {})
                };
                continue;
            case "engineering":
                result = {
                    ...result,
                    notation: "engineering",
                    ...token.options.reduce((all, opt)=>({
                            ...all,
                            ...$d4d3fc9f6275a50a$var$parseNotationOptions(opt)
                        }), {})
                };
                continue;
            case "notation-simple":
                result.notation = "standard";
                continue;
            case "unit-width-narrow":
                result.currencyDisplay = "narrowSymbol";
                result.unitDisplay = "narrow";
                continue;
            case "unit-width-short":
                result.currencyDisplay = "code";
                result.unitDisplay = "short";
                continue;
            case "unit-width-full-name":
                result.currencyDisplay = "name";
                result.unitDisplay = "long";
                continue;
            case "unit-width-iso-code":
                result.currencyDisplay = "symbol";
                continue;
            case "scale":
                result.scale = parseFloat(token.options[0]);
                continue;
            case "rounding-mode-floor":
                result.roundingMode = "floor";
                continue;
            case "rounding-mode-ceiling":
                result.roundingMode = "ceil";
                continue;
            case "rounding-mode-down":
                result.roundingMode = "trunc";
                continue;
            case "rounding-mode-up":
                result.roundingMode = "expand";
                continue;
            case "rounding-mode-half-even":
                result.roundingMode = "halfEven";
                continue;
            case "rounding-mode-half-down":
                result.roundingMode = "halfTrunc";
                continue;
            case "rounding-mode-half-up":
                result.roundingMode = "halfExpand";
                continue;
            case "integer-width":
                if (token.options.length > 1) throw new RangeError("integer-width stems only accept a single optional option");
                token.options[0].replace($d4d3fc9f6275a50a$var$INTEGER_WIDTH_REGEX, function(_, g1, g2, g3, g4, g5) {
                    if (g1) result.minimumIntegerDigits = g2.length;
                    else if (g3 && g4) throw new Error("We currently do not support maximum integer digits");
                    else if (g5) throw new Error("We currently do not support exact integer digits");
                    return "";
                });
                continue;
        }
        if ($d4d3fc9f6275a50a$var$CONCISE_INTEGER_WIDTH_REGEX.test(token.stem)) {
            result.minimumIntegerDigits = token.stem.length;
            continue;
        }
        if ($d4d3fc9f6275a50a$var$FRACTION_PRECISION_REGEX.test(token.stem)) {
            if (token.options.length > 1) throw new RangeError("Fraction-precision stems only accept a single optional option");
            token.stem.replace($d4d3fc9f6275a50a$var$FRACTION_PRECISION_REGEX, function(_, g1, g2, g3, g4, g5) {
                if (g2 === "*") result.minimumFractionDigits = g1.length;
                else if (g3 && g3[0] === "#") result.maximumFractionDigits = g3.length;
                else if (g4 && g5) {
                    result.minimumFractionDigits = g4.length;
                    result.maximumFractionDigits = g4.length + g5.length;
                } else {
                    result.minimumFractionDigits = g1.length;
                    result.maximumFractionDigits = g1.length;
                }
                return "";
            });
            const opt = token.options[0];
            if (opt === "w") result = {
                ...result,
                trailingZeroDisplay: "stripIfInteger"
            };
            else if (opt) result = {
                ...result,
                ...$d4d3fc9f6275a50a$var$parseSignificantPrecision(opt)
            };
            continue;
        }
        if ($d4d3fc9f6275a50a$var$SIGNIFICANT_PRECISION_REGEX.test(token.stem)) {
            result = {
                ...result,
                ...$d4d3fc9f6275a50a$var$parseSignificantPrecision(token.stem)
            };
            continue;
        }
        const signOpts = $d4d3fc9f6275a50a$var$parseSign(token.stem);
        if (signOpts) result = {
            ...result,
            ...signOpts
        };
        const conciseScientificAndEngineeringOpts = $d4d3fc9f6275a50a$var$parseConciseScientificAndEngineeringStem(token.stem);
        if (conciseScientificAndEngineeringOpts) result = {
            ...result,
            ...conciseScientificAndEngineeringOpts
        };
    }
    return result;
}


//#region packages/icu-messageformat-parser/error.ts
let $2dc2f66d316cd8db$var$ErrorKind = /* @__PURE__ */ function(ErrorKind) {
    /** Argument is unclosed (e.g. `{0`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_CLOSING_BRACE"] = 1] = "EXPECT_ARGUMENT_CLOSING_BRACE";
    /** Argument is empty (e.g. `{}`). */ ErrorKind[ErrorKind["EMPTY_ARGUMENT"] = 2] = "EMPTY_ARGUMENT";
    /** Argument is malformed (e.g. `{foo!}``) */ ErrorKind[ErrorKind["MALFORMED_ARGUMENT"] = 3] = "MALFORMED_ARGUMENT";
    /** Expect an argument type (e.g. `{foo,}`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_TYPE"] = 4] = "EXPECT_ARGUMENT_TYPE";
    /** Unsupported argument type (e.g. `{foo,foo}`) */ ErrorKind[ErrorKind["INVALID_ARGUMENT_TYPE"] = 5] = "INVALID_ARGUMENT_TYPE";
    /** Expect an argument style (e.g. `{foo, number, }`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_STYLE"] = 6] = "EXPECT_ARGUMENT_STYLE";
    /** The number skeleton is invalid. */ ErrorKind[ErrorKind["INVALID_NUMBER_SKELETON"] = 7] = "INVALID_NUMBER_SKELETON";
    /** The date time skeleton is invalid. */ ErrorKind[ErrorKind["INVALID_DATE_TIME_SKELETON"] = 8] = "INVALID_DATE_TIME_SKELETON";
    /** Exepct a number skeleton following the `::` (e.g. `{foo, number, ::}`) */ ErrorKind[ErrorKind["EXPECT_NUMBER_SKELETON"] = 9] = "EXPECT_NUMBER_SKELETON";
    /** Exepct a date time skeleton following the `::` (e.g. `{foo, date, ::}`) */ ErrorKind[ErrorKind["EXPECT_DATE_TIME_SKELETON"] = 10] = "EXPECT_DATE_TIME_SKELETON";
    /** Unmatched apostrophes in the argument style (e.g. `{foo, number, 'test`) */ ErrorKind[ErrorKind["UNCLOSED_QUOTE_IN_ARGUMENT_STYLE"] = 11] = "UNCLOSED_QUOTE_IN_ARGUMENT_STYLE";
    /** Missing select argument options (e.g. `{foo, select}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_OPTIONS"] = 12] = "EXPECT_SELECT_ARGUMENT_OPTIONS";
    /** Expecting an offset value in `plural` or `selectordinal` argument (e.g `{foo, plural, offset}`) */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE"] = 13] = "EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE";
    /** Offset value in `plural` or `selectordinal` is invalid (e.g. `{foo, plural, offset: x}`) */ ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_OFFSET_VALUE"] = 14] = "INVALID_PLURAL_ARGUMENT_OFFSET_VALUE";
    /** Expecting a selector in `select` argument (e.g `{foo, select}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR"] = 15] = "EXPECT_SELECT_ARGUMENT_SELECTOR";
    /** Expecting a selector in `plural` or `selectordinal` argument (e.g `{foo, plural}`) */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR"] = 16] = "EXPECT_PLURAL_ARGUMENT_SELECTOR";
    /** Expecting a message fragment after the `select` selector (e.g. `{foo, select, apple}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT"] = 17] = "EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT";
    /**
	* Expecting a message fragment after the `plural` or `selectordinal` selector
	* (e.g. `{foo, plural, one}`)
	*/ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT"] = 18] = "EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT";
    /** Selector in `plural` or `selectordinal` is malformed (e.g. `{foo, plural, =x {#}}`) */ ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_SELECTOR"] = 19] = "INVALID_PLURAL_ARGUMENT_SELECTOR";
    /**
	* Duplicate selectors in `plural` or `selectordinal` argument.
	* (e.g. {foo, plural, one {#} one {#}})
	*/ ErrorKind[ErrorKind["DUPLICATE_PLURAL_ARGUMENT_SELECTOR"] = 20] = "DUPLICATE_PLURAL_ARGUMENT_SELECTOR";
    /** Duplicate selectors in `select` argument.
	* (e.g. {foo, select, apple {apple} apple {apple}})
	*/ ErrorKind[ErrorKind["DUPLICATE_SELECT_ARGUMENT_SELECTOR"] = 21] = "DUPLICATE_SELECT_ARGUMENT_SELECTOR";
    /** Plural or select argument option must have `other` clause. */ ErrorKind[ErrorKind["MISSING_OTHER_CLAUSE"] = 22] = "MISSING_OTHER_CLAUSE";
    /** The tag is malformed. (e.g. `<bold!>foo</bold!>) */ ErrorKind[ErrorKind["INVALID_TAG"] = 23] = "INVALID_TAG";
    /** The tag name is invalid. (e.g. `<123>foo</123>`) */ ErrorKind[ErrorKind["INVALID_TAG_NAME"] = 25] = "INVALID_TAG_NAME";
    /** The closing tag does not match the opening tag. (e.g. `<bold>foo</italic>`) */ ErrorKind[ErrorKind["UNMATCHED_CLOSING_TAG"] = 26] = "UNMATCHED_CLOSING_TAG";
    /** The opening tag has unmatched closing tag. (e.g. `<bold>foo`) */ ErrorKind[ErrorKind["UNCLOSED_TAG"] = 27] = "UNCLOSED_TAG";
    return ErrorKind;
}({});
//#endregion
//#region packages/icu-messageformat-parser/types.ts
let $2dc2f66d316cd8db$export$b87f371cbc396fcf = /* @__PURE__ */ function(TYPE) {
    /**
	* Raw text
	*/ TYPE[TYPE["literal"] = 0] = "literal";
    /**
	* Variable w/o any format, e.g `var` in `this is a {var}`
	*/ TYPE[TYPE["argument"] = 1] = "argument";
    /**
	* Variable w/ number format
	*/ TYPE[TYPE["number"] = 2] = "number";
    /**
	* Variable w/ date format
	*/ TYPE[TYPE["date"] = 3] = "date";
    /**
	* Variable w/ time format
	*/ TYPE[TYPE["time"] = 4] = "time";
    /**
	* Variable w/ select format
	*/ TYPE[TYPE["select"] = 5] = "select";
    /**
	* Variable w/ plural format
	*/ TYPE[TYPE["plural"] = 6] = "plural";
    /**
	* Only possible within plural argument.
	* This is the `#` symbol that will be substituted with the count.
	*/ TYPE[TYPE["pound"] = 7] = "pound";
    /**
	* XML-like tag
	*/ TYPE[TYPE["tag"] = 8] = "tag";
    return TYPE;
}({});
let $2dc2f66d316cd8db$export$906452485466fa53 = /* @__PURE__ */ function(SKELETON_TYPE) {
    SKELETON_TYPE[SKELETON_TYPE["number"] = 0] = "number";
    SKELETON_TYPE[SKELETON_TYPE["dateTime"] = 1] = "dateTime";
    return SKELETON_TYPE;
}({});
/**
* Type Guards
*/ function $2dc2f66d316cd8db$export$cfa10c5697238752(el) {
    return el.type === 0;
}
function $2dc2f66d316cd8db$export$4f55724281bdfaf9(el) {
    return el.type === 1;
}
function $2dc2f66d316cd8db$export$e11187b219e191e1(el) {
    return el.type === 2;
}
function $2dc2f66d316cd8db$export$32d811605da75f40(el) {
    return el.type === 3;
}
function $2dc2f66d316cd8db$export$34ec46f596b1702f(el) {
    return el.type === 4;
}
function $2dc2f66d316cd8db$export$dcfe1c11d168b5a1(el) {
    return el.type === 5;
}
function $2dc2f66d316cd8db$export$6c796d116f0a4fbc(el) {
    return el.type === 6;
}
function $2dc2f66d316cd8db$export$c0ece297bdd0c082(el) {
    return el.type === 7;
}
function $2dc2f66d316cd8db$export$5c83de34745812b(el) {
    return el.type === 8;
}
function $2dc2f66d316cd8db$export$3f9a19cd4152eda3(el) {
    return !!(el && typeof el === "object" && el.type === 0);
}
function $2dc2f66d316cd8db$export$7680c41f1a55f4cf(el) {
    return !!(el && typeof el === "object" && el.type === 1);
}
function $2dc2f66d316cd8db$export$f0ac572c1121c662(value) {
    return {
        type: 0,
        value: value
    };
}
function $2dc2f66d316cd8db$export$425e864b0ba114f1(value, style) {
    return {
        type: 2,
        value: value,
        style: style
    };
}
//#endregion
//#region node_modules/.aspect_rules_js/@formatjs_generated+unicode@0.0.0/node_modules/@formatjs_generated/unicode/icu-messageformat-parser-regex.js
const $2dc2f66d316cd8db$var$SPACE_SEPARATOR_REGEX = /[ \xA0\u1680\u2000-\u200A\u202F\u205F\u3000]/;
const $2dc2f66d316cd8db$var$IDENTIFIER_PREFIX_REGEX = /([^\t-\r -\/:-@\[-\^`\{-~\x85\xA0-\xA7\xA9\xAB\xAC\xAE\xB0\xB1\xB6\xBB\xBF\xD7\xF7\u1680\u2000-\u200A\u2010-\u2029\u202F-\u203E\u2041-\u2053\u2055-\u205F\u2190-\u245F\u2500-\u2775\u2794-\u2BFF\u2E00-\u2E7F\u3000-\u3003\u3008-\u3020\u3030\uFD3E\uFD3F\uFE45\uFE46]*)/g;
//#endregion
//#region node_modules/.aspect_rules_js/@formatjs_generated+cldr.core@0.0.0/node_modules/@formatjs_generated/cldr.core/time-data.js
const $2dc2f66d316cd8db$var$timeData = {
    "001": [
        "H",
        "h"
    ],
    "419": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "AC": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "AD": [
        "H",
        "hB"
    ],
    "AE": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "AF": [
        "H",
        "hb",
        "hB",
        "h"
    ],
    "AG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "AI": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "AL": [
        "h",
        "H",
        "hB"
    ],
    "AM": [
        "H",
        "hB"
    ],
    "AO": [
        "H",
        "hB"
    ],
    "AR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "AS": [
        "h",
        "H"
    ],
    "AT": [
        "H",
        "hB"
    ],
    "AU": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "AW": [
        "H",
        "hB"
    ],
    "AX": [
        "H"
    ],
    "AZ": [
        "H",
        "hB",
        "h"
    ],
    "BA": [
        "H",
        "hB",
        "h"
    ],
    "BB": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BD": [
        "h",
        "hB",
        "H"
    ],
    "BE": [
        "H",
        "hB"
    ],
    "BF": [
        "H",
        "hB"
    ],
    "BG": [
        "H",
        "hB",
        "h"
    ],
    "BH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "BI": [
        "H",
        "h"
    ],
    "BJ": [
        "H",
        "hB"
    ],
    "BL": [
        "H",
        "hB"
    ],
    "BM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BN": [
        "hb",
        "hB",
        "h",
        "H"
    ],
    "BO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "BQ": [
        "H"
    ],
    "BR": [
        "H",
        "hB"
    ],
    "BS": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BT": [
        "h",
        "H"
    ],
    "BW": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "BY": [
        "H",
        "h"
    ],
    "BZ": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CA": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "CC": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CD": [
        "hB",
        "H"
    ],
    "CF": [
        "H",
        "h",
        "hB"
    ],
    "CG": [
        "H",
        "hB"
    ],
    "CH": [
        "H",
        "hB",
        "h"
    ],
    "CI": [
        "H",
        "hB"
    ],
    "CK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CL": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "CM": [
        "H",
        "h",
        "hB"
    ],
    "CN": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "CO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "CP": [
        "H"
    ],
    "CR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "CU": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "CV": [
        "H",
        "hB"
    ],
    "CW": [
        "H",
        "hB"
    ],
    "CX": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CY": [
        "h",
        "H",
        "hb",
        "hB"
    ],
    "CZ": [
        "H"
    ],
    "DE": [
        "H",
        "hB"
    ],
    "DG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "DJ": [
        "h",
        "H"
    ],
    "DK": [
        "H"
    ],
    "DM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "DO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "DZ": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "EA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "EC": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "EE": [
        "H",
        "hB"
    ],
    "EG": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "EH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "ER": [
        "h",
        "H"
    ],
    "ES": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "ET": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "FI": [
        "H"
    ],
    "FJ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "FK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "FM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "FO": [
        "H",
        "h"
    ],
    "FR": [
        "H",
        "hB"
    ],
    "GA": [
        "H",
        "hB"
    ],
    "GB": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GD": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GE": [
        "H",
        "hB",
        "h"
    ],
    "GF": [
        "H",
        "hB"
    ],
    "GG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GH": [
        "h",
        "H"
    ],
    "GI": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GL": [
        "H",
        "h"
    ],
    "GM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GN": [
        "H",
        "hB"
    ],
    "GP": [
        "H",
        "hB"
    ],
    "GQ": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "GR": [
        "h",
        "H",
        "hb",
        "hB"
    ],
    "GS": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GT": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "GU": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GW": [
        "H",
        "hB"
    ],
    "GY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "HK": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "HN": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "HR": [
        "H",
        "hB"
    ],
    "HU": [
        "H",
        "h"
    ],
    "IC": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "ID": [
        "H"
    ],
    "IE": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IL": [
        "H",
        "hB"
    ],
    "IM": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IN": [
        "h",
        "H"
    ],
    "IO": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IQ": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "IR": [
        "hB",
        "H"
    ],
    "IS": [
        "H"
    ],
    "IT": [
        "H",
        "hB"
    ],
    "JE": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "JM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "JO": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "JP": [
        "H",
        "K",
        "h"
    ],
    "KE": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "KG": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "KH": [
        "hB",
        "h",
        "H",
        "hb"
    ],
    "KI": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KM": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "KN": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KP": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "KR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "KW": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "KY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KZ": [
        "H",
        "hB"
    ],
    "LA": [
        "H",
        "hb",
        "hB",
        "h"
    ],
    "LB": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "LC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "LI": [
        "H",
        "hB",
        "h"
    ],
    "LK": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "LR": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "LS": [
        "h",
        "H"
    ],
    "LT": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "LU": [
        "H",
        "h",
        "hB"
    ],
    "LV": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "LY": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "MC": [
        "H",
        "hB"
    ],
    "MD": [
        "H",
        "hB"
    ],
    "ME": [
        "H",
        "hB",
        "h"
    ],
    "MF": [
        "H",
        "hB"
    ],
    "MG": [
        "H",
        "h"
    ],
    "MH": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "ML": [
        "H"
    ],
    "MM": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "MN": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MO": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MP": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MQ": [
        "H",
        "hB"
    ],
    "MR": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MS": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MT": [
        "H",
        "h"
    ],
    "MU": [
        "H",
        "h"
    ],
    "MV": [
        "H",
        "h"
    ],
    "MW": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MX": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "MY": [
        "hb",
        "hB",
        "h",
        "H"
    ],
    "MZ": [
        "H",
        "hB"
    ],
    "NA": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "NC": [
        "H",
        "hB"
    ],
    "NE": [
        "H"
    ],
    "NF": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NI": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "NL": [
        "H",
        "hB"
    ],
    "NO": [
        "H",
        "h"
    ],
    "NP": [
        "H",
        "h",
        "hB"
    ],
    "NR": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NU": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NZ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "OM": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PA": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PE": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PF": [
        "H",
        "h",
        "hB"
    ],
    "PG": [
        "h",
        "H"
    ],
    "PH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PK": [
        "h",
        "hB",
        "H"
    ],
    "PL": [
        "H",
        "h"
    ],
    "PM": [
        "H",
        "hB"
    ],
    "PN": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "PR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PS": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PT": [
        "H",
        "hB"
    ],
    "PW": [
        "h",
        "H"
    ],
    "PY": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "QA": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "RE": [
        "H",
        "hB"
    ],
    "RO": [
        "H",
        "hB"
    ],
    "RS": [
        "H",
        "hB",
        "h"
    ],
    "RU": [
        "H"
    ],
    "RW": [
        "H",
        "h"
    ],
    "SA": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SB": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SC": [
        "H",
        "h",
        "hB"
    ],
    "SD": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SE": [
        "H"
    ],
    "SG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SH": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "SI": [
        "H",
        "hB"
    ],
    "SJ": [
        "H"
    ],
    "SK": [
        "H"
    ],
    "SL": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SM": [
        "H",
        "h",
        "hB"
    ],
    "SN": [
        "H",
        "h",
        "hB"
    ],
    "SO": [
        "h",
        "H"
    ],
    "SR": [
        "H",
        "hB"
    ],
    "SS": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "ST": [
        "H",
        "hB"
    ],
    "SV": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "SX": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "SY": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SZ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TA": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "TC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TD": [
        "h",
        "H",
        "hB"
    ],
    "TF": [
        "H",
        "h",
        "hB"
    ],
    "TG": [
        "H",
        "hB"
    ],
    "TH": [
        "H",
        "h"
    ],
    "TJ": [
        "H",
        "h"
    ],
    "TL": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "TM": [
        "H",
        "h"
    ],
    "TN": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "TO": [
        "h",
        "H"
    ],
    "TR": [
        "H",
        "hB"
    ],
    "TT": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TW": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "TZ": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "UA": [
        "H",
        "hB",
        "h"
    ],
    "UG": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "UM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "US": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "UY": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "UZ": [
        "H",
        "hB",
        "h"
    ],
    "VA": [
        "H",
        "h",
        "hB"
    ],
    "VC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VE": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "VG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VI": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VN": [
        "H",
        "h"
    ],
    "VU": [
        "h",
        "H"
    ],
    "WF": [
        "H",
        "hB"
    ],
    "WS": [
        "h",
        "H"
    ],
    "XK": [
        "H",
        "hB",
        "h"
    ],
    "YE": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "YT": [
        "H",
        "hB"
    ],
    "ZA": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "ZM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "ZW": [
        "H",
        "h"
    ],
    "af-ZA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "ar-001": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "ca-ES": [
        "H",
        "h",
        "hB"
    ],
    "en-001": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "en-HK": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "en-IL": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "en-MY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "es-BR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-ES": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-GQ": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "fr-CA": [
        "H",
        "h",
        "hB"
    ],
    "gl-ES": [
        "H",
        "h",
        "hB"
    ],
    "gu-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "hi-IN": [
        "hB",
        "h",
        "H"
    ],
    "it-CH": [
        "H",
        "h",
        "hB"
    ],
    "it-IT": [
        "H",
        "h",
        "hB"
    ],
    "kn-IN": [
        "hB",
        "h",
        "H"
    ],
    "ku-SY": [
        "H",
        "hB"
    ],
    "ml-IN": [
        "hB",
        "h",
        "H"
    ],
    "mr-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "pa-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "ta-IN": [
        "hB",
        "h",
        "hb",
        "H"
    ],
    "te-IN": [
        "hB",
        "h",
        "H"
    ],
    "zu-ZA": [
        "H",
        "hB",
        "hb",
        "h"
    ]
};
//#endregion
//#region packages/icu-messageformat-parser/date-time-pattern-generator.ts
/**
* Returns the best matching date time pattern if a date time skeleton
* pattern is provided with a locale. Follows the Unicode specification:
* https://www.unicode.org/reports/tr35/tr35-dates.html#table-mapping-requested-time-skeletons-to-patterns
* @param skeleton date time skeleton pattern that possibly includes j, J or C
* @param locale
*/ function $2dc2f66d316cd8db$var$getBestPattern(skeleton, locale) {
    let skeletonCopy = "";
    for(let patternPos = 0; patternPos < skeleton.length; patternPos++){
        const patternChar = skeleton.charAt(patternPos);
        if (patternChar === "j") {
            let extraLength = 0;
            while(patternPos + 1 < skeleton.length && skeleton.charAt(patternPos + 1) === patternChar){
                extraLength++;
                patternPos++;
            }
            let hourLen = 1 + (extraLength & 1);
            let dayPeriodLen = extraLength < 2 ? 1 : 3 + (extraLength >> 1);
            let dayPeriodChar = "a";
            let hourChar = $2dc2f66d316cd8db$var$getDefaultHourSymbolFromLocale(locale);
            if (hourChar == "H" || hourChar == "k") dayPeriodLen = 0;
            while(dayPeriodLen-- > 0)skeletonCopy += dayPeriodChar;
            while(hourLen-- > 0)skeletonCopy = hourChar + skeletonCopy;
        } else if (patternChar === "J") skeletonCopy += "H";
        else skeletonCopy += patternChar;
    }
    return skeletonCopy;
}
/**
* Maps the [hour cycle type](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Locale/hourCycle)
* of the given `locale` to the corresponding time pattern.
* @param locale
*/ function $2dc2f66d316cd8db$var$getDefaultHourSymbolFromLocale(locale) {
    let hourCycle = locale.hourCycle;
    if (hourCycle === void 0) {
        const localeWithHourCycles = locale;
        hourCycle = localeWithHourCycles.getHourCycles?.()[0] ?? localeWithHourCycles.hourCycles?.[0];
    }
    if (hourCycle) switch(hourCycle){
        case "h24":
            return "k";
        case "h23":
            return "H";
        case "h12":
            return "h";
        case "h11":
            return "K";
        default:
            throw new Error("Invalid hourCycle");
    }
    const languageTag = locale.language;
    let regionTag;
    if (languageTag !== "root") regionTag = locale.maximize().region;
    return ($2dc2f66d316cd8db$var$timeData[`${languageTag}-${regionTag}`] || $2dc2f66d316cd8db$var$timeData[regionTag || ""] || $2dc2f66d316cd8db$var$timeData[languageTag || ""] || $2dc2f66d316cd8db$var$timeData[`${languageTag}-001`] || $2dc2f66d316cd8db$var$timeData["001"])[0].charAt(0);
}
//#endregion
//#region packages/icu-messageformat-parser/parser.ts
const $2dc2f66d316cd8db$var$SPACE_SEPARATOR_START_REGEX = new RegExp(`^${$2dc2f66d316cd8db$var$SPACE_SEPARATOR_REGEX.source}*`);
const $2dc2f66d316cd8db$var$SPACE_SEPARATOR_END_REGEX = new RegExp(`${$2dc2f66d316cd8db$var$SPACE_SEPARATOR_REGEX.source}*$`);
function $2dc2f66d316cd8db$var$createLocation(start, end) {
    return {
        start: start,
        end: end
    };
}
const $2dc2f66d316cd8db$var$hasNativeFromEntries = !!Object.fromEntries;
const $2dc2f66d316cd8db$var$hasTrimStart = !!String.prototype.trimStart;
const $2dc2f66d316cd8db$var$hasTrimEnd = !!String.prototype.trimEnd;
const $2dc2f66d316cd8db$var$fromEntries = $2dc2f66d316cd8db$var$hasNativeFromEntries ? Object.fromEntries : function fromEntries(entries) {
    const obj = {};
    for (const [k, v] of entries)obj[k] = v;
    return obj;
};
const $2dc2f66d316cd8db$var$trimStart = $2dc2f66d316cd8db$var$hasTrimStart ? function trimStart(s) {
    return s.trimStart();
} : function trimStart(s) {
    return s.replace($2dc2f66d316cd8db$var$SPACE_SEPARATOR_START_REGEX, "");
};
const $2dc2f66d316cd8db$var$trimEnd = $2dc2f66d316cd8db$var$hasTrimEnd ? function trimEnd(s) {
    return s.trimEnd();
} : function trimEnd(s) {
    return s.replace($2dc2f66d316cd8db$var$SPACE_SEPARATOR_END_REGEX, "");
};
let $2dc2f66d316cd8db$var$IDENTIFIER_PREFIX_RE = $2dc2f66d316cd8db$var$createIdentifierPrefixRegex();
function $2dc2f66d316cd8db$var$createIdentifierPrefixRegex() {
    try {
        const regex = new RegExp("([^\\p{White_Space}\\p{Pattern_Syntax}]*)", "yu");
        if (regex.exec("a ")?.[1] === "a") return regex;
    } catch  {}
    return $2dc2f66d316cd8db$var$IDENTIFIER_PREFIX_REGEX;
}
function $2dc2f66d316cd8db$var$matchIdentifierAtIndex(s, index) {
    $2dc2f66d316cd8db$var$IDENTIFIER_PREFIX_RE.lastIndex = index;
    return $2dc2f66d316cd8db$var$IDENTIFIER_PREFIX_RE.exec(s)[1] ?? "";
}
function $2dc2f66d316cd8db$var$plainTopLevelEndPosition(message) {
    if (message.length === 0) return null;
    let line = 1;
    let column = 1;
    for(let offset = 0; offset < message.length;){
        const code = message.charCodeAt(offset);
        switch(code){
            case 35:
            case 39:
            case 60:
            case 123:
            case 125:
                return null;
        }
        if (code === 10) {
            line++;
            column = 1;
            offset++;
        } else {
            column++;
            if (code >= 55296 && code <= 56319 && offset + 1 < message.length) {
                const next = message.charCodeAt(offset + 1);
                offset += next >= 56320 && next <= 57343 ? 2 : 1;
            } else offset++;
        }
    }
    return {
        offset: message.length,
        line: line,
        column: column
    };
}
var $2dc2f66d316cd8db$var$Parser = class {
    constructor(message, options = {}){
        this.message = message;
        this.position = {
            offset: 0,
            line: 1,
            column: 1
        };
        this.ignoreTag = !!options.ignoreTag;
        this.locale = options.locale;
        this.requiresOtherClause = !!options.requiresOtherClause;
        this.shouldParseSkeletons = !!options.shouldParseSkeletons;
    }
    parse() {
        if (this.offset() !== 0) throw Error("parser can only be used once");
        if (this.message.length > 0) {
            const firstCode = this.message.charCodeAt(0);
            if (firstCode !== 35 && firstCode !== 39 && firstCode !== 60 && firstCode !== 123 && firstCode !== 125) {
                const plainEndPosition = $2dc2f66d316cd8db$var$plainTopLevelEndPosition(this.message);
                if (plainEndPosition) {
                    const start = this.clonePosition();
                    this.position = plainEndPosition;
                    return {
                        val: [
                            {
                                type: 0,
                                value: this.message,
                                location: $2dc2f66d316cd8db$var$createLocation(start, this.clonePosition())
                            }
                        ],
                        err: null
                    };
                }
            }
        }
        return this.parseMessage(0, "", false);
    }
    parseMessage(nestingLevel, parentArgType, expectingCloseTag) {
        let elements = [];
        while(!this.isEOF()){
            const char = this.char();
            if (char === 123) {
                const result = this.parseArgument(nestingLevel, expectingCloseTag);
                if (result.err) return result;
                elements.push(result.val);
            } else if (char === 125 && nestingLevel > 0) break;
            else if (char === 35 && (parentArgType === "plural" || parentArgType === "selectordinal")) {
                const position = this.clonePosition();
                this.bump();
                elements.push({
                    type: 7,
                    location: $2dc2f66d316cd8db$var$createLocation(position, this.clonePosition())
                });
            } else if (char === 60 && !this.ignoreTag && this.peek() === 47) {
                if (expectingCloseTag) break;
                else return this.error(26, $2dc2f66d316cd8db$var$createLocation(this.clonePosition(), this.clonePosition()));
            } else if (char === 60 && !this.ignoreTag && $2dc2f66d316cd8db$var$_isAlpha(this.peek() || 0)) {
                const result = this.parseTag(nestingLevel, parentArgType);
                if (result.err) return result;
                elements.push(result.val);
            } else {
                const result = this.parseLiteral(nestingLevel, parentArgType);
                if (result.err) return result;
                elements.push(result.val);
            }
        }
        return {
            val: elements,
            err: null
        };
    }
    /**
	* A tag name must start with an ASCII lower/upper case letter. The grammar is based on the
	* [custom element name][] except that a dash is NOT always mandatory and uppercase letters
	* are accepted:
	*
	* ```
	* tag ::= "<" tagName (whitespace)* "/>" | "<" tagName (whitespace)* ">" message "</" tagName (whitespace)* ">"
	* tagName ::= [a-z] (PENChar)*
	* PENChar ::=
	*     "-" | "." | [0-9] | "_" | [a-z] | [A-Z] | #xB7 | [#xC0-#xD6] | [#xD8-#xF6] | [#xF8-#x37D] |
	*     [#x37F-#x1FFF] | [#x200C-#x200D] | [#x203F-#x2040] | [#x2070-#x218F] | [#x2C00-#x2FEF] |
	*     [#x3001-#xD7FF] | [#xF900-#xFDCF] | [#xFDF0-#xFFFD] | [#x10000-#xEFFFF]
	* ```
	*
	* [custom element name]: https://html.spec.whatwg.org/multipage/custom-elements.html#valid-custom-element-name
	* NOTE: We're a bit more lax here since HTML technically does not allow uppercase HTML element but we do
	* since other tag-based engines like React allow it
	*/ parseTag(nestingLevel, parentArgType) {
        const startPosition = this.clonePosition();
        this.bump();
        const tagName = this.parseTagName();
        this.bumpSpace();
        if (this.bumpIf("/>")) return {
            val: {
                type: 0,
                value: `<${tagName}/>`,
                location: $2dc2f66d316cd8db$var$createLocation(startPosition, this.clonePosition())
            },
            err: null
        };
        else if (this.bumpIf(">")) {
            const childrenResult = this.parseMessage(nestingLevel + 1, parentArgType, true);
            if (childrenResult.err) return childrenResult;
            const children = childrenResult.val;
            const endTagStartPosition = this.clonePosition();
            if (this.bumpIf("</")) {
                if (this.isEOF() || !$2dc2f66d316cd8db$var$_isAlpha(this.char())) return this.error(23, $2dc2f66d316cd8db$var$createLocation(endTagStartPosition, this.clonePosition()));
                const closingTagNameStartPosition = this.clonePosition();
                if (tagName !== this.parseTagName()) return this.error(26, $2dc2f66d316cd8db$var$createLocation(closingTagNameStartPosition, this.clonePosition()));
                this.bumpSpace();
                if (!this.bumpIf(">")) return this.error(23, $2dc2f66d316cd8db$var$createLocation(endTagStartPosition, this.clonePosition()));
                return {
                    val: {
                        type: 8,
                        value: tagName,
                        children: children,
                        location: $2dc2f66d316cd8db$var$createLocation(startPosition, this.clonePosition())
                    },
                    err: null
                };
            } else return this.error(27, $2dc2f66d316cd8db$var$createLocation(startPosition, this.clonePosition()));
        } else return this.error(23, $2dc2f66d316cd8db$var$createLocation(startPosition, this.clonePosition()));
    }
    /**
	* This method assumes that the caller has peeked ahead for the first tag character.
	*/ parseTagName() {
        const startOffset = this.offset();
        this.bump();
        while(!this.isEOF() && $2dc2f66d316cd8db$var$_isPotentialElementNameChar(this.char()))this.bump();
        return this.message.slice(startOffset, this.offset());
    }
    parseLiteral(nestingLevel, parentArgType) {
        const start = this.clonePosition();
        let value = "";
        while(true){
            const parseQuoteResult = this.tryParseQuote(parentArgType);
            if (parseQuoteResult) {
                value += parseQuoteResult;
                continue;
            }
            const parseUnquotedResult = this.tryParseUnquoted(nestingLevel, parentArgType);
            if (parseUnquotedResult) {
                value += parseUnquotedResult;
                continue;
            }
            const parseLeftAngleResult = this.tryParseLeftAngleBracket();
            if (parseLeftAngleResult) {
                value += parseLeftAngleResult;
                continue;
            }
            break;
        }
        const location = $2dc2f66d316cd8db$var$createLocation(start, this.clonePosition());
        return {
            val: {
                type: 0,
                value: value,
                location: location
            },
            err: null
        };
    }
    tryParseLeftAngleBracket() {
        if (!this.isEOF() && this.char() === 60 && (this.ignoreTag || !$2dc2f66d316cd8db$var$_isAlphaOrSlash(this.peek() || 0))) {
            this.bump();
            return "<";
        }
        return null;
    }
    /**
	* Starting with ICU 4.8, an ASCII apostrophe only starts quoted text if it immediately precedes
	* a character that requires quoting (that is, "only where needed"), and works the same in
	* nested messages as on the top level of the pattern. The new behavior is otherwise compatible.
	*/ tryParseQuote(parentArgType) {
        if (this.isEOF() || this.char() !== 39) return null;
        switch(this.peek()){
            case 39:
                this.bump();
                this.bump();
                return "'";
            case 123:
            case 60:
            case 62:
            case 125:
                break;
            case 35:
                if (parentArgType === "plural" || parentArgType === "selectordinal") break;
                return null;
            default:
                return null;
        }
        this.bump();
        const codePoints = [
            this.char()
        ];
        this.bump();
        while(!this.isEOF()){
            const ch = this.char();
            if (ch === 39) {
                if (this.peek() === 39) {
                    codePoints.push(39);
                    this.bump();
                } else {
                    this.bump();
                    break;
                }
            } else codePoints.push(ch);
            this.bump();
        }
        return String.fromCodePoint(...codePoints);
    }
    tryParseUnquoted(nestingLevel, parentArgType) {
        if (this.isEOF()) return null;
        const ch = this.char();
        if (ch === 60 || ch === 123 || ch === 35 && (parentArgType === "plural" || parentArgType === "selectordinal") || ch === 125 && nestingLevel > 0) return null;
        else {
            this.bump();
            return String.fromCodePoint(ch);
        }
    }
    parseArgument(nestingLevel, expectingCloseTag) {
        const openingBracePosition = this.clonePosition();
        this.bump();
        this.bumpSpace();
        if (this.isEOF()) return this.error(1, $2dc2f66d316cd8db$var$createLocation(openingBracePosition, this.clonePosition()));
        if (this.char() === 125) {
            this.bump();
            return this.error(2, $2dc2f66d316cd8db$var$createLocation(openingBracePosition, this.clonePosition()));
        }
        let value = this.parseIdentifierIfPossible().value;
        if (!value) return this.error(3, $2dc2f66d316cd8db$var$createLocation(openingBracePosition, this.clonePosition()));
        this.bumpSpace();
        if (this.isEOF()) return this.error(1, $2dc2f66d316cd8db$var$createLocation(openingBracePosition, this.clonePosition()));
        switch(this.char()){
            case 125:
                this.bump();
                return {
                    val: {
                        type: 1,
                        value: value,
                        location: $2dc2f66d316cd8db$var$createLocation(openingBracePosition, this.clonePosition())
                    },
                    err: null
                };
            case 44:
                this.bump();
                this.bumpSpace();
                if (this.isEOF()) return this.error(1, $2dc2f66d316cd8db$var$createLocation(openingBracePosition, this.clonePosition()));
                return this.parseArgumentOptions(nestingLevel, expectingCloseTag, value, openingBracePosition);
            default:
                return this.error(3, $2dc2f66d316cd8db$var$createLocation(openingBracePosition, this.clonePosition()));
        }
    }
    /**
	* Advance the parser until the end of the identifier, if it is currently on
	* an identifier character. Return an empty string otherwise.
	*/ parseIdentifierIfPossible() {
        const startingPosition = this.clonePosition();
        const startOffset = this.offset();
        const value = $2dc2f66d316cd8db$var$matchIdentifierAtIndex(this.message, startOffset);
        const endOffset = startOffset + value.length;
        this.bumpTo(endOffset);
        return {
            value: value,
            location: $2dc2f66d316cd8db$var$createLocation(startingPosition, this.clonePosition())
        };
    }
    parseArgumentOptions(nestingLevel, expectingCloseTag, value, openingBracePosition) {
        let typeStartPosition = this.clonePosition();
        let argType = this.parseIdentifierIfPossible().value;
        let typeEndPosition = this.clonePosition();
        switch(argType){
            case "":
                return this.error(4, $2dc2f66d316cd8db$var$createLocation(typeStartPosition, typeEndPosition));
            case "number":
            case "date":
            case "time":
                {
                    this.bumpSpace();
                    let styleAndLocation = null;
                    if (this.bumpIf(",")) {
                        this.bumpSpace();
                        const styleStartPosition = this.clonePosition();
                        const result = this.parseSimpleArgStyleIfPossible();
                        if (result.err) return result;
                        const style = $2dc2f66d316cd8db$var$trimEnd(result.val);
                        if (style.length === 0) return this.error(6, $2dc2f66d316cd8db$var$createLocation(this.clonePosition(), this.clonePosition()));
                        styleAndLocation = {
                            style: style,
                            styleLocation: $2dc2f66d316cd8db$var$createLocation(styleStartPosition, this.clonePosition())
                        };
                    }
                    const argCloseResult = this.tryParseArgumentClose(openingBracePosition);
                    if (argCloseResult.err) return argCloseResult;
                    const location = $2dc2f66d316cd8db$var$createLocation(openingBracePosition, this.clonePosition());
                    if (styleAndLocation && styleAndLocation.style.startsWith("::")) {
                        let skeleton = $2dc2f66d316cd8db$var$trimStart(styleAndLocation.style.slice(2));
                        if (argType === "number") {
                            const result = this.parseNumberSkeletonFromString(skeleton, styleAndLocation.styleLocation);
                            if (result.err) return result;
                            return {
                                val: {
                                    type: 2,
                                    value: value,
                                    location: location,
                                    style: result.val
                                },
                                err: null
                            };
                        } else {
                            if (skeleton.length === 0) return this.error(10, location);
                            let dateTimePattern = skeleton;
                            if (this.locale) dateTimePattern = $2dc2f66d316cd8db$var$getBestPattern(skeleton, this.locale);
                            const style = {
                                type: 1,
                                pattern: dateTimePattern,
                                location: styleAndLocation.styleLocation,
                                parsedOptions: this.shouldParseSkeletons ? (0, $d4d3fc9f6275a50a$export$f7b99fb377fe69fa)(dateTimePattern) : {}
                            };
                            return {
                                val: {
                                    type: argType === "date" ? 3 : 4,
                                    value: value,
                                    location: location,
                                    style: style
                                },
                                err: null
                            };
                        }
                    }
                    return {
                        val: {
                            type: argType === "number" ? 2 : argType === "date" ? 3 : 4,
                            value: value,
                            location: location,
                            style: styleAndLocation?.style ?? null
                        },
                        err: null
                    };
                }
            case "plural":
            case "selectordinal":
            case "select":
                {
                    const typeEndPosition = this.clonePosition();
                    this.bumpSpace();
                    if (!this.bumpIf(",")) return this.error(12, $2dc2f66d316cd8db$var$createLocation(typeEndPosition, {
                        ...typeEndPosition
                    }));
                    this.bumpSpace();
                    let identifierAndLocation = this.parseIdentifierIfPossible();
                    let pluralOffset = 0;
                    if (argType !== "select" && identifierAndLocation.value === "offset") {
                        if (!this.bumpIf(":")) return this.error(13, $2dc2f66d316cd8db$var$createLocation(this.clonePosition(), this.clonePosition()));
                        this.bumpSpace();
                        const result = this.tryParseDecimalInteger(13, 14);
                        if (result.err) return result;
                        this.bumpSpace();
                        identifierAndLocation = this.parseIdentifierIfPossible();
                        pluralOffset = result.val;
                    }
                    const optionsResult = this.tryParsePluralOrSelectOptions(nestingLevel, argType, expectingCloseTag, identifierAndLocation);
                    if (optionsResult.err) return optionsResult;
                    const argCloseResult = this.tryParseArgumentClose(openingBracePosition);
                    if (argCloseResult.err) return argCloseResult;
                    const location = $2dc2f66d316cd8db$var$createLocation(openingBracePosition, this.clonePosition());
                    if (argType === "select") return {
                        val: {
                            type: 5,
                            value: value,
                            options: $2dc2f66d316cd8db$var$fromEntries(optionsResult.val),
                            location: location
                        },
                        err: null
                    };
                    else return {
                        val: {
                            type: 6,
                            value: value,
                            options: $2dc2f66d316cd8db$var$fromEntries(optionsResult.val),
                            offset: pluralOffset,
                            pluralType: argType === "plural" ? "cardinal" : "ordinal",
                            location: location
                        },
                        err: null
                    };
                }
            default:
                return this.error(5, $2dc2f66d316cd8db$var$createLocation(typeStartPosition, typeEndPosition));
        }
    }
    tryParseArgumentClose(openingBracePosition) {
        if (this.isEOF() || this.char() !== 125) return this.error(1, $2dc2f66d316cd8db$var$createLocation(openingBracePosition, this.clonePosition()));
        this.bump();
        return {
            val: true,
            err: null
        };
    }
    /**
	* See: https://github.com/unicode-org/icu/blob/af7ed1f6d2298013dc303628438ec4abe1f16479/icu4c/source/common/messagepattern.cpp#L659
	*/ parseSimpleArgStyleIfPossible() {
        let nestedBraces = 0;
        const startPosition = this.clonePosition();
        while(!this.isEOF())switch(this.char()){
            case 39:
                {
                    this.bump();
                    let apostrophePosition = this.clonePosition();
                    if (!this.bumpUntil("'")) return this.error(11, $2dc2f66d316cd8db$var$createLocation(apostrophePosition, this.clonePosition()));
                    this.bump();
                    break;
                }
            case 123:
                nestedBraces += 1;
                this.bump();
                break;
            case 125:
                if (nestedBraces > 0) nestedBraces -= 1;
                else return {
                    val: this.message.slice(startPosition.offset, this.offset()),
                    err: null
                };
                break;
            default:
                this.bump();
        }
        return {
            val: this.message.slice(startPosition.offset, this.offset()),
            err: null
        };
    }
    parseNumberSkeletonFromString(skeleton, location) {
        let tokens = [];
        try {
            tokens = (0, $d4d3fc9f6275a50a$export$71cee2f16fba2480)(skeleton);
        } catch  {
            return this.error(7, location);
        }
        return {
            val: {
                type: 0,
                tokens: tokens,
                location: location,
                parsedOptions: this.shouldParseSkeletons ? (0, $d4d3fc9f6275a50a$export$47c6f8480bda3e11)(tokens) : {}
            },
            err: null
        };
    }
    /**
	* @param nesting_level The current nesting level of messages.
	*     This can be positive when parsing message fragment in select or plural argument options.
	* @param parent_arg_type The parent argument's type.
	* @param parsed_first_identifier If provided, this is the first identifier-like selector of
	*     the argument. It is a by-product of a previous parsing attempt.
	* @param expecting_close_tag If true, this message is directly or indirectly nested inside
	*     between a pair of opening and closing tags. The nested message will not parse beyond
	*     the closing tag boundary.
	*/ tryParsePluralOrSelectOptions(nestingLevel, parentArgType, expectCloseTag, parsedFirstIdentifier) {
        let hasOtherClause = false;
        const options = [];
        const parsedSelectors = /* @__PURE__ */ new Set();
        let { value: selector, location: selectorLocation } = parsedFirstIdentifier;
        while(true){
            if (selector.length === 0) {
                const startPosition = this.clonePosition();
                if (parentArgType !== "select" && this.bumpIf("=")) {
                    const result = this.tryParseDecimalInteger(16, 19);
                    if (result.err) return result;
                    selectorLocation = $2dc2f66d316cd8db$var$createLocation(startPosition, this.clonePosition());
                    selector = this.message.slice(startPosition.offset, this.offset());
                } else break;
            }
            if (parsedSelectors.has(selector)) return this.error(parentArgType === "select" ? 21 : 20, selectorLocation);
            if (selector === "other") hasOtherClause = true;
            this.bumpSpace();
            const openingBracePosition = this.clonePosition();
            if (!this.bumpIf("{")) return this.error(parentArgType === "select" ? 17 : 18, $2dc2f66d316cd8db$var$createLocation(this.clonePosition(), this.clonePosition()));
            const fragmentResult = this.parseMessage(nestingLevel + 1, parentArgType, expectCloseTag);
            if (fragmentResult.err) return fragmentResult;
            const argCloseResult = this.tryParseArgumentClose(openingBracePosition);
            if (argCloseResult.err) return argCloseResult;
            options.push([
                selector,
                {
                    value: fragmentResult.val,
                    location: $2dc2f66d316cd8db$var$createLocation(openingBracePosition, this.clonePosition())
                }
            ]);
            parsedSelectors.add(selector);
            this.bumpSpace();
            ({ value: selector, location: selectorLocation } = this.parseIdentifierIfPossible());
        }
        if (options.length === 0) return this.error(parentArgType === "select" ? 15 : 16, $2dc2f66d316cd8db$var$createLocation(this.clonePosition(), this.clonePosition()));
        if (this.requiresOtherClause && !hasOtherClause) return this.error(22, $2dc2f66d316cd8db$var$createLocation(this.clonePosition(), this.clonePosition()));
        return {
            val: options,
            err: null
        };
    }
    tryParseDecimalInteger(expectNumberError, invalidNumberError) {
        let sign = 1;
        const startingPosition = this.clonePosition();
        if (this.bumpIf("+")) ;
        else if (this.bumpIf("-")) sign = -1;
        let hasDigits = false;
        let decimal = 0;
        while(!this.isEOF()){
            const ch = this.char();
            if (ch >= 48 && ch <= 57) {
                hasDigits = true;
                decimal = decimal * 10 + (ch - 48);
                this.bump();
            } else break;
        }
        const location = $2dc2f66d316cd8db$var$createLocation(startingPosition, this.clonePosition());
        if (!hasDigits) return this.error(expectNumberError, location);
        decimal *= sign;
        if (!Number.isSafeInteger(decimal)) return this.error(invalidNumberError, location);
        return {
            val: decimal,
            err: null
        };
    }
    offset() {
        return this.position.offset;
    }
    isEOF() {
        return this.offset() === this.message.length;
    }
    clonePosition() {
        return {
            offset: this.position.offset,
            line: this.position.line,
            column: this.position.column
        };
    }
    /**
	* Return the code point at the current position of the parser.
	* Throws if the index is out of bound.
	*/ char() {
        const offset = this.position.offset;
        if (offset >= this.message.length) throw Error("out of bound");
        const code = this.message.codePointAt(offset);
        if (code === void 0) throw Error(`Offset ${offset} is at invalid UTF-16 code unit boundary`);
        return code;
    }
    error(kind, location) {
        return {
            val: null,
            err: {
                kind: kind,
                message: this.message,
                location: location
            }
        };
    }
    /** Bump the parser to the next UTF-16 code unit. */ bump() {
        if (this.isEOF()) return;
        const code = this.char();
        if (code === 10) {
            this.position.line += 1;
            this.position.column = 1;
            this.position.offset += 1;
        } else {
            this.position.column += 1;
            this.position.offset += code < 65536 ? 1 : 2;
        }
    }
    /**
	* If the substring starting at the current position of the parser has
	* the given prefix, then bump the parser to the character immediately
	* following the prefix and return true. Otherwise, don't bump the parser
	* and return false.
	*/ bumpIf(prefix) {
        const offset = this.offset();
        if (this.message.slice(offset, offset + prefix.length) === prefix) {
            for(let i = 0; i < prefix.length; i++)this.bump();
            return true;
        }
        return false;
    }
    /**
	* Bump the parser until the pattern character is found and return `true`.
	* Otherwise bump to the end of the file and return `false`.
	*/ bumpUntil(pattern) {
        const currentOffset = this.offset();
        const index = this.message.indexOf(pattern, currentOffset);
        if (index >= 0) {
            this.bumpTo(index);
            return true;
        } else {
            this.bumpTo(this.message.length);
            return false;
        }
    }
    /**
	* Bump the parser to the target offset.
	* If target offset is beyond the end of the input, bump the parser to the end of the input.
	*/ bumpTo(targetOffset) {
        if (this.offset() > targetOffset) throw Error(`targetOffset ${targetOffset} must be greater than or equal to the current offset ${this.offset()}`);
        targetOffset = Math.min(targetOffset, this.message.length);
        while(true){
            const offset = this.offset();
            if (offset === targetOffset) break;
            if (offset > targetOffset) throw Error(`targetOffset ${targetOffset} is at invalid UTF-16 code unit boundary`);
            this.bump();
            if (this.isEOF()) break;
        }
    }
    /** advance the parser through all whitespace to the next non-whitespace code unit. */ bumpSpace() {
        while(!this.isEOF() && $2dc2f66d316cd8db$var$_isWhiteSpace(this.char()))this.bump();
    }
    /**
	* Peek at the *next* Unicode codepoint in the input without advancing the parser.
	* If the input has been exhausted, then this returns null.
	*/ peek() {
        if (this.isEOF()) return null;
        const code = this.char();
        const offset = this.offset();
        return this.message.charCodeAt(offset + (code >= 65536 ? 2 : 1)) ?? null;
    }
};
/**
* This check if codepoint is alphabet (lower & uppercase)
* @param codepoint
* @returns
*/ function $2dc2f66d316cd8db$var$_isAlpha(codepoint) {
    return codepoint >= 97 && codepoint <= 122 || codepoint >= 65 && codepoint <= 90;
}
function $2dc2f66d316cd8db$var$_isAlphaOrSlash(codepoint) {
    return $2dc2f66d316cd8db$var$_isAlpha(codepoint) || codepoint === 47;
}
/** See `parseTag` function docs. */ function $2dc2f66d316cd8db$var$_isPotentialElementNameChar(c) {
    return c === 45 || c === 46 || c >= 48 && c <= 57 || c === 95 || c >= 97 && c <= 122 || c >= 65 && c <= 90 || c == 183 || c >= 192 && c <= 214 || c >= 216 && c <= 246 || c >= 248 && c <= 893 || c >= 895 && c <= 8191 || c >= 8204 && c <= 8205 || c >= 8255 && c <= 8256 || c >= 8304 && c <= 8591 || c >= 11264 && c <= 12271 || c >= 12289 && c <= 55295 || c >= 63744 && c <= 64975 || c >= 65008 && c <= 65533 || c >= 65536 && c <= 983039;
}
/**
* Code point equivalent of regex `\p{White_Space}`.
* From: https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
*/ function $2dc2f66d316cd8db$var$_isWhiteSpace(c) {
    return c >= 9 && c <= 13 || c === 32 || c === 133 || c >= 8206 && c <= 8207 || c === 8232 || c === 8233;
}
//#endregion
//#region packages/icu-messageformat-parser/manipulator.ts
/**
* Collect all variables in an AST to Record<string, TYPE>
* @param ast AST to collect variables from
* @param vars Record of variable name to variable type
*/ function $2dc2f66d316cd8db$var$collectVariables(ast, vars = /* @__PURE__ */ new Map()) {
    ast.forEach((el)=>{
        if ($2dc2f66d316cd8db$export$4f55724281bdfaf9(el) || $2dc2f66d316cd8db$export$32d811605da75f40(el) || $2dc2f66d316cd8db$export$34ec46f596b1702f(el) || $2dc2f66d316cd8db$export$e11187b219e191e1(el)) {
            if (vars.has(el.value)) {
                const existingType = vars.get(el.value);
                if (existingType !== el.type && existingType !== 6 && existingType !== 5) throw new Error(`Variable ${el.value} has conflicting types`);
            } else vars.set(el.value, el.type);
        }
        if ($2dc2f66d316cd8db$export$6c796d116f0a4fbc(el) || $2dc2f66d316cd8db$export$dcfe1c11d168b5a1(el)) {
            vars.set(el.value, el.type);
            Object.keys(el.options).forEach((k)=>{
                $2dc2f66d316cd8db$var$collectVariables(el.options[k].value, vars);
            });
        }
        if ($2dc2f66d316cd8db$export$5c83de34745812b(el)) {
            vars.set(el.value, el.type);
            $2dc2f66d316cd8db$var$collectVariables(el.children, vars);
        }
    });
}
/**
* Check if 2 ASTs are structurally the same. This primarily means that
* they have the same variables with the same type
* @param a
* @param b
* @returns
*/ function $2dc2f66d316cd8db$export$1edd9c892fdd9d27(a, b) {
    const aVars = /* @__PURE__ */ new Map();
    const bVars = /* @__PURE__ */ new Map();
    $2dc2f66d316cd8db$var$collectVariables(a, aVars);
    $2dc2f66d316cd8db$var$collectVariables(b, bVars);
    if (aVars.size !== bVars.size) return {
        success: false,
        error: /* @__PURE__ */ new Error(`Different number of variables: [${Array.from(aVars.keys()).join(", ")}] vs [${Array.from(bVars.keys()).join(", ")}]`)
    };
    return Array.from(aVars.entries()).reduce((result, [key, type])=>{
        if (!result.success) return result;
        const bType = bVars.get(key);
        if (bType == null) return {
            success: false,
            error: /* @__PURE__ */ new Error(`Missing variable ${key} in message`)
        };
        if (bType !== type) return {
            success: false,
            error: /* @__PURE__ */ new Error(`Variable ${key} has conflicting types: ${$2dc2f66d316cd8db$export$b87f371cbc396fcf[type]} vs ${$2dc2f66d316cd8db$export$b87f371cbc396fcf[bType]}`)
        };
        return result;
    }, {
        success: true
    });
}
//#endregion
//#region packages/icu-messageformat-parser/index.ts
function $2dc2f66d316cd8db$var$pruneLocation(els) {
    els.forEach((el)=>{
        delete el.location;
        if ($2dc2f66d316cd8db$export$dcfe1c11d168b5a1(el) || $2dc2f66d316cd8db$export$6c796d116f0a4fbc(el)) for(const k in el.options){
            delete el.options[k].location;
            $2dc2f66d316cd8db$var$pruneLocation(el.options[k].value);
        }
        else if ($2dc2f66d316cd8db$export$e11187b219e191e1(el) && $2dc2f66d316cd8db$export$3f9a19cd4152eda3(el.style)) delete el.style.location;
        else if (($2dc2f66d316cd8db$export$32d811605da75f40(el) || $2dc2f66d316cd8db$export$34ec46f596b1702f(el)) && $2dc2f66d316cd8db$export$7680c41f1a55f4cf(el.style)) delete el.style.location;
        else if ($2dc2f66d316cd8db$export$5c83de34745812b(el)) $2dc2f66d316cd8db$var$pruneLocation(el.children);
    });
}
function $2dc2f66d316cd8db$export$98e6a39c04603d36(message, opts = {}) {
    opts = {
        shouldParseSkeletons: true,
        requiresOtherClause: true,
        ...opts
    };
    const result = new $2dc2f66d316cd8db$var$Parser(message, opts).parse();
    if (result.err) {
        const error = SyntaxError($2dc2f66d316cd8db$var$ErrorKind[result.err.kind]);
        error.location = result.err.location;
        error.originalMessage = result.err.message;
        throw error;
    }
    if (!opts?.captureLocation) $2dc2f66d316cd8db$var$pruneLocation(result.val);
    return result.val;
}
const $2dc2f66d316cd8db$export$d3c1bfa0f7d806e9 = $2dc2f66d316cd8db$var$Parser;


//#region packages/intl-messageformat/error.ts
let $cce7b597e4178fb0$export$d4e71bc0b80dc0fb = /* @__PURE__ */ function(ErrorCode) {
    ErrorCode["MISSING_VALUE"] = "MISSING_VALUE";
    ErrorCode["INVALID_VALUE"] = "INVALID_VALUE";
    ErrorCode["MISSING_INTL_API"] = "MISSING_INTL_API";
    return ErrorCode;
}({});
var $cce7b597e4178fb0$export$7369836851cc1329 = class extends Error {
    constructor(msg, code, originalMessage){
        super(msg);
        this.code = code;
        this.originalMessage = originalMessage;
    }
    toString() {
        return `[formatjs Error: ${this.code}] ${this.message}`;
    }
};
var $cce7b597e4178fb0$export$565c3afc07dfa382 = class extends $cce7b597e4178fb0$export$7369836851cc1329 {
    constructor(variableId, value, options, originalMessage){
        super(`Invalid values for "${variableId}": "${value}". Options are "${Object.keys(options).join("\", \"")}"`, "INVALID_VALUE", originalMessage);
    }
};
var $cce7b597e4178fb0$export$cbc0db47c750f7c9 = class extends $cce7b597e4178fb0$export$7369836851cc1329 {
    constructor(value, type, originalMessage){
        super(`Value for "${value}" must be of type ${type}`, "INVALID_VALUE", originalMessage);
    }
};
var $cce7b597e4178fb0$export$8bfc137e4d23fdf0 = class extends $cce7b597e4178fb0$export$7369836851cc1329 {
    constructor(variableId, originalMessage){
        super(`The intl string context variable "${variableId}" was not provided to the string "${originalMessage}"`, "MISSING_VALUE", originalMessage);
    }
};
//#endregion
//#region packages/intl-messageformat/formatters.ts
let $cce7b597e4178fb0$export$49694c2877b44c57 = /* @__PURE__ */ function(PART_TYPE) {
    PART_TYPE[PART_TYPE["literal"] = 0] = "literal";
    PART_TYPE[PART_TYPE["object"] = 1] = "object";
    return PART_TYPE;
}({});
function $cce7b597e4178fb0$var$mergeLiteral(parts) {
    if (parts.length < 2) return parts;
    return parts.reduce((all, part)=>{
        const lastPart = all[all.length - 1];
        if (!lastPart || lastPart.type !== 0 || part.type !== 0) all.push(part);
        else lastPart.value += part.value;
        return all;
    }, []);
}
function $cce7b597e4178fb0$export$df0c12a2d414a163(el) {
    return typeof el === "function";
}
function $cce7b597e4178fb0$export$275d4a3bb5f66fda(els, locales, formatters, formats, values, currentPluralValue, originalMessage) {
    if (els.length === 1 && (0, $2dc2f66d316cd8db$export$cfa10c5697238752)(els[0])) return [
        {
            type: 0,
            value: els[0].value
        }
    ];
    const result = [];
    for (const el of els){
        if ((0, $2dc2f66d316cd8db$export$cfa10c5697238752)(el)) {
            result.push({
                type: 0,
                value: el.value
            });
            continue;
        }
        if ((0, $2dc2f66d316cd8db$export$c0ece297bdd0c082)(el)) {
            if (typeof currentPluralValue === "number") result.push({
                type: 0,
                value: formatters.getNumberFormat(locales).format(currentPluralValue)
            });
            continue;
        }
        const { value: varName } = el;
        if (!(values && varName in values)) throw new $cce7b597e4178fb0$export$8bfc137e4d23fdf0(varName, originalMessage);
        let value = values[varName];
        if ((0, $2dc2f66d316cd8db$export$4f55724281bdfaf9)(el)) {
            if (!value || typeof value === "string" || typeof value === "number" || typeof value === "bigint") value = typeof value === "string" || typeof value === "number" || typeof value === "bigint" ? String(value) : "";
            result.push({
                type: typeof value === "string" ? 0 : 1,
                value: value
            });
            continue;
        }
        if ((0, $2dc2f66d316cd8db$export$32d811605da75f40)(el)) {
            const style = typeof el.style === "string" ? formats.date[el.style] : (0, $2dc2f66d316cd8db$export$7680c41f1a55f4cf)(el.style) ? el.style.parsedOptions : void 0;
            result.push({
                type: 0,
                value: formatters.getDateTimeFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $2dc2f66d316cd8db$export$34ec46f596b1702f)(el)) {
            const style = typeof el.style === "string" ? formats.time[el.style] : (0, $2dc2f66d316cd8db$export$7680c41f1a55f4cf)(el.style) ? el.style.parsedOptions : formats.time.medium;
            result.push({
                type: 0,
                value: formatters.getDateTimeFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $2dc2f66d316cd8db$export$e11187b219e191e1)(el)) {
            const style = typeof el.style === "string" ? formats.number[el.style] : (0, $2dc2f66d316cd8db$export$3f9a19cd4152eda3)(el.style) ? el.style.parsedOptions : void 0;
            if (style && style.scale) {
                const scale = style.scale || 1;
                if (typeof value === "bigint") {
                    if (!Number.isInteger(scale)) throw new TypeError(`Cannot apply fractional scale ${scale} to bigint value. Scale must be an integer when formatting bigint.`);
                    value = value * BigInt(scale);
                } else value = value * scale;
            }
            result.push({
                type: 0,
                value: formatters.getNumberFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $2dc2f66d316cd8db$export$5c83de34745812b)(el)) {
            const { children: children, value: value } = el;
            const formatFn = values[value];
            if (!$cce7b597e4178fb0$export$df0c12a2d414a163(formatFn)) throw new $cce7b597e4178fb0$export$cbc0db47c750f7c9(value, "function", originalMessage);
            let chunks = formatFn($cce7b597e4178fb0$export$275d4a3bb5f66fda(children, locales, formatters, formats, values, currentPluralValue).map((p)=>p.value));
            if (!Array.isArray(chunks)) chunks = [
                chunks
            ];
            result.push(...chunks.map((c)=>{
                return {
                    type: typeof c === "string" ? 0 : 1,
                    value: c
                };
            }));
        }
        if ((0, $2dc2f66d316cd8db$export$dcfe1c11d168b5a1)(el)) {
            const key = value;
            const opt = (Object.prototype.hasOwnProperty.call(el.options, key) ? el.options[key] : void 0) || el.options.other;
            if (!opt) throw new $cce7b597e4178fb0$export$565c3afc07dfa382(el.value, value, Object.keys(el.options), originalMessage);
            result.push(...$cce7b597e4178fb0$export$275d4a3bb5f66fda(opt.value, locales, formatters, formats, values));
            continue;
        }
        if ((0, $2dc2f66d316cd8db$export$6c796d116f0a4fbc)(el)) {
            const exactKey = `=${value}`;
            let opt = Object.prototype.hasOwnProperty.call(el.options, exactKey) ? el.options[exactKey] : void 0;
            if (!opt) {
                if (!Intl.PluralRules) throw new $cce7b597e4178fb0$export$7369836851cc1329(`Intl.PluralRules is not available in this environment.
Try polyfilling it using "@formatjs/intl-pluralrules"
`, "MISSING_INTL_API", originalMessage);
                const numericValue = typeof value === "bigint" ? Number(value) : value;
                const rule = formatters.getPluralRules(locales, {
                    type: el.pluralType
                }).select(numericValue - (el.offset || 0));
                opt = (Object.prototype.hasOwnProperty.call(el.options, rule) ? el.options[rule] : void 0) || el.options.other;
            }
            if (!opt) throw new $cce7b597e4178fb0$export$565c3afc07dfa382(el.value, value, Object.keys(el.options), originalMessage);
            const numericValue = typeof value === "bigint" ? Number(value) : value;
            result.push(...$cce7b597e4178fb0$export$275d4a3bb5f66fda(opt.value, locales, formatters, formats, values, numericValue - (el.offset || 0)));
            continue;
        }
    }
    return $cce7b597e4178fb0$var$mergeLiteral(result);
}
//#endregion
//#region packages/intl-messageformat/core.ts
function $cce7b597e4178fb0$var$mergeConfig(c1, c2) {
    if (!c2) return c1;
    return {
        ...c1,
        ...c2,
        ...Object.keys(c1).reduce((all, k)=>{
            all[k] = {
                ...c1[k],
                ...c2[k]
            };
            return all;
        }, {})
    };
}
function $cce7b597e4178fb0$var$mergeConfigs(defaultConfig, configs) {
    if (!configs) return defaultConfig;
    return Object.keys(defaultConfig).reduce((all, k)=>{
        all[k] = $cce7b597e4178fb0$var$mergeConfig(defaultConfig[k], configs[k]);
        return all;
    }, {
        ...defaultConfig
    });
}
function $cce7b597e4178fb0$var$createFastMemoizeCache(store) {
    return {
        create () {
            return {
                get (key) {
                    return store[key];
                },
                set (key, value) {
                    store[key] = value;
                }
            };
        }
    };
}
function $cce7b597e4178fb0$var$createDefaultFormatters(cache = {
    number: {},
    dateTime: {},
    pluralRules: {}
}) {
    return {
        getNumberFormat: (0, $7bac09121bc9431c$export$fc10aeed3a532e2a)((...args)=>new Intl.NumberFormat(...args), {
            cache: $cce7b597e4178fb0$var$createFastMemoizeCache(cache.number),
            strategy: (0, $7bac09121bc9431c$export$c5491a8691a23b9e).variadic
        }),
        getDateTimeFormat: (0, $7bac09121bc9431c$export$fc10aeed3a532e2a)((...args)=>new Intl.DateTimeFormat(...args), {
            cache: $cce7b597e4178fb0$var$createFastMemoizeCache(cache.dateTime),
            strategy: (0, $7bac09121bc9431c$export$c5491a8691a23b9e).variadic
        }),
        getPluralRules: (0, $7bac09121bc9431c$export$fc10aeed3a532e2a)((...args)=>new Intl.PluralRules(...args), {
            cache: $cce7b597e4178fb0$var$createFastMemoizeCache(cache.pluralRules),
            strategy: (0, $7bac09121bc9431c$export$c5491a8691a23b9e).variadic
        })
    };
}
var $cce7b597e4178fb0$export$d342343268debc40 = class IntlMessageFormat {
    constructor(message, locales = IntlMessageFormat.defaultLocale, overrideFormats, opts){
        this.formatterCache = {
            number: {},
            dateTime: {},
            pluralRules: {}
        };
        this.format = (values)=>{
            const parts = this.formatToParts(values);
            if (parts.length === 1) return parts[0].value;
            const result = parts.reduce((all, part)=>{
                if (!all.length || part.type !== 0 || typeof all[all.length - 1] !== "string") all.push(part.value);
                else all[all.length - 1] += part.value;
                return all;
            }, []);
            if (result.length <= 1) return result[0] || "";
            return result;
        };
        this.formatToParts = (values)=>$cce7b597e4178fb0$export$275d4a3bb5f66fda(this.ast, this.locales, this.formatters, this.formats, values, void 0, this.message);
        this.resolvedOptions = ()=>({
                locale: this.resolvedLocale?.toString() || Intl.NumberFormat.supportedLocalesOf(this.locales)[0]
            });
        this.getAst = ()=>this.ast;
        this.locales = locales;
        this.resolvedLocale = IntlMessageFormat.resolveLocale(locales);
        if (typeof message === "string") {
            this.message = message;
            if (!IntlMessageFormat.__parse) throw new TypeError("IntlMessageFormat.__parse must be set to process `message` of type `string`");
            const { ...parseOpts } = opts || {};
            this.ast = IntlMessageFormat.__parse(message, {
                ...parseOpts,
                locale: this.resolvedLocale
            });
        } else this.ast = message;
        if (!Array.isArray(this.ast)) throw new TypeError("A message must be provided as a String or AST.");
        this.formats = $cce7b597e4178fb0$var$mergeConfigs(IntlMessageFormat.formats, overrideFormats);
        this.formatters = opts && opts.formatters || $cce7b597e4178fb0$var$createDefaultFormatters(this.formatterCache);
    }
    static{
        this.memoizedDefaultLocale = null;
    }
    static get defaultLocale() {
        if (!IntlMessageFormat.memoizedDefaultLocale) IntlMessageFormat.memoizedDefaultLocale = new Intl.NumberFormat().resolvedOptions().locale;
        return IntlMessageFormat.memoizedDefaultLocale;
    }
    static{
        this.resolveLocale = (locales)=>{
            if (typeof Intl.Locale === "undefined") return;
            const supportedLocales = Intl.NumberFormat.supportedLocalesOf(locales);
            if (supportedLocales.length > 0) return new Intl.Locale(supportedLocales[0]);
            return new Intl.Locale(typeof locales === "string" ? locales : locales[0]);
        };
    }
    static{
        this.__parse = (0, $2dc2f66d316cd8db$export$98e6a39c04603d36);
    }
    static{
        this.formats = {
            number: {
                integer: {
                    maximumFractionDigits: 0
                },
                currency: {
                    style: "currency"
                },
                percent: {
                    style: "percent"
                }
            },
            date: {
                short: {
                    month: "numeric",
                    day: "numeric",
                    year: "2-digit"
                },
                medium: {
                    month: "short",
                    day: "numeric",
                    year: "numeric"
                },
                long: {
                    month: "long",
                    day: "numeric",
                    year: "numeric"
                },
                full: {
                    weekday: "long",
                    month: "long",
                    day: "numeric",
                    year: "numeric"
                }
            },
            time: {
                short: {
                    hour: "numeric",
                    minute: "numeric"
                },
                medium: {
                    hour: "numeric",
                    minute: "numeric",
                    second: "numeric"
                },
                long: {
                    hour: "numeric",
                    minute: "numeric",
                    second: "numeric",
                    timeZoneName: "short"
                },
                full: {
                    hour: "numeric",
                    minute: "numeric",
                    second: "numeric",
                    timeZoneName: "short"
                }
            }
        };
    }
};
//#endregion
//#region packages/intl-messageformat/index.ts
var $cce7b597e4178fb0$export$2e2bcd8739ae039 = $cce7b597e4178fb0$export$d342343268debc40;


const $b2f6805dd403a8fa$export$21b6e36a47296689 = Object.freeze([
    'aria-label',
    'title',
    'placeholder',
    'alt',
    'content',
    'data-label',
    'data-model',
    'data-best',
    'data-inside',
    'data-outside',
    'data-outside-sub'
]);
const $b2f6805dd403a8fa$export$ef8fd008dd192760 = Object.freeze([
    'language.current',
    'language.choose',
    'language.search',
    'language.label',
    'language.empty',
    'theme.darkMode',
    'theme.switchToLight',
    'theme.switchToDark',
    'navigation.openMenu',
    'navigation.closeMenu',
    "booking.duration",
    "booking.selectPrompt",
    "booking.selection",
    "booking.dayLabel",
    "booking.loading",
    "booking.chooseTime",
    "booking.noSlots",
    "booking.loadFailed",
    "booking.required",
    "booking.termsRequired",
    "booking.emailInvalid",
    "booking.submitting",
    "booking.unavailable",
    "booking.rateLimit",
    "booking.uncertain",
    "booking.bookingFailed",
    "booking.successTitle",
    "booking.successCopy",
    "booking.pendingTitle",
    "booking.pendingCopy",
    "booking.topic.consultation",
    "booking.topic.review",
    "booking.topic.planning"
]);
function $b2f6805dd403a8fa$export$1a85e520fc74013a(value, languages) {
    if (typeof value !== 'string' || !value.trim()) return null;
    let canonical;
    try {
        [canonical] = Intl.getCanonicalLocales(value.trim().replaceAll('_', '-'));
    } catch  {
        return null;
    }
    const exact = languages.find((language)=>language.code.toLowerCase() === canonical.toLowerCase());
    const base = canonical.split('-')[0].toLowerCase();
    return exact?.code ?? languages.find((language)=>language.code.split('-')[0].toLowerCase() === base)?.code ?? null;
}
function $b2f6805dd403a8fa$export$df9bcabe7f932e01({ query: query, saved: saved, browser: browser = [], languages: languages, defaultLocale: defaultLocale }) {
    return $b2f6805dd403a8fa$export$1a85e520fc74013a(query, languages) ?? $b2f6805dd403a8fa$export$1a85e520fc74013a(saved, languages) ?? browser.map((value)=>$b2f6805dd403a8fa$export$1a85e520fc74013a(value, languages)).find(Boolean) ?? defaultLocale;
}
function $b2f6805dd403a8fa$export$6f3122ee6dbd9f46({ locale: locale, messages: messages, fallback: fallback, protectedTerms: protectedTerms }) {
    const fixed = Object.freeze({
        ...protectedTerms
    });
    const formatters = new Map();
    function format(key, values = {}, renderArgument) {
        const message = typeof messages[key] === 'string' ? messages[key] : fallback[key];
        if (typeof message !== 'string') throw new Error(`Unknown translation key: ${key}`);
        const messageLocale = typeof messages[key] === 'string' ? locale : 'en';
        const cacheKey = `${messageLocale}:${key}`;
        if (!formatters.has(cacheKey)) {
            const formatter = new (0, $cce7b597e4178fb0$export$d342343268debc40)(message, messageLocale);
            const types = new Map();
            function collect(nodes) {
                for (const node of nodes){
                    if (node.type >= 1 && node.type <= 6) {
                        const set = types.get(node.value) ?? new Set();
                        set.add(node.type);
                        types.set(node.value, set);
                    }
                    if (node.children) collect(node.children);
                    if (node.options) for (const option of Object.values(node.options))collect(option.value);
                }
            }
            collect(formatter.getAst());
            const plainArguments = [
                ...types
            ].filter(([, set])=>set.size === 1 && set.has(1)).map(([name])=>name);
            formatters.set(cacheKey, {
                formatter: formatter,
                plainArguments: plainArguments
            });
        }
        const { formatter: formatter, plainArguments: plainArguments } = formatters.get(cacheKey);
        const resolved = {
            year: String(new Date().getFullYear()),
            ...values,
            ...fixed
        };
        if (renderArgument) {
            for (const name of plainArguments)if (typeof resolved[name] === 'string' || typeof resolved[name] === 'number') resolved[name] = renderArgument(resolved[name], {
                name: name,
                protected: name in fixed
            });
        }
        return formatter.format(resolved);
    }
    return Object.freeze({
        format: format,
        // Markup belongs to the renderer, never the catalogue. Numeric/select/plural
        // operands remain raw so ICU can choose CLDR categories and format values.
        formatMarkup: (key, values, renderArgument)=>format(key, values, renderArgument),
        text (key, values) {
            const result = format(key, values);
            if (typeof result !== 'string' && typeof result !== 'number') throw new Error(`Rich message requires slots: ${key}`);
            return String(result);
        },
        number: (value, options)=>new Intl.NumberFormat(locale, options).format(value),
        currency: (value, currency, options)=>new Intl.NumberFormat(locale, {
                ...options,
                style: 'currency',
                currency: currency
            }).format(value),
        percent: (value, options)=>new Intl.NumberFormat(locale, {
                ...options,
                style: 'percent'
            }).format(value),
        date: (value, options)=>new Intl.DateTimeFormat(locale, options).format(value),
        relativeTime: (value, unit, options)=>new Intl.RelativeTimeFormat(locale, options).format(value, unit),
        list: (values, options)=>new Intl.ListFormat(locale, options).format(values)
    });
}
const $b2f6805dd403a8fa$export$4cf11838cdc2a8a8 = (value)=>String(value).replace(/[&<>"']/g, (character)=>({
            '&': '&amp;',
            '<': '&lt;',
            '>': '&gt;',
            '"': '&quot;',
            "'": '&#39;'
        })[character]);
function $b2f6805dd403a8fa$export$a80205324a0fc823(parts, isArgument, wrap) {
    const result = [], run = [];
    function flush() {
        if (run.length > 1 && run.some(isArgument)) result.push(wrap([
            ...run
        ]));
        else result.push(...run);
        run.length = 0;
    }
    for (const part of Array.isArray(parts) ? parts : [
        parts
    ])if (typeof part !== 'object' || isArgument(part)) run.push(part);
    else {
        flush();
        result.push(part);
    }
    flush();
    return result;
}
function $b2f6805dd403a8fa$export$7caa02bc8b4bb640(message, locale = 'en') {
    const argumentsByType = new Map();
    const tags = new Set();
    function visit(nodes) {
        for (const node of nodes){
            if (node.type === 8) {
                tags.add(node.value);
                visit(node.children);
            } else if (node.type >= 1 && node.type <= 6) {
                const types = argumentsByType.get(node.value) ?? new Set();
                types.add(node.type);
                argumentsByType.set(node.value, types);
            }
            if (node.options) for (const option of Object.values(node.options))visit(option.value);
        }
    }
    const ast = new (0, $cce7b597e4178fb0$export$d342343268debc40)(message, locale).getAst();
    function checkSlots(nodes, previous = new Set()) {
        const seen = new Set(previous);
        for (const node of nodes){
            if (node.type === 8) {
                if (seen.has(node.value)) throw new Error(`Repeated rich slot: ${node.value}`);
                seen.add(node.value);
                for (const name of checkSlots(node.children, seen))seen.add(name);
            }
            if (node.options) {
                const alternatives = Object.values(node.options).map((option)=>checkSlots(option.value, seen));
                for (const branch of alternatives)for (const name of branch)seen.add(name);
            }
        }
        return seen;
    }
    checkSlots(ast);
    visit(ast);
    return {
        arguments: [
            ...argumentsByType
        ].map(([key, types])=>[
                key,
                [
                    ...types
                ].sort()
            ]).sort(),
        tags: [
            ...tags
        ].sort()
    };
}
function $b2f6805dd403a8fa$export$e18536b97e5c1997(locale, catalog, english, protectedTerms) {
    if (!catalog || typeof catalog !== 'object' || Array.isArray(catalog)) throw new Error(`Invalid catalogue: ${locale}`);
    const expected = Object.keys(english).sort();
    if (JSON.stringify(Object.keys(catalog).sort()) !== JSON.stringify(expected)) throw new Error(`Catalogue key mismatch: ${locale}`);
    for (const key of expected){
        if (typeof catalog[key] !== 'string' || !catalog[key].trim()) throw new Error(`Missing message: ${locale}.${key}`);
        const expectedSchema = $b2f6805dd403a8fa$export$7caa02bc8b4bb640(english[key]);
        if (JSON.stringify($b2f6805dd403a8fa$export$7caa02bc8b4bb640(catalog[key], locale)) !== JSON.stringify(expectedSchema)) throw new Error(`Placeholder or rich-slot mismatch: ${locale}.${key}`);
        for (const [term, literal] of Object.entries(protectedTerms)){
            const schema = expectedSchema;
            if (schema.arguments.some(([name])=>name === term) && !schema.arguments.find(([name])=>name === term)[1].every((type)=>type === 1)) throw new Error(`Protected name must remain a plain placeholder: ${key}.${term}`);
            // A translated catalogue must reference immutable names through their placeholders.
            if (locale !== 'en' && $b2f6805dd403a8fa$var$containsProtectedLiteral(catalog[key], literal) && !$b2f6805dd403a8fa$var$containsProtectedLiteral(english[key], literal)) throw new Error(`Literal protected name: ${locale}.${key}.${term}`);
        }
    }
}
function $b2f6805dd403a8fa$export$9db9e806a7c06b16(className = '') {
    const token = className.split(/\s+/).find((value)=>value.startsWith('an-i18n-svg--'));
    return token ? token.slice(13).replaceAll('__', '.') : null;
}
function $b2f6805dd403a8fa$export$7aeaa1ca2e4d7cb5(className = '') {
    return className.split(/\s+/).find((value)=>value.startsWith('an-i18n-slot--'))?.slice('an-i18n-slot--'.length) ?? null;
}
function $b2f6805dd403a8fa$var$containsProtectedLiteral(message, literal) {
    const escaped = literal.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    return new RegExp(`(?<![\\p{L}\\p{N}_])${escaped}(?![\\p{L}\\p{N}_])`, 'u').test(message);
}


// Script metadata, rather than component-level language checks, controls direction.
// Explicit script tags matter: ar-Latn and az-Arab need different directions.
const $bbd7d3d4b7c88c17$export$ef8b760ac5cb7161 = Object.freeze([
    'Adlm',
    'Arab',
    'Hebr',
    'Mand',
    'Mend',
    'Nkoo',
    'Rohg',
    'Samr',
    'Syrc',
    'Thaa'
]);
const $bbd7d3d4b7c88c17$var$rtlScriptSet = new Set($bbd7d3d4b7c88c17$export$ef8b760ac5cb7161);
function $bbd7d3d4b7c88c17$export$8509e187c9ce2b63(value) {
    let locale;
    try {
        locale = new Intl.Locale(String(value).replaceAll('_', '-'));
    } catch  {
        locale = new Intl.Locale('en');
    }
    const script = locale.script ?? locale.maximize().script ?? 'Latn';
    return {
        lang: locale.toString(),
        dir: $bbd7d3d4b7c88c17$var$rtlScriptSet.has(script) ? 'rtl' : 'ltr',
        'data-script': script
    };
}
const $bbd7d3d4b7c88c17$export$fcce7887255d1c69 = (locale)=>$bbd7d3d4b7c88c17$export$8509e187c9ce2b63(locale).dir;
const $bbd7d3d4b7c88c17$export$702d680b21cbd764 = (locale)=>$bbd7d3d4b7c88c17$export$fcce7887255d1c69(locale) === 'rtl';
function $bbd7d3d4b7c88c17$export$453cc2855a0c4254(element, locale, directionOverride) {
    const attributes = $bbd7d3d4b7c88c17$export$8509e187c9ce2b63(locale);
    if (directionOverride === 'ltr' || directionOverride === 'rtl') attributes.dir = directionOverride;
    for (const [name, value] of Object.entries(attributes))element.setAttribute(name, value);
    return attributes;
}
function $bbd7d3d4b7c88c17$export$233ad4bf084bc0d2(key, direction) {
    if (key === 'ArrowDown') return 1;
    if (key === 'ArrowUp') return -1;
    const sign = direction === 'rtl' ? -1 : 1;
    if (key === 'ArrowRight') return sign;
    if (key === 'ArrowLeft') return -sign;
    return 0;
}
function $bbd7d3d4b7c88c17$export$c588715c25049782(search) {
    const value = new URLSearchParams(search).get('ui-dir');
    return value === 'ltr' || value === 'rtl' ? value : undefined;
}


const $53cebf01a6481b81$export$d0d68bb9ed2c643d = Object.freeze((0, (/*@__PURE__*/$parcel$interopDefault($175dbb69957d8e06$exports))).languages.map((language)=>Object.freeze({
        ...language
    })));
const $53cebf01a6481b81$export$d7f512c98c859244 = (0, (/*@__PURE__*/$parcel$interopDefault($175dbb69957d8e06$exports))).defaultLocale;
const $53cebf01a6481b81$export$7367158f2f597ab1 = (0, (/*@__PURE__*/$parcel$interopDefault($175dbb69957d8e06$exports))).storageKey;
// Register a reviewed catalogue here before adding its locale to the public registry.
const $53cebf01a6481b81$var$catalogs = new Map([
    [
        $53cebf01a6481b81$export$d7f512c98c859244,
        (0, (/*@__PURE__*/$parcel$interopDefault($9R3dw)))
    ]
]);
let $53cebf01a6481b81$var$currentLocale = $53cebf01a6481b81$export$d7f512c98c859244;
// Generated pages include only their bound and runtime messages. Seed the
// formatter before controllers initialize, with no translation network round trip.
try {
    const state = JSON.parse(document.getElementById('an-i18n-state')?.textContent ?? 'null');
    if (state && $53cebf01a6481b81$export$d0d68bb9ed2c643d.some((language)=>language.code === state.locale) && state.locale !== $53cebf01a6481b81$export$d7f512c98c859244) {
        const reference = Object.fromEntries(Object.keys(state.messages).map((key)=>[
                key,
                (0, (/*@__PURE__*/$parcel$interopDefault($9R3dw)))[key]
            ]));
        (0, $b2f6805dd403a8fa$export$e18536b97e5c1997)(state.locale, state.messages, reference, (0, (/*@__PURE__*/$parcel$interopDefault($c964284728795061$exports))));
        $53cebf01a6481b81$var$catalogs.set(state.locale, state.messages);
        $53cebf01a6481b81$var$currentLocale = state.locale;
    }
} catch  {}
let $53cebf01a6481b81$var$translator = (0, $b2f6805dd403a8fa$export$6f3122ee6dbd9f46)({
    locale: $53cebf01a6481b81$var$currentLocale,
    messages: $53cebf01a6481b81$var$catalogs.get($53cebf01a6481b81$var$currentLocale),
    fallback: (0, (/*@__PURE__*/$parcel$interopDefault($9R3dw))),
    protectedTerms: (/*@__PURE__*/$parcel$interopDefault($c964284728795061$exports))
});
let $53cebf01a6481b81$var$requestVersion = 0;
const $53cebf01a6481b81$var$templates = new WeakMap();
const $53cebf01a6481b81$export$180605366c04f0cd = ()=>$53cebf01a6481b81$var$currentLocale;
const $53cebf01a6481b81$export$625550452a3fa3ec = (key, values)=>$53cebf01a6481b81$var$translator.text(key, values);
const $53cebf01a6481b81$export$f5dd818bff069720 = (value, options)=>$53cebf01a6481b81$var$translator.number(value, options);
const $53cebf01a6481b81$export$3dc27271f5d5c629 = (value, currency, options)=>$53cebf01a6481b81$var$translator.currency(value, currency, options);
const $53cebf01a6481b81$export$32e6b1ae352e94d6 = (value, options)=>$53cebf01a6481b81$var$translator.percent(value, options);
const $53cebf01a6481b81$export$3ae94a2503e890a1 = (value, options)=>$53cebf01a6481b81$var$translator.date(value, options);
const $53cebf01a6481b81$export$b4ea3b48dcf921f6 = (value, unit, options)=>$53cebf01a6481b81$var$translator.relativeTime(value, unit, options);
const $53cebf01a6481b81$export$e8b8be48b45905bb = (values, options)=>$53cebf01a6481b81$var$translator.list(values, options);
const $53cebf01a6481b81$export$33fad6260ef90092 = (value)=>(0, $b2f6805dd403a8fa$export$1a85e520fc74013a)(value, $53cebf01a6481b81$export$d0d68bb9ed2c643d);
const $53cebf01a6481b81$export$811bf97b98741cc7 = (options)=>(0, $b2f6805dd403a8fa$export$df9bcabe7f932e01)({
        ...options,
        languages: $53cebf01a6481b81$export$d0d68bb9ed2c643d,
        defaultLocale: $53cebf01a6481b81$export$d7f512c98c859244
    });
function $53cebf01a6481b81$var$bindingKey(element) {
    return element.dataset.i18n ?? (0, $b2f6805dd403a8fa$export$9db9e806a7c06b16)(element.getAttribute('class') ?? '');
}
function $53cebf01a6481b81$export$562e0893fdbd90ef(root = document) {
    function visit(element) {
        const values = JSON.parse(element.dataset.i18nValues ?? '{}');
        if (element.hasAttribute('data-language-trigger')) values.language = $53cebf01a6481b81$export$d0d68bb9ed2c643d.find((value)=>value.code === $53cebf01a6481b81$var$currentLocale).nativeLabel;
        const attributes = JSON.parse(element.dataset.i18nAttrs ?? '{}');
        for (const [attribute, key] of Object.entries(attributes))if ((0, $b2f6805dd403a8fa$export$21b6e36a47296689).includes(attribute)) element.setAttribute(attribute, $53cebf01a6481b81$export$625550452a3fa3ec(key, values));
        const key = $53cebf01a6481b81$var$bindingKey(element);
        if (key) {
            if (!$53cebf01a6481b81$var$templates.has(element)) $53cebf01a6481b81$var$templates.set(element, element.cloneNode(true));
            const template = $53cebf01a6481b81$var$templates.get(element);
            const liveSlots = new Map([
                ...element.querySelectorAll('[data-i18n-slot],[class*="an-i18n-slot--"]')
            ].map((child)=>[
                    child.dataset.i18nSlot ?? (0, $b2f6805dd403a8fa$export$7aeaa1ca2e4d7cb5)(child.getAttribute('class') ?? ''),
                    child
                ]));
            const usedSlots = new Set();
            const argumentsCreated = new WeakSet();
            const inserted = new Set();
            const toNodes = (parts)=>parts.map((part)=>{
                    if (typeof part !== 'object') return document.createTextNode(String(part));
                    // Repeated ICU arguments need distinct DOM nodes at each occurrence.
                    const node = inserted.has(part) ? part.cloneNode(true) : part;
                    inserted.add(part);
                    return node;
                });
            function nodes(parts) {
                return toNodes((0, $b2f6805dd403a8fa$export$a80205324a0fc823)(parts, (part)=>typeof part === 'object' && argumentsCreated.has(part), (chunks)=>{
                    const span = document.createElement('span');
                    span.replaceChildren(...toNodes(chunks));
                    return span;
                }));
            }
            const slots = {};
            for (const child of template.querySelectorAll('[data-i18n-slot],[class*="an-i18n-slot--"]')){
                const name = child.dataset.i18nSlot ?? (0, $b2f6805dd403a8fa$export$7aeaa1ca2e4d7cb5)(child.getAttribute('class') ?? '');
                slots[name] = (chunks)=>{
                    if (usedSlots.has(name)) throw new Error(`Repeated rich slot: ${key}.${name}`);
                    usedSlots.add(name);
                    const clone = liveSlots.get(name) ?? child.cloneNode(true);
                    if (child.getAttribute('translate') !== 'no' && ![
                        'svg',
                        'img',
                        'br',
                        'wbr'
                    ].includes(child.tagName.toLowerCase())) clone.replaceChildren(...nodes(chunks));
                    return clone;
                };
            }
            const html = element.namespaceURI !== 'http://www.w3.org/2000/svg' && ![
                'TITLE',
                'TEXTAREA'
            ].includes(element.tagName);
            const result = html ? $53cebf01a6481b81$var$translator.formatMarkup(key, {
                ...values,
                ...slots
            }, (value, info)=>{
                const isolated = document.createElement('bdi');
                isolated.dir = info.protected ? 'ltr' : 'auto';
                isolated.textContent = String(value);
                argumentsCreated.add(isolated);
                return isolated;
            }) : $53cebf01a6481b81$var$translator.format(key, {
                ...values,
                ...slots
            });
            const parts = Array.isArray(result) ? result : [
                result
            ];
            // Reuse existing slots to preserve their listeners and state. Catalogue text stays inert.
            element.replaceChildren(...nodes(parts));
        }
        // Visit the live children after rendering rich messages, including their attribute bindings.
        for (const child of element.children)visit(child);
    }
    visit(root.documentElement ?? root);
}
async function $53cebf01a6481b81$export$c8aadf3621e41efb(requested, { refresh: refresh = false } = {}) {
    const version = ++$53cebf01a6481b81$var$requestVersion;
    let locale = $53cebf01a6481b81$export$33fad6260ef90092(requested) ?? $53cebf01a6481b81$export$d7f512c98c859244;
    if (!$53cebf01a6481b81$var$catalogs.has(locale)) try {
        const messages = await (0, $33fa2452826454d7$export$7211f0bd52e8a1b7)[locale]?.();
        (0, $b2f6805dd403a8fa$export$e18536b97e5c1997)(locale, messages, (0, (/*@__PURE__*/$parcel$interopDefault($9R3dw))), (0, (/*@__PURE__*/$parcel$interopDefault($c964284728795061$exports))));
        $53cebf01a6481b81$var$catalogs.set(locale, messages);
    } catch  {
        locale = $53cebf01a6481b81$export$d7f512c98c859244;
    }
    if (version !== $53cebf01a6481b81$var$requestVersion) return $53cebf01a6481b81$var$currentLocale;
    const changed = $53cebf01a6481b81$var$currentLocale !== locale;
    $53cebf01a6481b81$var$currentLocale = locale;
    $53cebf01a6481b81$var$translator = (0, $b2f6805dd403a8fa$export$6f3122ee6dbd9f46)({
        locale: locale,
        messages: $53cebf01a6481b81$var$catalogs.get(locale),
        fallback: (0, (/*@__PURE__*/$parcel$interopDefault($9R3dw))),
        protectedTerms: (/*@__PURE__*/$parcel$interopDefault($c964284728795061$exports))
    });
    // Parcel removes this development branch from production. Direction previews
    // retain the real content language and never publish an untranslated locale.
    const override = undefined;
    const attributes = (0, $bbd7d3d4b7c88c17$export$453cc2855a0c4254)(document.documentElement, locale, override);
    if (changed || refresh) $53cebf01a6481b81$export$562e0893fdbd90ef();
    window.dispatchEvent(new CustomEvent('an:languagechange', {
        detail: {
            locale: locale,
            direction: attributes.dir,
            script: attributes['data-script']
        }
    }));
    return locale;
}


const $f3bcf4641bf8382d$var$storageKey = 'theme';
let $f3bcf4641bf8382d$var$initialized = false;
let $f3bcf4641bf8382d$var$preference = null;
function $f3bcf4641bf8382d$var$validTheme(value) {
    return value === 'light' || value === 'dark' ? value : null;
}
function $f3bcf4641bf8382d$var$savedTheme() {
    try {
        return $f3bcf4641bf8382d$var$validTheme(localStorage.getItem($f3bcf4641bf8382d$var$storageKey));
    } catch (_) {
        return null;
    }
}
function $f3bcf4641bf8382d$var$applyTheme(theme) {
    const isDark = theme === 'dark';
    document.documentElement.classList.add('an-theme-changing');
    document.documentElement.dataset.theme = theme;
    document.documentElement.classList.toggle('dark', isDark);
    const meta = document.querySelector('meta[name="theme-color"]');
    if (meta) meta.content = isDark ? '#0d0c12' : '#faf5f0';
    document.querySelectorAll('[data-theme-toggle]').forEach((button)=>{
        button.setAttribute('aria-pressed', String(isDark));
        button.title = (0, $53cebf01a6481b81$export$625550452a3fa3ec)(isDark ? 'theme.switchToLight' : 'theme.switchToDark');
    });
    window.dispatchEvent(new CustomEvent('an:themechange', {
        detail: {
            theme: theme
        }
    }));
    requestAnimationFrame(()=>requestAnimationFrame(()=>document.documentElement.classList.remove('an-theme-changing')));
}
function $f3bcf4641bf8382d$export$f543642fc33c1018() {
    $f3bcf4641bf8382d$var$preference = document.documentElement.dataset.theme === 'dark' ? 'light' : 'dark';
    try {
        localStorage.setItem($f3bcf4641bf8382d$var$storageKey, $f3bcf4641bf8382d$var$preference);
    } catch (_) {}
    $f3bcf4641bf8382d$var$applyTheme($f3bcf4641bf8382d$var$preference);
}
function $f3bcf4641bf8382d$export$4c47704ed26c13e8() {
    if ($f3bcf4641bf8382d$var$initialized) return;
    $f3bcf4641bf8382d$var$initialized = true;
    const system = window.matchMedia('(prefers-color-scheme: dark)');
    $f3bcf4641bf8382d$var$preference = $f3bcf4641bf8382d$var$savedTheme();
    const resolved = ()=>$f3bcf4641bf8382d$var$preference || (system.matches ? 'dark' : 'light');
    $f3bcf4641bf8382d$var$applyTheme(resolved());
    window.addEventListener('an:languagechange', ()=>$f3bcf4641bf8382d$var$applyTheme(document.documentElement.dataset.theme));
    document.querySelectorAll('[data-theme-toggle]').forEach((button)=>button.addEventListener('click', $f3bcf4641bf8382d$export$f543642fc33c1018));
    system.addEventListener('change', ()=>{
        if (!$f3bcf4641bf8382d$var$preference) $f3bcf4641bf8382d$var$applyTheme(resolved());
    });
    window.addEventListener('storage', (event)=>{
        if (event.key !== $f3bcf4641bf8382d$var$storageKey && event.key !== null) return;
        $f3bcf4641bf8382d$var$preference = $f3bcf4641bf8382d$var$validTheme(event.newValue);
        $f3bcf4641bf8382d$var$applyTheme(resolved());
    });
}
var $f3bcf4641bf8382d$export$2e2bcd8739ae039 = {
    initTheme: $f3bcf4641bf8382d$export$4c47704ed26c13e8,
    toggleTheme: $f3bcf4641bf8382d$export$f543642fc33c1018
};



// One route contract for generated pages, browser navigation and early redirects.

const $67a62db5dc6e62ee$export$499288c30fa4eadc = Object.freeze([
    '',
    'it-consultation',
    'app-development',
    'fynlink',
    'retailist-app',
    'retailist-store',
    'retailist-cloud',
    'retailist-ai',
    'psynera',
    'privacy-policy',
    'tos',
    'cookie-policy'
]);
const $67a62db5dc6e62ee$export$48e0a417796fae09 = 'https://algorithmic.network';
function $67a62db5dc6e62ee$export$9725e64c244bed22(pathname, { languages: languages, pages: pages = $67a62db5dc6e62ee$export$499288c30fa4eadc } = {}) {
    let segments;
    try {
        segments = decodeURIComponent(pathname).split('/').filter(Boolean);
    } catch  {
        return null;
    }
    const language = languages.find((value)=>value.code.toLowerCase() === segments[0]?.toLowerCase());
    if (language) segments.shift();
    if (segments.length > 1) return null;
    const name = (segments[0] ?? '').replace(/\.html$/, '');
    const page = name === 'index' ? '' : name;
    return pages.includes(page) ? {
        page: page,
        locale: language?.code ?? null
    } : null;
}
function $67a62db5dc6e62ee$export$4db79997711d3d07(page, locale) {
    return `/${locale.toLowerCase()}/${page ? `${page}/` : ''}`;
}
function $67a62db5dc6e62ee$export$35fee7f436a2dab6(value, locale, base, registry) {
    const url = new URL(value, base);
    if (url.origin !== new URL(base).origin) return null;
    const route = $67a62db5dc6e62ee$export$9725e64c244bed22(url.pathname, registry);
    if (!route) return null;
    url.pathname = $67a62db5dc6e62ee$export$4db79997711d3d07(route.page, locale);
    url.searchParams.delete('lang');
    return url;
}
function $67a62db5dc6e62ee$export$2e39b6ead7062db1(config) {
    const url = new URL(location.href);
    const route = $67a62db5dc6e62ee$export$9725e64c244bed22(url.pathname, config);
    if (!route) return;
    let saved;
    try {
        saved = localStorage.getItem(config.storageKey);
    } catch  {}
    const query = (0, $b2f6805dd403a8fa$export$1a85e520fc74013a)(url.searchParams.get('lang'), config.languages);
    const locale = query ?? route.locale ?? (0, $b2f6805dd403a8fa$export$df9bcabe7f932e01)({
        saved: saved,
        browser: navigator.languages ?? [
            navigator.language
        ],
        ...config
    });
    const pathname = $67a62db5dc6e62ee$export$4db79997711d3d07(route.page, locale);
    if (pathname === url.pathname && !url.searchParams.has('lang')) return;
    url.pathname = pathname;
    url.searchParams.delete('lang');
    location.replace(url.pathname + url.search + url.hash);
}
function $67a62db5dc6e62ee$export$1cb3b2c5444f5ee(locale, registry) {
    const url = $67a62db5dc6e62ee$export$35fee7f436a2dab6(location.href, locale, location.href, registry);
    if (!url) return;
    history.replaceState(history.state, '', url.pathname + url.search + url.hash);
    const base = document.querySelector('base[href]');
    if (base) base.href = url.pathname;
    const canonical = document.querySelector('link[rel="canonical"]');
    const address = $67a62db5dc6e62ee$export$48e0a417796fae09 + url.pathname;
    if (canonical) canonical.href = address;
    document.querySelector('meta[property="og:url"]')?.setAttribute('content', address);
}



let $ef2d0223374c7da0$var$initialized = false;
function $ef2d0223374c7da0$var$readPreference() {
    try {
        return localStorage.getItem((0, $53cebf01a6481b81$export$7367158f2f597ab1));
    } catch  {
        return null;
    }
}
function $ef2d0223374c7da0$var$browserLanguages() {
    return navigator.languages?.length ? navigator.languages : [
        navigator.language
    ];
}
const $ef2d0223374c7da0$var$normalize = (value)=>value.normalize('NFKD').replace(/\p{M}/gu, '').toLowerCase().trim();
function $ef2d0223374c7da0$var$carryLanguageInLinks(locale) {
    for (const link of document.querySelectorAll('a[href]')){
        const href = link.getAttribute('href');
        if (!href || href.startsWith('#')) continue;
        const destination = (0, $67a62db5dc6e62ee$export$35fee7f436a2dab6)(href, locale, location.href, {
            languages: $53cebf01a6481b81$export$d0d68bb9ed2c643d
        });
        if (!destination) continue;
        link.href = destination.pathname + destination.search + destination.hash;
    }
}
function $ef2d0223374c7da0$export$544ea8661fa0df65() {
    if ($ef2d0223374c7da0$var$initialized) return;
    $ef2d0223374c7da0$var$initialized = true;
    const controls = [
        ...document.querySelectorAll('[data-language-switcher]')
    ];
    const native = typeof HTMLElement.prototype.showPopover === 'function';
    function sync() {
        const language = (0, $53cebf01a6481b81$export$d0d68bb9ed2c643d).find((value)=>value.code === (0, $53cebf01a6481b81$export$180605366c04f0cd)());
        for (const control of controls){
            const label = control.querySelector('[data-language-label]');
            label.textContent = label.dataset.languageLabel === 'full' ? language.nativeLabel : language.shortLabel;
            control.querySelector('[data-language-trigger]').setAttribute('aria-label', (0, $53cebf01a6481b81$export$625550452a3fa3ec)('language.current', {
                language: language.nativeLabel
            }));
            control.querySelector('[data-language-trigger]').title = (0, $53cebf01a6481b81$export$625550452a3fa3ec)('language.choose');
            for (const option of control.querySelectorAll('[data-language-option]')){
                const selected = option.dataset.languageOption === language.code;
                option.setAttribute('aria-checked', String(selected));
                option.tabIndex = selected ? 0 : -1;
            }
        }
    }
    window.addEventListener('an:languagechange', ()=>{
        (0, $67a62db5dc6e62ee$export$1cb3b2c5444f5ee)((0, $53cebf01a6481b81$export$180605366c04f0cd)(), {
            languages: $53cebf01a6481b81$export$d0d68bb9ed2c643d
        });
        $ef2d0223374c7da0$var$carryLanguageInLinks((0, $53cebf01a6481b81$export$180605366c04f0cd)());
        sync();
        for (const control of controls)if (control.querySelector('[data-language-trigger]').getAttribute('aria-expanded') === 'true') control.dispatchEvent(new Event('an:reposition'));
    });
    function close(panel, trigger, focus = false) {
        if (native && panel.matches(':popover-open')) panel.hidePopover();
        else if (!native) {
            panel.hidden = true;
            panel.dataset.open = 'false';
            trigger.setAttribute('aria-expanded', 'false');
        }
        if (focus) trigger.focus();
    }
    for (const control of controls){
        const trigger = control.querySelector('[data-language-trigger]');
        const panel = control.querySelector('[data-language-panel]');
        const search = control.querySelector('[data-language-search]');
        const options = [
            ...control.querySelectorAll('[data-language-option]')
        ];
        const empty = control.querySelector('[data-language-empty]');
        if (!native) {
            trigger.removeAttribute('popovertarget');
            panel.removeAttribute('popover');
            panel.hidden = true;
        }
        function position() {
            const anchor = trigger.getBoundingClientRect();
            const width = panel.offsetWidth, height = panel.offsetHeight, gutter = 12;
            const rtl = getComputedStyle(control).direction === 'rtl';
            let left = rtl ? anchor.left : anchor.right - width;
            left = Math.max(gutter, Math.min(left, innerWidth - width - gutter));
            const below = innerHeight - anchor.bottom - gutter;
            const above = anchor.top - gutter;
            const preferAbove = control.dataset.placement === 'above';
            const placeAbove = preferAbove ? above >= height || above > below : below < height && above > below;
            const top = placeAbove ? anchor.top - height - 8 : anchor.bottom + 8;
            panel.style.left = `${left}px`;
            panel.style.top = `${Math.max(gutter, Math.min(top, innerHeight - height - gutter))}px`;
        }
        function opened(open) {
            panel.dataset.open = String(open);
            if (!open) {
                trigger.setAttribute('aria-expanded', 'false');
                return;
            }
            search.value = '';
            options.forEach((option)=>{
                option.hidden = false;
            });
            empty.hidden = true;
            position();
            panel.style.visibility = '';
            trigger.setAttribute('aria-expanded', 'true');
            queueMicrotask(()=>{
                const touch = window.matchMedia('(pointer: coarse)').matches;
                (touch ? options.find((option)=>option.getAttribute('aria-checked') === 'true') ?? search : search).focus();
            });
        }
        trigger.addEventListener('click', ()=>{
            if (native) return;
            const open = panel.hidden;
            controls.filter((other)=>other !== control).forEach((other)=>close(other.querySelector('[data-language-panel]'), other.querySelector('[data-language-trigger]')));
            panel.hidden = !open;
            opened(open);
        });
        if (native) {
            // Native popovers have no dimensions while closed. Reveal only after positioning.
            panel.addEventListener('beforetoggle', (event)=>{
                if (event.newState === 'open') panel.style.visibility = 'hidden';
            });
            panel.addEventListener('toggle', (event)=>opened(event.newState === 'open'));
        }
        trigger.addEventListener('keydown', (event)=>{
            if (![
                'ArrowDown',
                'ArrowUp'
            ].includes(event.key)) return;
            event.preventDefault();
            if (native) panel.showPopover();
            else {
                panel.hidden = false;
                opened(true);
            }
        });
        search.addEventListener('input', ()=>{
            const query = $ef2d0223374c7da0$var$normalize(search.value);
            const names = typeof Intl.DisplayNames === 'function' ? new Intl.DisplayNames([
                (0, $53cebf01a6481b81$export$180605366c04f0cd)()
            ], {
                type: 'language'
            }) : null;
            options.forEach((option)=>{
                const language = (0, $53cebf01a6481b81$export$d0d68bb9ed2c643d).find((value)=>value.code === option.dataset.languageOption);
                option.hidden = !$ef2d0223374c7da0$var$normalize([
                    language.code,
                    language.nativeLabel,
                    names?.of(language.code) ?? ''
                ].join(' ')).includes(query);
            });
            empty.hidden = options.some((option)=>!option.hidden);
            position();
        });
        panel.addEventListener('keydown', (event)=>{
            if (event.key === 'Escape') {
                event.preventDefault();
                event.stopPropagation();
                close(panel, trigger, true);
                return;
            }
            const visible = options.filter((option)=>!option.hidden);
            if ([
                'ArrowDown',
                'ArrowUp',
                'Home',
                'End'
            ].includes(event.key) && visible.length) {
                event.preventDefault();
                const index = visible.indexOf(document.activeElement);
                const next = event.key === 'Home' ? 0 : event.key === 'End' ? visible.length - 1 : event.key === 'ArrowDown' ? (index + 1) % visible.length : (index - 1 + visible.length) % visible.length;
                visible[next].focus();
            }
        });
        options.forEach((option)=>option.addEventListener('click', async ()=>{
                const selected = await (0, $53cebf01a6481b81$export$c8aadf3621e41efb)(option.dataset.languageOption, {
                    refresh: true
                });
                try {
                    localStorage.setItem((0, $53cebf01a6481b81$export$7367158f2f597ab1), selected);
                } catch  {}
                close(panel, trigger, true);
            }));
        window.addEventListener('resize', ()=>{
            if (trigger.getAttribute('aria-expanded') === 'true') position();
        }, {
            passive: true
        });
        control.addEventListener('an:reposition', position);
        if ('ResizeObserver' in window) new ResizeObserver(()=>{
            if (trigger.getAttribute('aria-expanded') === 'true') position();
        }).observe(panel);
        window.addEventListener('scroll', ()=>{
            if (trigger.getAttribute('aria-expanded') === 'true') position();
        }, {
            passive: true,
            capture: true
        });
        if (!native) document.addEventListener('click', (event)=>{
            if (!control.contains(event.target)) close(panel, trigger);
        });
    }
    sync();
    const query = new URL(location.href).searchParams.get('lang');
    const rendered = (0, $53cebf01a6481b81$export$33fad6260ef90092)(document.documentElement.lang);
    const routeLocale = (0, $67a62db5dc6e62ee$export$9725e64c244bed22)(location.pathname, {
        languages: $53cebf01a6481b81$export$d0d68bb9ed2c643d
    })?.locale;
    const initial = (0, $53cebf01a6481b81$export$33fad6260ef90092)(query) ?? routeLocale ?? (rendered && rendered !== (0, $53cebf01a6481b81$export$d7f512c98c859244) ? rendered : (0, $53cebf01a6481b81$export$811bf97b98741cc7)({
        saved: $ef2d0223374c7da0$var$readPreference(),
        browser: $ef2d0223374c7da0$var$browserLanguages()
    }));
    (0, $53cebf01a6481b81$export$c8aadf3621e41efb)(initial).then((locale)=>{
        if ((0, $53cebf01a6481b81$export$33fad6260ef90092)(query) || false) $ef2d0223374c7da0$var$carryLanguageInLinks(locale);
    });
    window.addEventListener('storage', (event)=>{
        if (event.key !== (0, $53cebf01a6481b81$export$7367158f2f597ab1) && event.key !== null) return;
        if ((0, $67a62db5dc6e62ee$export$9725e64c244bed22)(location.pathname, {
            languages: $53cebf01a6481b81$export$d0d68bb9ed2c643d
        })?.locale || (0, $53cebf01a6481b81$export$33fad6260ef90092)(new URL(location.href).searchParams.get('lang'))) return;
        (0, $53cebf01a6481b81$export$c8aadf3621e41efb)((0, $53cebf01a6481b81$export$811bf97b98741cc7)({
            saved: event.newValue,
            browser: $ef2d0223374c7da0$var$browserLanguages()
        }));
    });
}



(0, $ef2d0223374c7da0$export$544ea8661fa0df65)();
(0, $f3bcf4641bf8382d$export$4c47704ed26c13e8)();
const $3dbe651fb76d0227$var$header = document.querySelector('[data-nav]');
if ($3dbe651fb76d0227$var$header) {
    const desktop = window.matchMedia('(min-width: 1024px)');
    const html = document.documentElement;
    // Dropdowns -------------------------------------------------------------
    const dropdowns = [
        ...$3dbe651fb76d0227$var$header.querySelectorAll('[data-nav-dropdown]')
    ].map((root)=>({
            root: root,
            trigger: root.querySelector('[data-nav-trigger]'),
            panel: root.querySelector('[data-nav-panel]'),
            pinned: false,
            closeTimer: 0,
            openTimer: 0
        }));
    const isOpen = (dropdown)=>dropdown.root.dataset.open === 'true';
    function close(dropdown) {
        window.clearTimeout(dropdown.closeTimer);
        window.clearTimeout(dropdown.openTimer);
        dropdown.pinned = false;
        dropdown.root.dataset.open = 'false';
        dropdown.panel.dataset.open = 'false';
        dropdown.trigger.setAttribute('aria-expanded', 'false');
        dropdown.panel.inert = true;
    }
    function open(dropdown, pinned = false) {
        if (!desktop.matches) return;
        dropdowns.filter((other)=>other !== dropdown).forEach(close);
        window.clearTimeout(dropdown.closeTimer);
        dropdown.pinned ||= pinned;
        dropdown.root.dataset.open = 'true';
        dropdown.panel.dataset.open = 'true';
        dropdown.trigger.setAttribute('aria-expanded', 'true');
        dropdown.panel.inert = false;
        $3dbe651fb76d0227$var$header.classList.remove('is-hidden');
    }
    const links = (dropdown)=>[
            ...dropdown.panel.querySelectorAll('a[href]')
        ];
    // A visibility transition can update styles before contents can receive
    // focus. Wait for actual focus, without taking it from a user already inside.
    function focusAfterOpen(panel, target, stillOpen, options = {}) {
        if (!target) return;
        const focus = ()=>{
            if (!stillOpen() || panel.contains(document.activeElement)) return;
            target.focus(options);
            if (!panel.contains(document.activeElement)) requestAnimationFrame(focus);
        };
        requestAnimationFrame(focus);
    }
    dropdowns.forEach((dropdown)=>{
        dropdown.root.addEventListener('pointerenter', (event)=>{
            if (event.pointerType !== 'mouse') return;
            window.clearTimeout(dropdown.closeTimer);
            if (isOpen(dropdown)) return;
            // Hover intent: switching from another open menu waits a moment, so a
            // diagonal path into a wide panel does not flip to the neighbouring menu.
            const switching = dropdowns.some((other)=>other !== dropdown && isOpen(other));
            window.clearTimeout(dropdown.openTimer);
            dropdown.openTimer = window.setTimeout(()=>open(dropdown), switching ? 180 : 60);
        });
        dropdown.root.addEventListener('pointerleave', ()=>{
            window.clearTimeout(dropdown.openTimer);
            if (dropdown.pinned || dropdown.root.contains(document.activeElement)) return;
            // A short grace period lets the pointer travel from the trigger into the panel.
            dropdown.closeTimer = window.setTimeout(()=>close(dropdown), 220);
        });
        dropdown.trigger.addEventListener('click', ()=>{
            if (isOpen(dropdown) && dropdown.pinned) close(dropdown);
            else open(dropdown, true);
        });
        dropdown.trigger.addEventListener('keydown', (event)=>{
            if (![
                'ArrowDown',
                'ArrowUp'
            ].includes(event.key)) return;
            event.preventDefault();
            open(dropdown, true);
            const items = links(dropdown);
            focusAfterOpen(dropdown.panel, event.key === 'ArrowDown' ? items[0] : items.at(-1), ()=>isOpen(dropdown));
        });
        dropdown.panel.addEventListener('keydown', (event)=>{
            if (![
                'ArrowDown',
                'ArrowUp',
                'Home',
                'End'
            ].includes(event.key)) return;
            event.preventDefault();
            const items = links(dropdown);
            let index = items.indexOf(document.activeElement);
            if (event.key === 'Home') index = 0;
            else if (event.key === 'End') index = items.length - 1;
            else index = (index + (event.key === 'ArrowDown' ? 1 : -1) + items.length) % items.length;
            items[index]?.focus();
        });
        dropdown.root.addEventListener('focusout', (event)=>{
            if (!dropdown.root.contains(event.relatedTarget)) close(dropdown);
        });
        dropdown.panel.addEventListener('click', (event)=>{
            if (event.target.closest('a')) close(dropdown);
        });
    });
    document.addEventListener('pointerdown', (event)=>{
        dropdowns.forEach((dropdown)=>{
            if (!dropdown.root.contains(event.target)) close(dropdown);
        });
    });
    // Mobile sheet ------------------------------------------------------------
    const burger = $3dbe651fb76d0227$var$header.querySelector('[data-nav-burger]');
    const sheet = $3dbe651fb76d0227$var$header.querySelector('[data-nav-mobile]');
    function setSheet(openSheet) {
        if (!burger || !sheet) return;
        $3dbe651fb76d0227$var$header.classList.toggle('is-open', openSheet);
        html.classList.toggle('an-nav-locked', openSheet);
        burger.setAttribute('aria-expanded', String(openSheet));
        burger.setAttribute('aria-label', (0, $53cebf01a6481b81$export$625550452a3fa3ec)(openSheet ? 'navigation.closeMenu' : 'navigation.openMenu'));
        sheet.inert = !openSheet;
        if (openSheet) {
            $3dbe651fb76d0227$var$header.classList.remove('is-hidden');
            focusAfterOpen(sheet, sheet.querySelector('button, a'), ()=>$3dbe651fb76d0227$var$header.classList.contains('is-open'), {
                preventScroll: true
            });
        }
    }
    burger?.addEventListener('click', ()=>setSheet(!$3dbe651fb76d0227$var$header.classList.contains('is-open')));
    window.addEventListener('an:languagechange', ()=>burger?.setAttribute('aria-label', (0, $53cebf01a6481b81$export$625550452a3fa3ec)($3dbe651fb76d0227$var$header.classList.contains('is-open') ? 'navigation.closeMenu' : 'navigation.openMenu')));
    sheet?.addEventListener('click', (event)=>{
        if (event.target.closest('a[href]')) setSheet(false);
    });
    sheet?.querySelectorAll('.an-mobile__top[aria-controls]').forEach((button)=>{
        button.addEventListener('click', ()=>{
            button.setAttribute('aria-expanded', String(button.getAttribute('aria-expanded') !== 'true'));
        });
    });
    document.addEventListener('keydown', (event)=>{
        if (event.key !== 'Escape') return;
        if ($3dbe651fb76d0227$var$header.classList.contains('is-open')) {
            event.preventDefault();
            setSheet(false);
            burger?.focus();
            return;
        }
        const current = dropdowns.find(isOpen);
        if (!current) return;
        event.preventDefault();
        close(current);
        current.trigger.focus();
    });
    desktop.addEventListener('change', ()=>{
        dropdowns.forEach(close);
        if (desktop.matches) setSheet(false);
    });
    // Condensed bar on scroll, tucked away while reading downwards -----------------
    let lastY = null;
    let frame = 0;
    function onScroll() {
        frame = 0;
        const y = window.scrollY;
        if (lastY === null) lastY = y;
        $3dbe651fb76d0227$var$header.classList.toggle('is-scrolled', y > 24);
        const busy = $3dbe651fb76d0227$var$header.classList.contains('is-open') || dropdowns.some(isOpen) || $3dbe651fb76d0227$var$header.contains(document.activeElement);
        if (y <= 640 || y < lastY - 4) $3dbe651fb76d0227$var$header.classList.remove('is-hidden');
        else if (!busy && y > lastY + 4) $3dbe651fb76d0227$var$header.classList.add('is-hidden');
        if (Math.abs(y - lastY) > 4) lastY = y;
    }
    window.addEventListener('scroll', ()=>{
        if (!frame) frame = requestAnimationFrame(onScroll);
    }, {
        passive: true
    });
    // Let initial locale/theme DOM changes settle before reading scroll geometry.
    frame = requestAnimationFrame(onScroll);
    // Highlight the section in view on the home page ---------------------------------
    const sectionLinks = [
        ...$3dbe651fb76d0227$var$header.querySelectorAll('[data-nav-section]')
    ];
    const sections = sectionLinks.map((link)=>document.getElementById(link.dataset.navSection)).filter(Boolean);
    if (sections.length && 'IntersectionObserver' in window) {
        const observer = new IntersectionObserver((entries)=>{
            entries.forEach((entry)=>{
                const link = sectionLinks.find((item)=>item.dataset.navSection === entry.target.id);
                if (!link) return;
                if (entry.isIntersecting) link.setAttribute('aria-current', 'true');
                else link.removeAttribute('aria-current');
            });
        }, {
            rootMargin: '-45% 0px -50% 0px'
        });
        sections.forEach((section)=>observer.observe(section));
    }
}


// Home page interactions. Every effect is progressive: without JavaScript, or with
// reduced motion, the content is fully visible and usable.


const $80eaaa1ee2ec9e35$var$root = document.documentElement;
const $80eaaa1ee2ec9e35$var$reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
window.__anReady = true;
// Ambient motion runs only while a section is visible and motion is welcome.
// CSS owns the frames; this controller only updates lifecycle state.
function $80eaaa1ee2ec9e35$var$initAmbientMotion() {
    const regions = [
        ...document.querySelectorAll('[data-ambient-motion]')
    ];
    if (!regions.length) return;
    const visible = new Map(regions.map((region)=>[
            region,
            false
        ]));
    const refresh = (region)=>{
        const running = visible.get(region) && !document.hidden && !$80eaaa1ee2ec9e35$var$reduceMotion.matches;
        region.classList.toggle('is-motion-active', running);
        for (const svg of region.querySelectorAll('.an-diagram svg'))// Pause SMIL too, including the hidden desktop/mobile and hosted variants.
        if (running && svg.getClientRects().length) svg.unpauseAnimations?.();
        else svg.pauseAnimations?.();
    };
    const refreshAll = ()=>regions.forEach(refresh);
    if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver((entries)=>{
            for (const entry of entries){
                visible.set(entry.target, entry.isIntersecting);
                refresh(entry.target);
            }
        });
        regions.forEach((region)=>observer.observe(region));
    }
    document.addEventListener('visibilitychange', refreshAll);
    $80eaaa1ee2ec9e35$var$reduceMotion.addEventListener('change', refreshAll);
    window.addEventListener('an:deploymentchange', refreshAll);
    let resizeFrame = 0;
    window.addEventListener('resize', ()=>{
        if (resizeFrame) return;
        resizeFrame = requestAnimationFrame(()=>{
            resizeFrame = 0;
            refreshAll();
        });
    }, {
        passive: true
    });
    refreshAll();
}
// Scroll reveal ---------------------------------------------------------------
function $80eaaa1ee2ec9e35$var$initReveal() {
    const items = [
        ...document.querySelectorAll('.an-home [data-reveal]')
    ];
    if (!$80eaaa1ee2ec9e35$var$root.classList.contains('an-js') || !('IntersectionObserver' in window)) {
        items.forEach((item)=>item.classList.add('is-in'));
        return;
    }
    const observer = new IntersectionObserver((entries)=>{
        entries.forEach((entry)=>{
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-in');
            observer.unobserve(entry.target);
        });
    }, {
        rootMargin: '0px 0px -8% 0px',
        threshold: 0.12
    });
    items.forEach((item)=>observer.observe(item));
}
// Hero spotlight on the blueprint grid ----------------------------------------
function $80eaaa1ee2ec9e35$var$initHeroSpotlight() {
    const hero = document.querySelector('[data-hero]');
    const glow = hero?.querySelector('.an-hero__glow');
    if (!hero || !glow || $80eaaa1ee2ec9e35$var$reduceMotion.matches) return;
    let frame = 0;
    hero.addEventListener('pointermove', (event)=>{
        if (event.pointerType !== 'mouse') return;
        cancelAnimationFrame(frame);
        frame = requestAnimationFrame(()=>{
            const box = hero.getBoundingClientRect();
            glow.style.setProperty('--x', `${event.clientX - box.left}px`);
            glow.style.setProperty('--y', `${event.clientY - box.top}px`);
        });
    });
}
// Local assistant console: streams its answer like a running model -------------
function $80eaaa1ee2ec9e35$var$initConsole() {
    const answer = document.querySelector('[data-typing]');
    if (!answer) return;
    let text = answer.textContent.trim();
    if ($80eaaa1ee2ec9e35$var$reduceMotion.matches) {
        answer.classList.add('is-done');
        return;
    }
    let timer = 0;
    let visible = false;
    const run = ()=>{
        window.clearTimeout(timer);
        answer.classList.remove('is-done');
        const words = text.split(' ');
        let index = 0;
        answer.textContent = '';
        const step = ()=>{
            if (!visible) return;
            index += 1;
            answer.textContent = words.slice(0, index).join(' ');
            if (index < words.length) timer = window.setTimeout(step, 55 + Math.random() * 70);
            else {
                answer.classList.add('is-done');
                timer = window.setTimeout(run, 6500);
            }
        };
        timer = window.setTimeout(step, 700);
    };
    new IntersectionObserver(([entry])=>{
        const wasVisible = visible;
        visible = entry.isIntersecting;
        if (visible && !wasVisible) run();
        if (!visible) window.clearTimeout(timer);
    }, {
        threshold: 0.3
    }).observe(answer);
    window.addEventListener('an:languagechange', ()=>{
        text = answer.textContent.trim();
        if (visible) run();
    });
}
// Deployment tabs -------------------------------------------------------------
function $80eaaa1ee2ec9e35$var$initDeployment() {
    const list = document.querySelector('[data-deploy-tabs]');
    const panel = document.querySelector('[data-deploy-panel]');
    if (!list || !panel) return;
    const tabs = [
        ...list.querySelectorAll('[role="tab"]')
    ];
    const privateDiagram = panel.querySelector('[data-deploy-private]');
    const hostedDiagram = panel.querySelector('[data-deploy-hosted]');
    const targets = {
        // SVG data attributes are removed by Parcel's optimiser; classes survive.
        label: privateDiagram.querySelectorAll('.an-diagram__label'),
        model: privateDiagram.querySelectorAll('.an-diagram__model-caption'),
        best: panel.querySelectorAll('[data-deploy-best]'),
        inside: panel.querySelectorAll('[data-deploy-inside]')
    };
    let swapTimer = 0;
    // This terminal provider node can grow without changing connection paths.
    // Measure captions in SVG units so every locale can keep its full wording.
    const hostedWide = hostedDiagram.querySelector('.an-diagram__wide');
    const modelRect = hostedWide.querySelector('.an-diagram__node--model rect');
    const providerRect = hostedWide.querySelector('.an-diagram__provider-boundary');
    const providerLabel = [
        ...hostedWide.querySelectorAll('.an-diagram__label')
    ].at(-1);
    const modelCaptions = [
        ...modelRect.parentElement.querySelectorAll('text')
    ];
    const originalGeometry = {
        modelWidth: modelRect.width.baseVal.value,
        providerWidth: providerRect.width.baseVal.value,
        viewBox: hostedWide.getAttribute('viewBox').split(/\s+/).map(Number)
    };
    const alignCaption = (text, rectangle)=>{
        const shift = 2 * rectangle.x.baseVal.value + rectangle.width.baseVal.value - 2 * text.x.baseVal.getItem(0).value;
        text.style.setProperty('--an-diagram-text-shift', `${shift}px`);
    };
    const wideDiagram = window.matchMedia('(min-width: 40rem)');
    const fitHostedCaptions = ()=>{
        // Hidden diagrams need no layout measurement. Read caption lengths
        // together before applying the final geometry once.
        if (hostedDiagram.hidden || !wideDiagram.matches) return;
        const modelPadding = modelCaptions[0].x.baseVal.getItem(0).value - modelRect.x.baseVal.value;
        const labelPadding = providerLabel.x.baseVal.getItem(0).value - providerRect.x.baseVal.value;
        const captionWidth = Math.max(...modelCaptions.map((text)=>text.getComputedTextLength())) + 2 * modelPadding;
        const labelWidth = providerLabel.getComputedTextLength() + 2 * labelPadding;
        const expansion = Math.max(0, captionWidth - originalGeometry.modelWidth, labelWidth - originalGeometry.providerWidth);
        modelRect.setAttribute('width', originalGeometry.modelWidth + expansion);
        providerRect.setAttribute('width', originalGeometry.providerWidth + expansion);
        const viewBox = [
            ...originalGeometry.viewBox
        ];
        viewBox[2] += expansion;
        hostedWide.setAttribute('viewBox', viewBox.join(' '));
        modelCaptions.forEach((text)=>alignCaption(text, modelRect));
        alignCaption(providerLabel, providerRect);
    };
    let fitFrame = 0;
    const scheduleCaptionFit = ()=>{
        cancelAnimationFrame(fitFrame);
        fitFrame = requestAnimationFrame(fitHostedCaptions);
    };
    document.fonts.addEventListener('loadingdone', scheduleCaptionFit);
    window.addEventListener('resize', scheduleCaptionFit);
    const select = (tab, focus = false, immediate = false)=>{
        tabs.forEach((item)=>{
            const on = item === tab;
            item.setAttribute('aria-selected', String(on));
            item.tabIndex = on ? 0 : -1;
        });
        panel.setAttribute('aria-labelledby', tab.id);
        if (focus) tab.focus();
        const apply = ()=>{
            const translatedAttributes = JSON.parse(tab.dataset.i18nAttrs ?? '{}');
            Object.entries(targets).forEach(([key, nodes])=>nodes.forEach((node)=>{
                    node.textContent = translatedAttributes[`data-${key}`] ? (0, $53cebf01a6481b81$export$625550452a3fa3ec)(translatedAttributes[`data-${key}`]) : tab.dataset[key];
                }));
            const hosted = tab.dataset.mode === 'hosted';
            privateDiagram.hidden = hosted;
            hostedDiagram.hidden = !hosted;
            fitHostedCaptions();
            panel.classList.toggle('is-hosted', hosted);
            panel.classList.remove('is-swapping');
            window.dispatchEvent(new CustomEvent('an:deploymentchange'));
        };
        window.clearTimeout(swapTimer);
        if ($80eaaa1ee2ec9e35$var$reduceMotion.matches || immediate) {
            apply();
            return;
        }
        panel.classList.add('is-swapping');
        swapTimer = window.setTimeout(apply, 220);
    };
    tabs.forEach((tab, index)=>{
        tab.addEventListener('click', ()=>select(tab));
        tab.addEventListener('keydown', (event)=>{
            const step = (0, $bbd7d3d4b7c88c17$export$233ad4bf084bc0d2)(event.key, getComputedStyle(list).direction);
            let next = null;
            if (step) next = tabs[(index + step + tabs.length) % tabs.length];
            if (event.key === 'Home') next = tabs[0];
            if (event.key === 'End') next = tabs.at(-1);
            if (!next) return;
            event.preventDefault();
            select(next, true);
        });
    });
    window.addEventListener('an:languagechange', ()=>select(tabs.find((tab)=>tab.getAttribute('aria-selected') === 'true') ?? tabs[0], false, true));
}
// Process progress line -------------------------------------------------------
function $80eaaa1ee2ec9e35$var$initProcess() {
    const wrap = document.querySelector('[data-steps]');
    if (!wrap) return;
    const track = wrap.querySelector('.an-steps__track > span');
    const steps = [
        ...wrap.querySelectorAll('.an-step')
    ];
    let frame = 0;
    let visible = !('IntersectionObserver' in window);
    const update = ()=>{
        frame = 0;
        const box = wrap.getBoundingClientRect();
        const start = window.innerHeight * 0.85;
        const progress = Math.min(1, Math.max(0, (start - box.top) / (box.height + window.innerHeight * 0.25)));
        track?.style.setProperty('--p', progress.toFixed(3));
        steps.forEach((step, index)=>step.classList.toggle('is-on', progress >= index / steps.length + 0.02));
    };
    const request = ()=>{
        if (visible && !frame) frame = requestAnimationFrame(update);
    };
    window.addEventListener('scroll', request, {
        passive: true
    });
    window.addEventListener('resize', request);
    if ('IntersectionObserver' in window) new IntersectionObserver(([entry])=>{
        visible = entry.isIntersecting;
        if (visible) request();
        else {
            cancelAnimationFrame(frame);
            frame = 0;
        }
    }, {
        rootMargin: '0px 0px 20% 0px'
    }).observe(wrap);
    else request();
}
// Soft spotlight that follows the pointer across cards ---------------------------
function $80eaaa1ee2ec9e35$var$initSpotlights() {
    if ($80eaaa1ee2ec9e35$var$reduceMotion.matches) return;
    document.querySelectorAll('[data-spotlight]').forEach((card)=>{
        card.addEventListener('pointermove', (event)=>{
            const box = card.getBoundingClientRect();
            card.style.setProperty('--mx', `${event.clientX - box.left}px`);
            card.style.setProperty('--my', `${event.clientY - box.top}px`);
        });
    });
}
$80eaaa1ee2ec9e35$var$initAmbientMotion();
$80eaaa1ee2ec9e35$var$initReveal();
$80eaaa1ee2ec9e35$var$initHeroSpotlight();
$80eaaa1ee2ec9e35$var$initConsole();
$80eaaa1ee2ec9e35$var$initDeployment();
$80eaaa1ee2ec9e35$var$initProcess();
$80eaaa1ee2ec9e35$var$initSpotlights();




// Public guest endpoints only. No credentials belong in this configuration.
const $1243020a61e0d2a6$export$d184628c42f8b576 = Object.freeze({
    username: 'algorithmic.network',
    slug: 'get-in-touch',
    duration: 30,
    url: 'https://cal.com/algorithmic.network/get-in-touch'
});
class $1243020a61e0d2a6$export$5bcdc2832fd1bfb0 extends Error {
    constructor(kind, uncertain = false){
        super(kind);
        this.kind = kind;
        this.uncertain = uncertain;
    }
}
function $1243020a61e0d2a6$export$b77d6fb52904647d(date, timeZone) {
    const parts = new Intl.DateTimeFormat('en-US', {
        timeZone: timeZone,
        calendar: 'gregory',
        numberingSystem: 'latn',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
    }).formatToParts(date);
    const part = (type)=>parts.find((value)=>value.type === type).value;
    return `${part('year')}-${part('month')}-${part('day')}`;
}
function $1243020a61e0d2a6$export$5ba7dc3ae43cca8b(year, month, day = 1) {
    return new Date(Date.UTC(year, month, day, 12));
}
function $1243020a61e0d2a6$export$fbc33432e385d43a(date) {
    return date.toISOString().slice(0, 7);
}
function $1243020a61e0d2a6$export$f43810aaf0d479b0(value) {
    try {
        new Intl.DateTimeFormat('en', {
            timeZone: value
        }).format();
        return true;
    } catch  {
        return false;
    }
}
function $1243020a61e0d2a6$export$689e7793afc12c95(value) {
    try {
        const url = new URL(value);
        return url.protocol === 'https:' && [
            'cal.com',
            'app.cal.com'
        ].includes(url.hostname) && !url.port && !url.username && !url.password ? url.href : null;
    } catch  {
        return null;
    }
}
async function $1243020a61e0d2a6$var$request(path, { method: method = 'GET', body: body, signal: signal, fetcher: fetcher = fetch } = {}) {
    const controller = new AbortController(), abort = ()=>controller.abort();
    signal?.addEventListener('abort', abort, {
        once: true
    });
    if (signal?.aborted) abort();
    const timeout = setTimeout(abort, 25000), mutating = method === 'POST';
    try {
        const response = await fetcher(`https://api.cal.com${path}`, {
            method: method,
            credentials: 'omit',
            cache: 'no-store',
            signal: controller.signal,
            headers: {
                'cal-api-version': path.startsWith('/v2/slots') ? '2024-09-04' : '2026-02-25',
                ...body ? {
                    'Content-Type': 'application/json'
                } : {}
            },
            body: body ? JSON.stringify(body) : undefined
        });
        if (response.status === 429) throw new $1243020a61e0d2a6$export$5bcdc2832fd1bfb0('rateLimit');
        if (response.status >= 500) throw new $1243020a61e0d2a6$export$5bcdc2832fd1bfb0('failed', mutating);
        let result;
        try {
            result = await response.json();
        } catch  {
            throw new $1243020a61e0d2a6$export$5bcdc2832fd1bfb0('failed', mutating);
        }
        if (!response.ok || result.status !== 'success') {
            const message = result.error?.message ?? result.message ?? '';
            const conflict = response.status === 409 || /no available|not available|unavailable|already booked|already been booked/i.test(String(message));
            throw new $1243020a61e0d2a6$export$5bcdc2832fd1bfb0(conflict ? 'unavailable' : 'failed');
        }
        return result.data;
    } catch (error) {
        if (error instanceof $1243020a61e0d2a6$export$5bcdc2832fd1bfb0) throw error;
        if (signal?.aborted) throw new $1243020a61e0d2a6$export$5bcdc2832fd1bfb0('aborted');
        // A lost POST response may still be a confirmed booking. Never retry it.
        throw new $1243020a61e0d2a6$export$5bcdc2832fd1bfb0('failed', mutating);
    } finally{
        clearTimeout(timeout);
        signal?.removeEventListener('abort', abort);
    }
}
async function $1243020a61e0d2a6$export$cd583cc20c0a2dd8(month, timeZone, options = {}) {
    if (!$1243020a61e0d2a6$export$f43810aaf0d479b0(timeZone)) throw new $1243020a61e0d2a6$export$5bcdc2832fd1bfb0('timezone');
    const year = month.getUTCFullYear(), index = month.getUTCMonth();
    const query = new URLSearchParams({
        username: $1243020a61e0d2a6$export$d184628c42f8b576.username,
        eventTypeSlug: $1243020a61e0d2a6$export$d184628c42f8b576.slug,
        start: $1243020a61e0d2a6$export$5ba7dc3ae43cca8b(year, index, 0).toISOString().slice(0, 10),
        end: $1243020a61e0d2a6$export$5ba7dc3ae43cca8b(year, index + 1, 2).toISOString().slice(0, 10),
        timeZone: timeZone
    });
    const data = await $1243020a61e0d2a6$var$request(`/v2/slots?${query}`, options);
    if (!data || typeof data !== 'object' || Array.isArray(data)) throw new $1243020a61e0d2a6$export$5bcdc2832fd1bfb0('failed');
    const now = options.now ?? Date.now(), grouped = new Map(), unique = new Set();
    for (const list of Object.values(data)){
        if (!Array.isArray(list)) throw new $1243020a61e0d2a6$export$5bcdc2832fd1bfb0('failed');
        for (const slot of list){
            const instant = new Date(slot?.start);
            if (!Number.isFinite(+instant)) throw new $1243020a61e0d2a6$export$5bcdc2832fd1bfb0('failed');
            const start = instant.toISOString(), key = $1243020a61e0d2a6$export$b77d6fb52904647d(instant, timeZone);
            if (+instant <= now || !key.startsWith($1243020a61e0d2a6$export$fbc33432e385d43a(month)) || unique.has(start)) continue;
            unique.add(start);
            if (!grouped.has(key)) grouped.set(key, []);
            grouped.get(key).push(start);
        }
    }
    for (const slots of grouped.values())slots.sort();
    return grouped;
}
async function $1243020a61e0d2a6$export$3877e99530b0c773({ start: start, name: name, email: email, topic: topic, notes: notes = '', timeZone: timeZone, language: language }, options = {}) {
    if (!$1243020a61e0d2a6$export$f43810aaf0d479b0(timeZone) || !Number.isFinite(Date.parse(start)) || !name.trim() || !email.trim() || !topic.trim()) throw new $1243020a61e0d2a6$export$5bcdc2832fd1bfb0('failed');
    if (Date.parse(start) <= Date.now()) throw new $1243020a61e0d2a6$export$5bcdc2832fd1bfb0('unavailable');
    const data = await $1243020a61e0d2a6$var$request('/v2/bookings', {
        ...options,
        method: 'POST',
        body: {
            start: new Date(start).toISOString(),
            eventTypeSlug: $1243020a61e0d2a6$export$d184628c42f8b576.slug,
            username: $1243020a61e0d2a6$export$d184628c42f8b576.username,
            attendee: {
                name: name.trim(),
                email: email.trim(),
                timeZone: timeZone,
                language: language
            },
            bookingFieldsResponses: {
                title: topic.trim(),
                notes: notes.trim()
            }
        }
    });
    if (!data || typeof data.uid !== 'string' || !data.uid || Date.parse(data.start) !== Date.parse(start) || ![
        'accepted',
        'pending'
    ].includes(data.status)) throw new $1243020a61e0d2a6$export$5bcdc2832fd1bfb0('failed', true);
    return {
        uid: data.uid,
        status: data.status,
        start: data.start,
        end: data.end,
        meetingUrl: $1243020a61e0d2a6$export$689e7793afc12c95(data.meetingUrl || data.location)
    };
}


const $560a9521d5a4f58e$var$cityAliases = Object.freeze({
    'Asia/Calcutta': 'Kolkata',
    'Europe/Kiev': 'Kyiv'
});
const $560a9521d5a4f58e$var$normalize = (value)=>value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[_/]/g, ' ').trim();
function $560a9521d5a4f58e$export$83b7d32c1ffb9ac7(zones, referenceDate = new Date()) {
    return [
        ...new Set(zones)
    ].sort().map((value)=>{
        const offset = new Intl.DateTimeFormat('en-US', {
            timeZone: value,
            timeZoneName: 'longOffset'
        }).formatToParts(referenceDate).find((part)=>part.type === 'timeZoneName').value;
        return {
            value: value,
            label: value.replaceAll('_', ' '),
            offset: offset === 'GMT' ? 'UTC+00:00' : offset.replace('GMT', 'UTC'),
            alias: $560a9521d5a4f58e$var$cityAliases[value] ?? ''
        };
    });
}
function $560a9521d5a4f58e$export$b6b170125f41716d(options, query) {
    const search = $560a9521d5a4f58e$var$normalize(query), terms = search.split(/\s+/).filter(Boolean);
    const result = options.filter((option)=>terms.every((term)=>$560a9521d5a4f58e$var$normalize(`${option.value} ${option.label} ${option.offset} ${option.alias}`).includes(term)));
    // An exact IANA identifier stays ahead of matches in the UTC offset.
    return result.sort((a, b)=>Number($560a9521d5a4f58e$var$normalize(b.value) === search) - Number($560a9521d5a4f58e$var$normalize(a.value) === search));
}
function $560a9521d5a4f58e$export$d4961d7c66214e50(dialog, { zones: zones, initialValue: initialValue, referenceDate: referenceDate, onChange: onChange }) {
    const find = (name)=>dialog.querySelector(`[data-booking-timezone-${name}]`);
    const trigger = find('toggle'), current = find('current'), popup = find('popup'), search = find('search'), list = find('options'), empty = find('empty');
    const valueInput = dialog.querySelector('[data-booking-timezone]');
    let value = initialValue, options = [], matches = [], active = -1, referenceKey = '';
    valueInput.value = value;
    current.textContent = value.replaceAll('_', ' ');
    function position() {
        if (popup.hidden) return;
        const box = dialog.getBoundingClientRect(), field = trigger.getBoundingClientRect(), gap = 12;
        const width = Math.min(Math.max(field.width, 320), dialog.clientWidth - gap * 2);
        const left = Math.max(gap, Math.min(field.left - box.left, dialog.clientWidth - width - gap));
        const below = Math.max(0, dialog.clientHeight - (field.bottom - box.top) - gap * 2);
        const above = Math.max(0, field.top - box.top - gap * 2);
        const downward = below >= 200 || below >= above;
        const height = Math.min(352, Math.max(104, downward ? below : above), dialog.clientHeight - gap * 2);
        const top = Math.max(gap, Math.min(downward ? field.bottom - box.top + gap / 2 : field.top - box.top - height - gap / 2, dialog.clientHeight - height - gap));
        // These distances come from physical browser rectangles; the inline inset
        // converts them once to the popup's inherited writing direction.
        const start = getComputedStyle(dialog).direction === 'rtl' ? dialog.clientWidth - left - width : left;
        popup.style.insetInlineStart = `${start}px`;
        popup.style.insetBlockStart = `${top}px`;
        popup.style.inlineSize = `${width}px`;
        popup.style.blockSize = `${height}px`;
    }
    function highlight(index, scroll = true) {
        active = index;
        for (const [number, option] of [
            ...list.children
        ].entries()){
            option.dataset.active = String(number === active);
            option.setAttribute('aria-selected', String(number === active));
        }
        const option = list.children[active];
        if (option) {
            search.setAttribute('aria-activedescendant', option.id);
            if (scroll) option.scrollIntoView({
                block: 'nearest'
            });
        } else search.removeAttribute('aria-activedescendant');
    }
    function render(query = '', selected = false) {
        matches = $560a9521d5a4f58e$export$b6b170125f41716d(options, query);
        const fragment = document.createDocumentFragment();
        for (const [index, entry] of matches.entries()){
            const option = document.createElement('div');
            option.setAttribute('role', 'option');
            option.id = `booking-timezone-option-${index}`;
            option.dataset.zone = entry.value;
            const label = document.createElement('bdi');
            label.dir = 'ltr';
            label.textContent = entry.label;
            const offset = document.createElement('bdi');
            offset.dir = 'ltr';
            offset.className = 'an-booking__timezone-offset';
            offset.textContent = entry.offset;
            option.append(label, offset);
            fragment.append(option);
        }
        list.replaceChildren(fragment);
        empty.hidden = !!matches.length;
        list.hidden = !matches.length;
        highlight(selected ? matches.findIndex((entry)=>entry.value === value) : -1, false);
    }
    function open() {
        const date = referenceDate(), key = date.toISOString().slice(0, 10);
        if (key !== referenceKey) {
            options = $560a9521d5a4f58e$export$83b7d32c1ffb9ac7(zones, date);
            referenceKey = key;
        }
        popup.hidden = false;
        trigger.setAttribute('aria-expanded', 'true');
        search.setAttribute('aria-expanded', 'true');
        search.value = '';
        render('', true);
        position();
        search.focus({
            preventScroll: true
        });
        highlight(active);
    }
    function close({ focus: focus = false } = {}) {
        popup.hidden = true;
        trigger.setAttribute('aria-expanded', 'false');
        search.setAttribute('aria-expanded', 'false');
        search.removeAttribute('aria-activedescendant');
        if (focus && dialog.open) trigger.focus({
            preventScroll: true
        });
    }
    function choose(entry) {
        if (!entry) return;
        const changed = value !== entry.value;
        value = entry.value;
        valueInput.value = value;
        current.textContent = entry.label;
        close({
            focus: true
        });
        if (changed) onChange(value);
    }
    trigger.addEventListener('click', ()=>popup.hidden ? open() : close({
            focus: true
        }));
    trigger.addEventListener('keydown', (event)=>{
        if ([
            'ArrowDown',
            'ArrowUp'
        ].includes(event.key)) {
            event.preventDefault();
            open();
        }
    });
    search.addEventListener('input', ()=>{
        render(search.value);
        list.scrollTop = 0;
    });
    search.addEventListener('keydown', (event)=>{
        if (event.key === 'Escape') {
            event.preventDefault();
            event.stopPropagation();
            close({
                focus: true
            });
        } else if (event.key === 'Enter') {
            event.preventDefault();
            choose(matches[active] ?? (matches.length === 1 ? matches[0] : null));
        } else if ([
            'ArrowDown',
            'ArrowUp'
        ].includes(event.key)) {
            event.preventDefault();
            if (matches.length) highlight(active < 0 ? event.key === 'ArrowDown' ? 0 : matches.length - 1 : Math.max(0, Math.min(matches.length - 1, active + (event.key === 'ArrowDown' ? 1 : -1))));
        }
    });
    // Option focus stays on the search combobox, including mouse/touch selection.
    list.addEventListener('mousedown', (event)=>{
        if (event.target.closest('[data-zone]')) event.preventDefault();
    });
    list.addEventListener('click', (event)=>{
        const option = event.target.closest('[data-zone]');
        if (option) choose(matches.find((entry)=>entry.value === option.dataset.zone));
    });
    document.addEventListener('pointerdown', (event)=>{
        if (!popup.hidden && !popup.contains(event.target) && !trigger.contains(event.target)) close();
    });
    dialog.addEventListener('focusin', (event)=>{
        if (!popup.hidden && !popup.contains(event.target) && !trigger.contains(event.target)) close();
    });
    dialog.addEventListener('cancel', (event)=>{
        if (!popup.hidden) {
            event.preventDefault();
            close({
                focus: true
            });
        }
    });
    dialog.querySelector('.an-booking__schedule-body').addEventListener('scroll', position, {
        passive: true
    });
    return Object.freeze({
        close: close,
        position: position,
        get isOpen () {
            return !popup.hidden;
        }
    });
}


const $1fd606f3f999340c$var$dialog = document.querySelector('[data-booking-dialog]');
if ($1fd606f3f999340c$var$dialog && typeof $1fd606f3f999340c$var$dialog.showModal === 'function') $1fd606f3f999340c$var$initBooking($1fd606f3f999340c$var$dialog);
function $1fd606f3f999340c$var$initBooking(dialog) {
    const find = (name)=>dialog.querySelector(`[data-booking-${name}]`);
    const form = find('form'), calendar = find('calendar'), times = find('times');
    // Native validity is retained, with messages in the site language rather than
    // the browser's potentially different language.
    form.noValidate = true;
    const field = (name)=>form.elements.namedItem(name);
    const consent = field('terms');
    consent.checked = false;
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC';
    const zones = [
        ...new Set([
            timeZone,
            'UTC',
            ...Intl.supportedValuesOf?.('timeZone') ?? []
        ])
    ].sort();
    const state = {
        zone: timeZone,
        month: currentMonth(timeZone),
        day: null,
        start: null,
        slots: new Map(),
        loading: false,
        loadError: null,
        submitError: null,
        controller: null,
        submitting: false,
        uncertain: false,
        confirmed: false,
        topic: 'consultation',
        trigger: null,
        step: 'schedule'
    };
    function updateSubmit() {
        find('submit').disabled = state.submitting || state.uncertain || !state.start || !consent.checked;
    }
    const timezonePicker = (0, $560a9521d5a4f58e$export$d4961d7c66214e50)(dialog, {
        zones: zones,
        initialValue: timeZone,
        referenceDate: ()=>state.day ? new Date(`${state.day}T12:00:00Z`) : state.month,
        onChange: (value)=>{
            state.zone = value;
            state.month = currentMonth(value);
            state.day = null;
            loadSlots();
        }
    });
    let viewportFrame = null, viewportHeight = 0;
    function updateViewport() {
        viewportFrame = null;
        if (!dialog.open) return;
        // iOS keyboards shrink/pan the visual viewport without resizing 100dvh.
        // Center against that visible area while retaining the usual desktop size.
        const height = window.visualViewport?.height ?? window.innerHeight;
        dialog.style.setProperty('--booking-viewport-height', `${height}px`);
        dialog.style.setProperty('--booking-viewport-top', `${window.visualViewport?.offsetTop ?? 0}px`);
        const focused = document.activeElement;
        if (height < viewportHeight && form.contains(focused) && focused.matches('input,textarea')) focused.scrollIntoView({
            block: 'nearest'
        });
        timezonePicker.position();
        viewportHeight = height;
    }
    function queueViewportUpdate() {
        if (dialog.open && viewportFrame === null) viewportFrame = requestAnimationFrame(updateViewport);
    }
    window.visualViewport?.addEventListener('resize', queueViewportUpdate, {
        passive: true
    });
    window.visualViewport?.addEventListener('scroll', queueViewportUpdate, {
        passive: true
    });
    window.addEventListener('resize', queueViewportUpdate, {
        passive: true
    });
    function currentMonth(timeZone) {
        const [year, month] = (0, $1243020a61e0d2a6$export$b77d6fb52904647d)(new Date(), timeZone).split('-').map(Number);
        return (0, $1243020a61e0d2a6$export$5ba7dc3ae43cca8b)(year, month - 1);
    }
    function displayDate(key) {
        return (0, $53cebf01a6481b81$export$3ae94a2503e890a1)(new Date(`${key}T12:00:00Z`), {
            dateStyle: 'long',
            timeZone: 'UTC',
            calendar: 'gregory'
        });
    }
    function displayTime(start) {
        return (0, $53cebf01a6481b81$export$3ae94a2503e890a1)(new Date(start), {
            timeStyle: 'short',
            timeZone: state.zone
        });
    }
    function selection() {
        if (!state.start) return (0, $53cebf01a6481b81$export$625550452a3fa3ec)('booking.selectPrompt');
        return (0, $53cebf01a6481b81$export$625550452a3fa3ec)('booking.selection', {
            date: displayDate((0, $1243020a61e0d2a6$export$b77d6fb52904647d)(new Date(state.start), state.zone)),
            time: displayTime(state.start),
            zone: state.zone
        });
    }
    function status(element, message, error = false) {
        element.textContent = message;
        element.dataset.error = String(error);
    }
    function setStep(step) {
        state.step = step;
        timezonePicker.close();
        for (const name of [
            'schedule',
            'details',
            'success'
        ])find(name).hidden = name !== step;
        dialog.querySelectorAll('[data-booking-scroll]').forEach((element)=>{
            element.scrollTop = 0;
        });
        find('success').scrollTop = 0;
    }
    function renderSummary() {
        find('duration').textContent = (0, $53cebf01a6481b81$export$625550452a3fa3ec)('booking.duration', {
            minutes: (0, $53cebf01a6481b81$export$f5dd818bff069720)((0, $1243020a61e0d2a6$export$d184628c42f8b576).duration)
        });
        find('summary').textContent = selection();
        find('detail-summary').textContent = selection();
        find('confirmed-time').textContent = selection();
    }
    function renderCalendar() {
        const year = state.month.getUTCFullYear(), month = state.month.getUTCMonth();
        find('month').textContent = (0, $53cebf01a6481b81$export$3ae94a2503e890a1)(state.month, {
            month: 'long',
            year: 'numeric',
            timeZone: 'UTC',
            calendar: 'gregory'
        });
        find('previous').disabled = (0, $1243020a61e0d2a6$export$fbc33432e385d43a)(state.month) <= (0, $1243020a61e0d2a6$export$fbc33432e385d43a)(currentMonth(state.zone));
        const locale = new Intl.Locale((0, $53cebf01a6481b81$export$180605366c04f0cd)());
        const firstDay = (locale.getWeekInfo?.() ?? locale.weekInfo)?.firstDay ?? 1;
        const firstWeekday = firstDay % 7;
        const fragment = document.createDocumentFragment();
        for(let index = 0; index < 7; index++){
            const day = document.createElement('span');
            day.className = 'an-booking__weekday';
            day.setAttribute('aria-hidden', 'true');
            const weekday = (0, $1243020a61e0d2a6$export$5ba7dc3ae43cca8b)(2023, 0, 1 + (firstWeekday + index) % 7);
            day.textContent = (0, $53cebf01a6481b81$export$3ae94a2503e890a1)(weekday, {
                weekday: calendar.clientWidth < 350 ? 'narrow' : 'short',
                timeZone: 'UTC',
                calendar: 'gregory'
            });
            day.title = (0, $53cebf01a6481b81$export$3ae94a2503e890a1)(weekday, {
                weekday: 'long',
                timeZone: 'UTC',
                calendar: 'gregory'
            });
            fragment.append(day);
        }
        const offset = ((0, $1243020a61e0d2a6$export$5ba7dc3ae43cca8b)(year, month).getUTCDay() - firstWeekday + 7) % 7;
        for(let index = 0; index < offset; index++){
            const blank = document.createElement('span');
            blank.setAttribute('aria-hidden', 'true');
            fragment.append(blank);
        }
        const lastDay = (0, $1243020a61e0d2a6$export$5ba7dc3ae43cca8b)(year, month + 1, 0).getUTCDate(), today = (0, $1243020a61e0d2a6$export$b77d6fb52904647d)(new Date(), state.zone);
        for(let day = 1; day <= lastDay; day++){
            const key = (0, $1243020a61e0d2a6$export$5ba7dc3ae43cca8b)(year, month, day).toISOString().slice(0, 10), count = state.slots.get(key)?.length ?? 0;
            const button = document.createElement('button');
            button.type = 'button';
            button.className = 'an-booking__date';
            button.dataset.date = key;
            button.textContent = (0, $53cebf01a6481b81$export$f5dd818bff069720)(day, {
                useGrouping: false
            });
            button.disabled = state.loading || !count;
            button.setAttribute('aria-label', (0, $53cebf01a6481b81$export$625550452a3fa3ec)('booking.dayLabel', {
                date: displayDate(key),
                count: count
            }));
            button.setAttribute('aria-pressed', String(state.day === key));
            button.tabIndex = state.day === key ? 0 : -1;
            if (key === today) button.setAttribute('aria-current', 'date');
            fragment.append(button);
        }
        for(let index = offset + lastDay; index < 42; index++){
            const blank = document.createElement('span');
            blank.setAttribute('aria-hidden', 'true');
            fragment.append(blank);
        }
        calendar.replaceChildren(fragment);
        if (!calendar.querySelector('button[tabindex="0"]:enabled')) calendar.querySelector('button:enabled')?.setAttribute('tabindex', '0');
        calendar.setAttribute('aria-busy', String(state.loading));
    }
    function renderTimes() {
        const panel = find('times-panel'), skeleton = find('skeleton');
        // Keep the phone's single scrolling surface steady when a request or a
        // shorter slot list replaces the previous one. Desktop slots scroll inside
        // their own fixed pane and do not use this minimum size.
        const phone = window.matchMedia('(max-width: 47.99rem)').matches;
        let reservedSize = phone ? Math.max(parseFloat(panel.style.getPropertyValue('--booking-times-size')) || 0, panel.getBoundingClientRect().height) : 0;
        const placeholderCount = Math.max(16, times.children.length);
        const slots = state.slots.get(state.day) ?? [];
        find('day').textContent = state.day ? displayDate(state.day) : find('month').textContent;
        times.replaceChildren(...slots.map((start)=>{
            const button = document.createElement('button');
            button.type = 'button';
            button.className = 'an-booking__time';
            button.dataset.start = start;
            button.textContent = displayTime(start);
            button.setAttribute('aria-pressed', String(state.start === start));
            return button;
        }));
        times.hidden = state.loading;
        skeleton.hidden = !state.loading;
        if (state.loading) skeleton.replaceChildren(...Array.from({
            length: placeholderCount
        }, ()=>document.createElement('span')));
        find('slots-panel').setAttribute('aria-busy', String(state.loading));
        if (phone) reservedSize = Math.max(reservedSize, panel.getBoundingClientRect().height);
        panel.style.setProperty('--booking-times-size', `${reservedSize}px`);
        find('continue').disabled = !state.start || state.loading;
        renderSummary();
    }
    function renderLoadStatus() {
        const message = state.loading ? (0, $53cebf01a6481b81$export$625550452a3fa3ec)('booking.loading') : state.loadError ? (0, $53cebf01a6481b81$export$625550452a3fa3ec)(state.loadError === 'rateLimit' ? 'booking.rateLimit' : 'booking.loadFailed') : state.slots.size ? (0, $53cebf01a6481b81$export$625550452a3fa3ec)('booking.chooseTime') : (0, $53cebf01a6481b81$export$625550452a3fa3ec)('booking.noSlots');
        status(find('load-status'), message, !!state.loadError);
        find('retry').hidden = !state.loadError;
    }
    async function loadSlots() {
        state.controller?.abort();
        const controller = new AbortController();
        state.controller = controller;
        state.loading = true;
        state.loadError = null;
        state.slots = new Map();
        state.start = null;
        renderCalendar();
        renderTimes();
        renderLoadStatus();
        try {
            const slots = await (0, $1243020a61e0d2a6$export$cd583cc20c0a2dd8)(state.month, state.zone, {
                signal: controller.signal
            });
            if (controller !== state.controller || !dialog.open) return;
            state.slots = slots;
            if (!slots.has(state.day)) state.day = [
                ...slots.keys()
            ].sort()[0] ?? null;
        } catch (error) {
            if (controller !== state.controller || error.kind === 'aborted') return;
            state.loadError = error.kind;
        } finally{
            if (controller === state.controller && dialog.open) {
                state.loading = false;
                renderCalendar();
                renderTimes();
                renderLoadStatus();
            }
        }
    }
    function close() {
        dialog.close();
    }
    function open(trigger) {
        state.trigger = trigger;
        if ((0, $1243020a61e0d2a6$export$fbc33432e385d43a)(state.month) < (0, $1243020a61e0d2a6$export$fbc33432e385d43a)(currentMonth(state.zone))) {
            state.month = currentMonth(state.zone);
            state.day = null;
        }
        state.topic = trigger.dataset.bookingTopic ?? 'consultation';
        if (![
            'consultation',
            'review',
            'planning'
        ].includes(state.topic)) state.topic = 'consultation';
        if (state.confirmed) {
            form.reset();
            state.confirmed = false;
            state.start = null;
            state.submitError = null;
        }
        if (!field('topic').value || field('topic').value === state.defaultTopic) field('topic').value = (0, $53cebf01a6481b81$export$625550452a3fa3ec)(`booking.topic.${state.topic}`);
        state.defaultTopic = (0, $53cebf01a6481b81$export$625550452a3fa3ec)(`booking.topic.${state.topic}`);
        dialog.showModal();
        document.documentElement.classList.add('an-booking-open');
        updateViewport();
        renderSummary();
        if (state.submitting || state.uncertain) {
            setStep('details');
            status(find('submit-status'), (0, $53cebf01a6481b81$export$625550452a3fa3ec)(state.uncertain ? 'booking.uncertain' : 'booking.submitting'), state.uncertain);
            find('submit').disabled = true;
            find('back').disabled = true;
        } else {
            setStep('schedule');
            loadSlots();
        }
        dialog.querySelector('#booking-heading').focus({
            preventScroll: true
        });
    }
    document.querySelectorAll('[data-cal-link]').forEach((trigger)=>{
        trigger.setAttribute('aria-haspopup', 'dialog');
        trigger.addEventListener('click', (event)=>{
            event.preventDefault();
            if (!dialog.open) open(trigger);
        });
    });
    dialog.querySelectorAll('[data-booking-close]').forEach((button)=>button.addEventListener('click', close));
    dialog.addEventListener('close', ()=>{
        timezonePicker.close();
        state.controller?.abort();
        if (viewportFrame !== null) cancelAnimationFrame(viewportFrame);
        viewportFrame = null;
        viewportHeight = 0;
        document.documentElement.classList.remove('an-booking-open');
        state.trigger?.focus({
            preventScroll: true
        });
    });
    dialog.addEventListener('click', (event)=>{
        if (event.target !== dialog) return;
        const box = dialog.getBoundingClientRect();
        if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) close();
    });
    calendar.addEventListener('click', (event)=>{
        const button = event.target.closest('[data-date]');
        if (!button || button.disabled) return;
        state.day = button.dataset.date;
        state.start = null;
        renderCalendar();
        renderTimes();
        calendar.querySelector(`[data-date="${state.day}"]`)?.focus({
            preventScroll: true
        });
    });
    calendar.addEventListener('keydown', (event)=>{
        if (!event.target.matches('[data-date]') || ![
            'ArrowLeft',
            'ArrowRight',
            'ArrowUp',
            'ArrowDown',
            'Home',
            'End'
        ].includes(event.key)) return;
        event.preventDefault();
        const buttons = [
            ...calendar.querySelectorAll('button')
        ];
        let index = buttons.indexOf(event.target);
        const direction = document.documentElement.dir;
        let step = event.key === 'ArrowUp' ? -7 : event.key === 'ArrowDown' ? 7 : (0, $bbd7d3d4b7c88c17$export$233ad4bf084bc0d2)(event.key, direction);
        if (event.key === 'Home' || event.key === 'End') {
            index = event.key === 'Home' ? 0 : buttons.length - 1;
            step = event.key === 'Home' ? 1 : -1;
        } else index += step;
        while(index >= 0 && index < buttons.length && buttons[index].disabled)index += step;
        if (buttons[index] && !buttons[index].disabled) {
            buttons.forEach((button)=>{
                button.tabIndex = -1;
            });
            buttons[index].tabIndex = 0;
            buttons[index].focus();
        }
    });
    times.addEventListener('click', (event)=>{
        const button = event.target.closest('[data-start]');
        if (!button || button.disabled || state.loading) return;
        state.start = button.dataset.start;
        renderTimes();
        times.querySelector(`[data-start="${state.start}"]`)?.focus({
            preventScroll: true
        });
    });
    for (const [name, offset] of [
        [
            'previous',
            -1
        ],
        [
            'next',
            1
        ]
    ])find(name).addEventListener('click', ()=>{
        state.month = (0, $1243020a61e0d2a6$export$5ba7dc3ae43cca8b)(state.month.getUTCFullYear(), state.month.getUTCMonth() + offset);
        state.day = null;
        loadSlots();
    });
    find('retry').addEventListener('click', loadSlots);
    find('continue').addEventListener('click', ()=>{
        if (!state.start) return;
        updateSubmit();
        find('back').disabled = state.submitting || state.uncertain;
        setStep('details');
        status(find('submit-status'), state.submitError ? (0, $53cebf01a6481b81$export$625550452a3fa3ec)(`booking.${state.submitError}`) : '', !!state.submitError);
        dialog.querySelector('#booking-details-heading').focus({
            preventScroll: true
        });
    });
    find('back').addEventListener('click', ()=>{
        state.submitError = null;
        setStep('schedule');
        loadSlots();
    });
    form.addEventListener('submit', async (event)=>{
        event.preventDefault();
        if (state.submitting || state.uncertain || !state.start) return;
        consent.setCustomValidity(consent.checked ? '' : (0, $53cebf01a6481b81$export$625550452a3fa3ec)('booking.termsRequired'));
        for (const name of [
            'name',
            'email',
            'topic'
        ]){
            const input = field(name);
            input.setCustomValidity('');
            if (!input.value.trim()) input.setCustomValidity((0, $53cebf01a6481b81$export$625550452a3fa3ec)('booking.required'));
            else if (input.validity.typeMismatch) input.setCustomValidity((0, $53cebf01a6481b81$export$625550452a3fa3ec)('booking.emailInvalid'));
        }
        if (!form.reportValidity()) return;
        // Dismiss a phone keyboard after valid submission so feedback has the full
        // viewport. Native invalid-field focus/validation remains unchanged.
        if (form.contains(document.activeElement) && document.activeElement.matches('input,textarea')) document.activeElement.blur();
        state.submitting = true;
        state.submitError = null;
        find('submit').disabled = true;
        find('back').disabled = true;
        form.setAttribute('aria-busy', 'true');
        status(find('submit-status'), (0, $53cebf01a6481b81$export$625550452a3fa3ec)('booking.submitting'));
        try {
            const booking = await (0, $1243020a61e0d2a6$export$3877e99530b0c773)({
                start: state.start,
                name: field('name').value,
                email: field('email').value,
                topic: field('topic').value,
                notes: field('notes').value,
                timeZone: state.zone,
                language: (0, $53cebf01a6481b81$export$180605366c04f0cd)()
            });
            state.confirmed = true;
            const pending = booking.status === 'pending';
            state.bookingStatus = booking.status;
            find('success-title').textContent = (0, $53cebf01a6481b81$export$625550452a3fa3ec)(pending ? 'booking.pendingTitle' : 'booking.successTitle');
            find('success-copy').textContent = (0, $53cebf01a6481b81$export$625550452a3fa3ec)(pending ? 'booking.pendingCopy' : 'booking.successCopy');
            const link = find('meeting');
            link.hidden = !booking.meetingUrl || pending;
            link.href = booking.meetingUrl || find('fallback').href;
            setStep('success');
            renderSummary();
            if (dialog.open) dialog.querySelector('#booking-success-heading').focus({
                preventScroll: true
            });
        } catch (error) {
            state.uncertain = !!error.uncertain;
            state.submitError = state.uncertain ? 'uncertain' : error.kind === 'unavailable' ? 'unavailable' : error.kind === 'rateLimit' ? 'rateLimit' : 'bookingFailed';
            status(find('submit-status'), (0, $53cebf01a6481b81$export$625550452a3fa3ec)(`booking.${state.submitError}`), true);
            if (error.kind === 'unavailable') {
                state.start = null;
                renderSummary();
            }
        } finally{
            state.submitting = false;
            form.setAttribute('aria-busy', 'false');
            updateSubmit();
            find('back').disabled = state.uncertain;
        }
    });
    for (const name of [
        'name',
        'email',
        'topic'
    ])field(name).addEventListener('input', ()=>field(name).setCustomValidity(''));
    consent.addEventListener('change', ()=>{
        consent.setCustomValidity('');
        updateSubmit();
    });
    window.addEventListener('an:languagechange', ()=>{
        if (!dialog.open) return;
        renderSummary();
        renderCalendar();
        renderTimes();
        renderLoadStatus();
        if (state.submitError) status(find('submit-status'), (0, $53cebf01a6481b81$export$625550452a3fa3ec)(`booking.${state.submitError}`), true);
        if (state.submitting) status(find('submit-status'), (0, $53cebf01a6481b81$export$625550452a3fa3ec)('booking.submitting'));
        if (field('topic').value === state.defaultTopic) field('topic').value = (0, $53cebf01a6481b81$export$625550452a3fa3ec)(`booking.topic.${state.topic}`);
        state.defaultTopic = (0, $53cebf01a6481b81$export$625550452a3fa3ec)(`booking.topic.${state.topic}`);
        if (state.confirmed) {
            const pending = state.bookingStatus === 'pending';
            find('success-title').textContent = (0, $53cebf01a6481b81$export$625550452a3fa3ec)(pending ? 'booking.pendingTitle' : 'booking.successTitle');
            find('success-copy').textContent = (0, $53cebf01a6481b81$export$625550452a3fa3ec)(pending ? 'booking.pendingCopy' : 'booking.successCopy');
        }
        timezonePicker.position();
    });
}




//# sourceMappingURL=algorithmic.network.6f5406c8.js.map
